var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { isEqual } from 'lodash';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '../../../../../node_modules/@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { ApiUrlConstants } from '../../../common/constants/api.constants';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { Permission } from '../../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../../common/pipes/currency-format.pipe';
import { TitleCasePipe } from '../../../common/pipes/title-case.pipe';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../../shared/constants/common.constants';
import { CacheService } from '../../../shared/services/cache.service';
import { CommonService } from '../../../shared/services/common.service';
import { MemberDisplayPriceConfigService } from '../../../shared/services/member-display-price-config.service';
import { MessageService } from '../../../shared/services/message.service';
import { CustomValidators } from '../../../shared/Utils/custom-validator';
import { Utils } from '../../../shared/Utils/utils';
import { Constants, DelivaryOptionType, IsoCodeThree, MemberType, ProductSource } from '../../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, PurchaseFlow, PromotionOrderType } from '../../common/enumerations';
import { DateConstants } from '../../constants/date.constants';
import { MemberTypeId } from '../../constants/member-type-id.enum';
import { PaymentMethodTypeConstants } from '../../constants/payment-method-types.constants';
import { PaymentConstants } from '../../constants/payment.constants';
import { PhoneCodesConstants } from '../../constants/phone-codes.constant';
import { PortalDisplayPage } from '../../constants/portal-display-page.enum';
import { Translations } from '../../constants/translations.constants';
import { EcheckPhoneNumberValidation } from '../../directive/echeck-phone-validation';
import { CartTypes } from '../../enums/cart-type.enum';
import { AccountType } from '../../enums/echeck-accounttypes.enum';
import { EcheckPortalTypes } from '../../enums/echeck-portal-types.enum';
import { ImageType } from '../../enums/image-type.enum';
import { MemberOrderType } from '../../enums/member-order-type.enum';
import { MemberTypeEnum } from '../../enums/member-type.enum';
import { MessageTypeEnum } from '../../enums/message-type.enums';
import { NotificationType } from '../../enums/notification-types.enum';
import { AddressType, OrderSourceType, OrderStatus, OrderStatus as OrderStatusEnums, PaymentMethodTypes, PaymentStatusId, PaymentType, PriceType, ProductWeightMetric, PurchaseFlows, PurchaseFlowType, ShippingOrderType, ShippingType, Source } from '../../enums/order-source-type';
import { OrderSourceValue } from '../../enums/order-source.enum';
import { PaymentCardTypes } from '../../enums/payment-card-types.enum';
import { PriceTier } from '../../enums/price-tier.enum';
import { ProductMetatDataValue } from '../../enums/product-metadata.enum';
import { SelectEnum } from '../../enums/selection.enum';
import { ShippingMemberTitle } from '../../enums/shipping-member-title.enum';
import { ShippingMemberType } from '../../enums/shipping-member-type.enum';
import { ValueType } from '../../enums/value-type.enum';
import { TaxType } from '../../interface/tax-type.interface';
import { DeleteModal } from '../../models/delete-modal';
import { PaymentComponentSettings } from '../../models/payments/payment.model';
import { AchService } from '../../services/ach.service';
import { AppConfigService } from '../../services/app-config.service';
import { CheckoutConfigService } from '../../services/checkout-config.service';
import { CustomerService } from '../../services/customer.service';
import { EcheckService } from '../../services/echeck.service';
import { OrderMapperService } from '../../services/order-mapper.service';
import { OrderService } from '../../services/order.service';
import { PayvisionService } from '../../services/payvision.service';
import { AddressService } from '../../services/address.service';
import { CustomValidator } from '../customvalidation.component';
import { EnrollmentCommonService } from '../../../shared/services/enrollment-common.service';
import { EnrollService } from '../../services/enrollment.service';
import { PaymentModeConstants } from '../../constants/payment-mode.constants';
import { CustomerServiceConstants } from '../../../common/constants/customer-service.constants';
import { StoreMetaDataConstants } from '../../constants/store-metadata.constants';
import { ShippingAddressInfoConfigService } from '../../services/shipping-config.service';
import { MemberMetaDataEnum } from '../../enums/member-meta-data.enum';
import { ConfigurationService } from '../../services/configuration.service';
import { BonusConstants } from '../../constants/bonus-status.constants';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
import { BankWireTransferConstants } from '../../constants/bank-wire-transfer-configuration.constants';
import { OrderLineItemTypeEnum } from '../../../shared/enums/order-lineitem-type.enum';
var OrderEditComponent = /** @class */ (function () {
    function OrderEditComponent(messageService, _orderservice, _commonService, _translatePipe, _orderService, _echeckService, _sanitizer, _formbuilder, _http, router, _currencyPipe, _cacheService, _customerService, _payvisionService, _orderMapperService, _titleCase, _appConfigService, _maskPipe, _translateService, _memberDisplayPriceConfigService, _checkoutConfigService, _configurationService, _achService, _enrollmentCommonService, _enrollService, _shippingAddressInfoConfigService, _addressService) {
        var _this = this;
        this.messageService = messageService;
        this._orderservice = _orderservice;
        this._commonService = _commonService;
        this._translatePipe = _translatePipe;
        this._orderService = _orderService;
        this._echeckService = _echeckService;
        this._sanitizer = _sanitizer;
        this._formbuilder = _formbuilder;
        this._http = _http;
        this.router = router;
        this._currencyPipe = _currencyPipe;
        this._cacheService = _cacheService;
        this._customerService = _customerService;
        this._payvisionService = _payvisionService;
        this._orderMapperService = _orderMapperService;
        this._titleCase = _titleCase;
        this._appConfigService = _appConfigService;
        this._maskPipe = _maskPipe;
        this._translateService = _translateService;
        this._memberDisplayPriceConfigService = _memberDisplayPriceConfigService;
        this._checkoutConfigService = _checkoutConfigService;
        this._configurationService = _configurationService;
        this._achService = _achService;
        this._enrollmentCommonService = _enrollmentCommonService;
        this._enrollService = _enrollService;
        this._shippingAddressInfoConfigService = _shippingAddressInfoConfigService;
        this._addressService = _addressService;
        this.momentConstructor = moment.default || moment;
        this.orderStatuses = [];
        this.showAddressFormValidations = false;
        this.deliveryPreference = DeliveryPreference;
        this.items = [];
        this.countries = [];
        this.states = [];
        this.memberAddressDetails = [];
        this.memberShippingDetails = [];
        this.displayUserName = false;
        this.shipMethodValidation = '';
        this.subTotal = 0.0;
        this.retailSubTotal = 0.0;
        this.total = 0.0;
        this.totalCommissionableVolume = 0;
        this.selectedIsoCountryCode = '';
        this.selectedCountryCodeTwo = '';
        this.shippingMethods = [];
        this.isPaymentWithSavedCard = false;
        this.products = [];
        this.orderSubmitted = false;
        this.statesByCountry = [];
        this.taxableAmount = 0;
        this.moneyOrderAmount = 0;
        this.shippingCost = 0;
        this.importFeeEnabled = false;
        this.orginalShippingCost = 0;
        this.shipMethod = {};
        this.showSelectedShipMethod = false;
        this.languageCode = 'en-US';
        this.languageShortCode = 'en';
        this.disableDelivery = false;
        this.pollCount = 0;
        this.maxPollCount = 15;
        this.importFeeValue = 0;
        this.selectEnum = SelectEnum;
        this.isUpdated = false;
        this.isOrderedTax = true;
        this.disableUpdateQuanitity = [];
        this.promotionIds = [];
        this.paymentStatusEnum = PaymentStatusId;
        this.showDropShipPersonAddressForm = false;
        this.selectedPudoCollectionPoint = null;
        this.dropLoactionSelected = false;
        this.cityList = [];
        this.paymentMethodTypes = PaymentMethodTypes;
        this.imageTypes = ImageType;
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.orderSession = {};
        this.orderType = OrderType;
        this.IsoCountryCode = IsoCodeThree;
        this.memberTypeEnums = MemberTypeEnum;
        this.paymentMethodTypeConstants = PaymentMethodTypeConstants;
        this.backDateOrderPermission = false;
        this.enableBackDateOrder = false;
        this.isReviewWindow = false;
        this.isOrderBackdated = false;
        this.isPaymentChanged = false;
        this.isNewCard = false;
        this.showShippingAddress = true;
        this.orderStatusId = OrderStatusEnums;
        this.stores = [];
        this.paymentTypeEnum = PaymentType;
        this.defaultCurrency = CommonConstant.Default_Currency;
        this.existingItemCount = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        this.shippingTax = 0;
        this.bankDetailsList = [];
        this.taxType = TaxType;
        this.addressSearchResult = [];
        this.promotionModels = [];
        this.changeOrderStatus = CustomerServiceConstants.ORDER__SHIPPED_STATUS;
        this.validateEnteredAmount = true;
        this.isMoneyOrderAmountUpdate = false;
        this.translateOptions = {
            translateText: "checkout.Forever Living Products {{countryName}} GmbH",
            translateParams: { countryName: '' }
        };
        this.deliveryPreferenceType = this.deliveryPreference.DELIVERY;
        this.productAssociationInfo = [];
        this.ServiceOrderPermissions = [
            Permission.REPLACEMENT_ORDER_CREATE,
            Permission.REPLACEMENT_ORDER_MANAGE,
            Permission.REPLACEMENT_ORDER_CANCEL
        ];
        this.orderLevelDiscount = 0;
        this.isBWPEnabledProduct = false;
        this.isBWPEnabledMember = false;
        this.pudoShippingAddressInfo = null;
        this.pudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.hidePudoPickupLocationsButton = true;
        this.customBankTransferDetailsConfiguration = BankWireTransferConstants.BankTransferCountries;
        this.customWireTransferDetailsConfiguration = BankWireTransferConstants.WireTransferCountries;
        this.showCustomerBankTransferDetails = false;
        this.showCustomerWireTransferDetails = false;
        this.isPayByLinkValid = true;
        this.dropshipPudoShippingMethod = null;
        this.isPickUpOptionExist = false;
        this.isDropShipOptionExist = false;
        this.scandinavianCountry = false;
        this.showDistance = false;
        /**
         * Checks Whether Order Can be BackDated or Not
         * @param timeZoneOffset
         */
        this.isBackDateOrderAvailable = function (timeZoneOffset, operatingCountry) {
            _this.enableBackDateOrder = false;
            var processingMonth;
            var processingYear;
            var date = new Date();
            if (date.getMonth() === 0) {
                processingMonth = 12;
                processingYear = date.getFullYear() - 1;
            }
            else {
                processingMonth = date.getMonth();
                processingYear = date.getFullYear();
            }
            if (operatingCountry && processingMonth && processingYear) {
                _this._customerService.getBonusRunStatusDetails(operatingCountry, processingMonth, processingYear).subscribe(function (response) {
                    if (response && response.success && response.bonusStatus && response.validations.length === 0) {
                        if ((response.bonusStatus.toLowerCase() === BonusConstants.Open.toLowerCase())
                            || (response.bonusStatus.toLowerCase() === BonusConstants.Restricted.toLowerCase())) {
                            _this._orderService.isBackDateOrderAllowed(timeZoneOffset, _this.countryCode).subscribe(function (response) {
                                if (response && response.success) {
                                    _this.enableBackDateOrder = true;
                                }
                                else {
                                    _this.enableBackDateOrder = false;
                                }
                            }, function (error) {
                                _this.enableBackDateOrder = false;
                            });
                        }
                    }
                }, function (error) {
                    _this.enableBackDateOrder = false;
                });
            }
        };
        // endregion
        // region #Start Products Section
        /**
        * @param  {any} data
        * @returns SafeHtml
        */
        this.autocompleListFormatter = function (data) {
            var html = "<span>" + data.itemNumber + " - " + _this._titleCase.transform(data.displayName ? data.displayName : data.name) + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        /**
         * Auto Complete Product Search
         */
        this.observableSource = function (keyword, fullSearch) {
            if (_this.memberInfo && _this.storeInfo) {
                if (keyword && keyword.length > 2) {
                    if (keyword.indexOf('#') == 0) {
                        keyword = keyword.replace(/#/, '');
                    }
                    var wholesaleQualified = _this.orderInformation ? _this.orderInformation.wholesaleQualified : null;
                    if (wholesaleQualified == null) {
                        wholesaleQualified = false;
                    }
                    var fpc5PercentEnabled = false;
                    if (_this.appConfig) {
                        fpc5PercentEnabled = _this.appConfig.fpc5PercentEnabled;
                    }
                    var optin = _this.orderInformation ? _this.orderInformation.optIn : false;
                    var memberTitleId = _this.orderInformation && _this.orderInformation.memberLevelId ? _this.orderInformation.memberLevelId : _this.memberInfo.memberTitleId;
                    var purchaseFlowType = _this._commonService.getPurchaseFlowType(_this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
                    var _itemNumberURL = environment.productsUrl + '/stores/' + _this.storeInfo.id + '/categories/products' +
                        '?languageCode=' + _this.storeDefaultLanguage + '&memberTitleId=' + memberTitleId + '&purchaseFlowType='
                        + purchaseFlowType + '&countryCode=' + _this.selectedIsoCountryCode + '&pageSize=10&pageNumber=1&wholesaleQualified='
                        + wholesaleQualified + '&productWildSearch=' + keyword.trim() + '&excludeVariableProducts=true&isAutoShip=false&excludePromotionProducts=true&source=' + ProductSource.ADMINISTRATION
                        + '&optin=' + optin + '&taxInclusive=' + _this.storeInfo.taxInclusive;
                    if (fullSearch) {
                        _itemNumberURL += '&searchType=FULL';
                    }
                    return _this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(function (res) {
                        var results = res.json();
                        if (results && results.length > 0) {
                            return results;
                        }
                        else {
                            return [];
                        }
                    });
                }
                else {
                    return Observable.of([]);
                }
            }
            else {
                var notification = void 0;
                if (!_this.memberInfo) {
                    notification = _this._translatePipe.get('order. Member Details are Mandatory');
                }
                if (!_this.storeInfo && !_this.pickupDeliveryOptionAvailable && !_this.shippingDeliveryOptionAvailable && !_this.dropshipDeliveryOptionAvailable) {
                    notification = _this._translatePipe.get('Shipping options not available');
                }
                else if (!_this.storeInfo && (_this.pickupDeliveryOptionAvailable || _this.shippingDeliveryOptionAvailable || !_this.dropshipDeliveryOptionAvailable)) {
                    notification = _this._translatePipe.get('order.Country Details are Mandatory');
                }
                _this._commonService.createNotification('', notification.value, 'error');
            }
        };
    }
    OrderEditComponent.prototype.ngOnInit = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.orderSession = this._cacheService.get('UpdateOrderInfo');
        this._cacheService.remove('UpdateOrderInfo');
        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.getZipCodePatterns();
        this.isOrderedTax = !this.isOrderSessionInfo;
        this.getOrderStatuses();
        this.showDistance = environment.restrictGoogleMapNavigation;
        this.backDateOrderPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.ORDER_BACKDATE + ']'), AccessLevel.Customer_Service);
        this.hasReleaseMoPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.RELEASE_MO + ']'), AccessLevel.Customer_Service);
        this.hasReleaseWTPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.RELEASE_WIRE_TRANSFER + ']'), AccessLevel.Customer_Service);
        this.hasReleaseBFPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.RELEASE_BF + ']'), AccessLevel.Customer_Service);
        this.hasReleaseCODPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.RELEASE_COD + ']'), AccessLevel.Customer_Service);
        this.viewShoppingBagPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.VIEW_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.createShoppingBagPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.CREATE_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.deleteModal = new DeleteModal(this.clearData.bind(this), this.closeDeleteMessage.bind(this), this.closeDeleteMessage.bind(this));
        this.deleteModal.viewActionButtons = true;
        this.getCountries();
        this.getStates();
        if (this.orderSession) {
            this.shoppingBagClicked = this.orderSession && this.orderSession.shoppingBagClicked ? true : false;
            this.memberCartSessionGuid = this.orderSession.memberCartSessionGuid;
            this.orderFormGroup.patchValue({
                originalShippingCost: this.orderSession.originalShippingCost,
            });
        }
        this.paymentComponentSettings.webOrderId = this.webOrderId;
        this.isOrderFormLoad = this.isOrderSessionInfo ? false : true;
        this.selectedPaymentMethod = PaymentMethodTypes.Credit_Card.toString();
        this.setElementsFocus();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.accountTypes = [AccountType.Checking, AccountType.Savings];
        this.subscribeSaveAddress();
    };
    /*
      get different order statuses
       */
    OrderEditComponent.prototype.getOrderStatuses = function () {
        var _this = this;
        this._orderservice.getOrderStatuses().subscribe(function (response) {
            if (response) {
                _this.orderStatuses = response;
                _this.getOrderDetails();
            }
        });
    };
    OrderEditComponent.prototype.getOrderStatusUpdateOptions = function () {
        if (this.orderInformation && this.orderInformation.orderStatusId && this.orderInformation.orderShippings) {
            if (this.orderInformation.orderStatusId === OrderStatusEnums.Processing) {
                this.changeOrderStatus = this.orderInformation.orderShippings[0].deliveryPreferenceId === ShippingType.DELIVERY ?
                    CustomerServiceConstants.ORDER__SHIPPED_STATUS.filter(function (status) { return (status.id === OrderStatusEnums.Shipped); }) : CustomerServiceConstants.ORDER__SHIPPED_STATUS.filter(function (status) { return (status.id === OrderStatusEnums.Ready_For_Pickup); });
            }
            else if (this.orderInformation.orderStatusId === OrderStatusEnums.Shipped || this.orderInformation.orderStatusId === OrderStatusEnums.Ready_For_Pickup) {
                this.changeOrderStatus = CustomerServiceConstants.ORDER__SHIPPED_STATUS.filter(function (status) { return (status.id === OrderStatusEnums.Completed); });
            }
        }
    };
    /**
     * get order information
     */
    OrderEditComponent.prototype.getOrderDetails = function () {
        var _this = this;
        this._orderservice.getRecentOrderInformation(this.webOrderId.toUpperCase()).subscribe(function (response) {
            if (response) {
                _this.orderInformation = response;
                _this.setOrderType = _this.orderInformation.orderGroupId;
                _this.getOrderStatusUpdateOptions();
                if (_this.orderInformation && _this.orderInformation.userName && (_this.orderInformation.source === Constants.CUSTOMER_SERIVCE || _this.orderInformation.source === Constants.POS_ORDER || _this.orderInformation.source === Constants.SERVICE_ORDER)) {
                    _this.displayUserName = true;
                }
                _this.getOrderPaymentInfoUsingWebOrderId(_this.webOrderId, _this.orderInformation.id);
                var orderStatus = _this.orderStatuses.find(function (status) { return status.id === _this.orderInformation.orderStatusId; });
                _this.isReviewWindow = orderStatus
                    && (orderStatus.id === OrderStatus.Review_Window || (orderStatus.id === OrderStatus.Pending && _this.orderInformation.orderPayments.length > 0 &&
                        (_this.orderInformation.orderPayments[0].paymentMode === _this.paymentMethodTypes.Wire_Transfer || _this.orderInformation.orderPayments[0].paymentMode === _this.paymentMethodTypes.Money_order || _this.orderInformation.orderPayments[0].paymentMode === _this.paymentMethodTypes.Orange_Money))) ? true : false;
                // if (orderStatus.id !== OrderStatus.Pending  &&
                //     (this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Money_order ||
                //     this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Bank_Transfer)) {
                //     const updatedOrderInfo = {
                //         webOrderId: this.orderInformation.webOrderId,
                //         countryCode: this.orderInformation.countryCode
                //     };
                //     this._cacheService.set('UpdatedOrderInfo', updatedOrderInfo);
                //     this.router.navigate(['/customerservice/orders']);
                // }
                if (_this.orderInformation && _this.orderInformation.orderStatusId == _this.orderStatusId.Failed) {
                    _this.isOrderBackdated = false;
                }
                else {
                    _this.isOrderBackdated = response.backDateOrder ? true : false;
                }
                if (_this.orderInformation && _this.orderInformation.orderStatusId !== _this.orderStatusId.Failed) {
                    _this.isEditOrder = true;
                }
                else if (_this.orderInformation.orderStatusId === _this.orderStatusId.Failed) {
                    _this.isCloneOrder = true;
                }
                _this.orderInformation.orderStatus = orderStatus ? orderStatus.description : '';
                var distributor = _this.orderInformation.distrubutorId ? _this.orderInformation.distrubutorId : _this.orderInformation.email;
                _this.getMemberInfo(distributor, _this.orderInformation.countryCode);
                _this.selectedCountry(_this.orderInformation.countryCode);
                if (_this.orderInformation.orderPayments && _this.orderInformation.orderPayments.length > 0 && _this.orderInformation.orderPayments[0].paymentMode === _this.paymentMethodTypes.Bank_Transfer) {
                    _this.isEnableStatus = _this.hasReleaseBFPermission;
                }
                else if (_this.orderInformation.orderPayments && _this.orderInformation.orderPayments.length > 0 && _this.orderInformation.orderPayments[0].paymentMode === _this.paymentMethodTypes.Money_order) {
                    _this.isEnableStatus = _this.hasReleaseMoPermission;
                }
                else if (_this.orderInformation.orderPayments && _this.orderInformation.orderPayments.length > 0 && _this.orderInformation.orderPayments[0].paymentMode === _this.paymentMethodTypes.Orange_Money) {
                    _this.isEnableStatus = _this.hasReleaseMoPermission;
                }
                else if (_this.orderInformation.orderPayments && _this.orderInformation.orderPayments.length > 0 && _this.orderInformation.orderPayments[0].paymentMode === _this.paymentMethodTypes.Wire_Transfer) {
                    _this.isEnableStatus = _this.hasReleaseWTPermission;
                }
                else if (_this.orderInformation.orderPayments && _this.orderInformation.orderPayments.length > 0 && _this.orderInformation.orderPayments[0].paymentMode === _this.paymentMethodTypes.Cash_On_Delivery) {
                    _this.isEnableStatus = _this.hasReleaseCODPermission;
                }
                _this.buildForm();
                _this.buildPayByLinkForm();
                _this.orderFormGroup.controls['backDateOrder'].setValue(_this.isOrderBackdated);
                _this.deliveryPreferenceOnChange();
                if (_this.orderInformation.orderGroupId === OrderType.POS) {
                    _this.disableDelivery = true;
                }
                else {
                    _this.disableDelivery = false;
                }
                _this.unTouchedOrderRequest = _this.mapOrderResponseToUntouchedOrder(response);
            }
        });
    };
    /**
     * @description
     *  set focus for country and memberInfo elements
     *  based on orderSessionInfo
     * @date 2020-05-19
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.setElementsFocus = function () {
        var country = document.getElementById('country');
        var memberInfo = document.getElementById('memberInfo');
        if (this.isOrderSessionInfo) {
            country ? country.focus() : null;
        }
        else {
            memberInfo ? memberInfo.focus() : null;
        }
    };
    /**
     * @description map order request
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.mapOrderResponseToUntouchedOrder = function (response) {
        var unTouchedOrderRequest = {
            shippingCost: response.shippingCost,
            addresses: this._orderMapperService.mapAddressDetails(response.addresses),
            orderLineItems: this._orderMapperService.mapOrderLineItems(response.orderLineItems),
            orderShippings: this._orderMapperService.mapOrderShippingDetails(response.orderShippings),
            orderPayments: this._orderMapperService.mapOrderPaymentDetails(response.orderPayments),
            orderStatusId: response.orderStatusId
        };
        return unTouchedOrderRequest;
    };
    /**
     * @description map the modified order payment details
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.mapModifiedOrderPaymentDetails = function () {
        var orderPaymentsMapper = [];
        var orderLineItem = {
            paymentMode: this.getSelectedPaymentType(),
            isPaymentChanged: this.isPaymentChanged
        };
        orderPaymentsMapper.push(orderLineItem);
        return orderPaymentsMapper;
    };
    /**
     * @description map modified order request
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.mapModifiedOrderResponse = function () {
        var modifiedOrderRequest = {
            shippingCost: this.shippingCost,
            addresses: this._orderMapperService.mapAddressDetails(this.getAddresses()),
            orderLineItems: this._orderMapperService.mapOrderLineItems(this.products, true),
            orderShippings: this._orderMapperService.mapModifiedOrderShippingDetails(this.orderFormGroup),
            orderPayments: this.mapModifiedOrderPaymentDetails(),
            orderStatusId: this.orderFormGroup.controls['shippedOrderStatus'].value || (this.orderFormGroup.value.enableStatus ? OrderStatus.Accepted : OrderStatus.Pending)
        };
        return modifiedOrderRequest;
    };
    /**
     * Get State Info by Code or Id
     * @param stateId
     *
     */
    OrderEditComponent.prototype.getStateByStateId = function (stateId) {
        var stateObj = null;
        if (stateId) {
            stateObj = this.states.find(function (x) { return x.id === stateId; });
        }
        return stateObj;
    };
    /**
     * Get Country Info by Code or Id
     * @param countryId
     *
     */
    OrderEditComponent.prototype.getCountryByCountryId = function (countryId) {
        var countryObj = null;
        if (countryId) {
            countryObj = this.countries.find(function (x) { return x.countryId === countryId; });
        }
        return countryObj;
    };
    OrderEditComponent.prototype.clearData = function () {
    };
    OrderEditComponent.prototype.getFormControls = function () {
        var items = this.orderFormGroup.get('items');
        return items.controls;
    };
    OrderEditComponent.prototype.closeDeleteMessage = function () {
    };
    //#region #Start Build Forms Section
    /**
     * build Form
     */
    OrderEditComponent.prototype.buildForm = function () {
        var _this = this;
        this.orderFormGroup = this._formbuilder.group({
            orderType: [this.orderInformation.orderGroupId],
            memberInfo: [this.orderInformation.distrubutorId],
            items: this._formbuilder.array(this.items),
            countryId: [''],
            deliveryPreference: [this.orderInformation.orderShippings[0].deliveryPreferenceId],
            shippingAddressId: [''],
            shipMethodId: ['', [Validators.required]],
            originalShippingCost: [0, [Validators.required]],
            moneyOrderAmount: [0, [Validators.required]],
            shippingCost: [''],
            shippingCostPercentage: [''],
            itemSearch: [''],
            itemLevelSearch: [''],
            shippingCostSelector: [this.selectEnum.secondOption.toString()],
            paymentInstrumentId: ['', [Validators.required]],
            paymentSelector: [this.selectEnum.firstOption.toString()],
            enableStatus: [{ value: false, disabled: !this.isEnableStatus }],
            backDateOrder: [{ value: false, disabled: this.isOrderBackdated }],
            saveForFutureUse: [false],
            isShippingDiscountApplied: [false],
            originalShippingTax: [0, [Validators.required]],
            shippedOrderStatus: [],
        });
        setTimeout(function () {
            if (_this.addItemInput && _this.addItemInput.nativeElement) {
                _this.addItemInput.nativeElement.focus();
            }
        }, 500);
        this.buildPudoLocationSearchForm();
    };
    OrderEditComponent.prototype.onKeydown = function (event) {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    };
    /**
     * create item number
     * @returns FormGroup
     */
    OrderEditComponent.prototype.createItemNumberGroup = function () {
        return this._formbuilder.group({
            itemNumber: [''],
            quantity: [''],
            productId: [''],
            productItem: [{}],
            productNumber: [''],
            productName: [''],
            productImage: [[]],
            disableIncrement: [false],
            disableDelete: [],
            isDepositFeeProduct: [false],
            depositFeeEnabled: [false]
        });
    };
    /**
    * ShippingAddressForm Intialize
    */
    OrderEditComponent.prototype.createNewShippingAddress = function () {
        return this._formbuilder.group({
            name: [''],
            addressLine1: [''],
            addressLine2: [''],
            addressLine3: [''],
            addressLine4: [''],
            city: [''],
            stateId: [''],
            countryId: [''],
            postalCode: [''],
            phone: ['']
        });
    };
    /**
    * BillingAddressForm Intialize
    */
    OrderEditComponent.prototype.createNewBillingAddress = function () {
        return this._formbuilder.group({
            name: [''],
            addressLine1: [''],
            addressLine2: [''],
            addressLine3: [''],
            addressLine4: [''],
            city: [''],
            stateId: [''],
            countryId: [''],
            postalCode: [''],
            phone: ['']
        });
    };
    //#region #Start Countries/ Store and States Section
    /**
    * get Countries
    */
    OrderEditComponent.prototype.getCountries = function () {
        var _this = this;
        this._customerService.getCountriesLookup().subscribe(function (response) {
            if (response) {
                _this.countries = response;
                _this.stores = _this.countries.filter(function (country) { return country.titanPlatformEnabled && country.shopEnabled; });
            }
        });
    };
    /**
     * Get States By Country
     */
    OrderEditComponent.prototype.getStatesByCountry = function () {
        var _this = this;
        this.statesByCountry = [];
        var shippingForm = this.orderFormGroup.get('shippingAddressForm');
        this.states.forEach(function (state) {
            if (state.countryId === shippingForm.controls[0].controls['countryId'].value) {
                _this.statesByCountry.push(state);
            }
        });
    };
    /**
     * get States
     */
    OrderEditComponent.prototype.getStates = function () {
        var _this = this;
        this._customerService.getStates().subscribe(function (response) {
            if (response) {
                _this.states = response;
            }
        });
    };
    /**
     * Get Country Info by Code or Id
     * @param countryId
     * @param countryCode
     */
    OrderEditComponent.prototype.getCountryDetailsByCountryIdOrCode = function (countryId, countryCode) {
        var countryObj = {};
        if (countryId) {
            countryObj = this.countries.filter(function (x) { return x.countryId === countryId; })[0];
        }
        if (countryCode) {
            countryObj = this.countries.filter(function (x) { return x.isocodeThree === countryCode; })[0];
        }
        return countryObj;
    };
    /**
     * Get State Info by Code or Id
     * @param stateId
     * @param stateCode
     */
    OrderEditComponent.prototype.getStateDetailsByStateIdOrCode = function (stateId, stateCode, countryCode) {
        var stateObj = {};
        if (stateId) {
            stateObj = this.states.filter(function (x) { return x.id === stateId; })[0];
        }
        if (stateCode && countryCode) {
            stateObj = this.states.filter(function (x) { return x.stateCode === stateCode && x.countryCode === countryCode; })[0];
        }
        else if (stateCode) {
            stateObj = this.states.filter(function (x) { return x.stateCode === stateCode; })[0];
        }
        return stateObj;
    };
    OrderEditComponent.prototype.getCitiesByStates = function () {
        var _this = this;
        var countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
        this._addressService.getCitiesList(countryId).subscribe(function (response) {
            if (response) {
                _this.cityList = response;
                _this._cacheService.set(CacheKey.Cities, response);
            }
        });
    };
    /**
     * event for OrderBackDate CheckBox change
     */
    OrderEditComponent.prototype.backDateOrderChange = function (event) {
        this.orderFormGroup.controls['backDateOrder'].setValue(event.target.checked);
    };
    /**
     * On Country Select
     */
    OrderEditComponent.prototype.selectedCountry = function (countryCode) {
        var _this = this;
        var countryObj = this.countries.filter(function (x) { return x.isocodeThree === countryCode; })[0];
        if (countryObj) {
            this.translateOptions.translateParams.countryName = countryObj.name;
            if (this.memberInfo) {
                this.memberInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.memberInfo);
            }
            this.selectedIsoCountryCode = countryObj.isocodeThree;
            this.getZipCodePatterns();
            this.checkoutConfig = this._checkoutConfigService.getSettings(countryObj.isocodeThree, this.memberInfo);
            if (this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState) {
                this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                this._cacheService.set(CacheKey.COUNTRY_ID, countryObj.countryId);
                this.getCitiesByStates();
            }
            else {
                this._cacheService.remove(CacheKey.COUNTRY_CODE);
                this._cacheService.remove(CacheKey.COUNTRY_ID);
            }
            this.skipAddressVerification = this.checkoutConfig.skipAddressVerification;
            if (this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState) {
                this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                this._cacheService.set(CacheKey.COUNTRY_ID, countryObj.countryId);
                this.getCitiesByStates();
            }
            else {
                this._cacheService.remove(CacheKey.COUNTRY_CODE);
                this._cacheService.remove(CacheKey.COUNTRY_ID);
            }
            // this.isWorldPayEnabledCountry = this._configurationService.checkWorldPayEnabledCountry(countryObj.isocodeThree);
            // this.isWorldpayPayment = this.checkoutConfig.isWorldpayPayment;
            // this.isAdyenPayment = this.checkoutConfig.isAdyenPayment;
            // this.isNIPayment = this.checkoutConfig.isNIPayment;
            // this.NexioPayment = this.checkoutConfig.isNexioPayment;
            if (this.IsoCountryCode.CAN === this.selectedIsoCountryCode) {
                this.languageCode = 'en-CA';
            }
            this.countryCode = countryObj.isocodeThree;
            // this.selectedIsoCountryCode =countryObj.isoCodeThree;
            this.shippingSchemaUrl = countryObj.isocodeThree.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
            this.billingSchemaUrl = countryObj.isocodeThree.toLowerCase() + '-billing-schema-form.json?templateVersion='
                + environment.templateVersion;
            this.showShippingData = true;
            this.selectedCountryCodeTwo = countryObj.isocodeTwo;
            this.paymentComponentSettings.isoCountryCode = countryObj.isocodeThree;
            this.paymentComponentSettings.isoTwoletterCountryCode = countryObj.isocodeTwo;
            this.currentCountryObj = countryObj;
            this.isDropShipOptionExist = false;
            this.isPickUpOptionExist = false;
            // this.getZipCodePatterns();
            setTimeout(function () {
                _this.address = _this.address;
                _this.showAddressForm = true;
            }, 5000);
        }
    };
    OrderEditComponent.prototype.savedCardInfo = function (savedcardDetails) {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        if (savedcardDetails) {
            this.paymentComponentSettings.savedCards.unshift(savedcardDetails);
            this.showNexioPayment.close();
            this.isNexioPayment = false;
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length) {
                var savedCard = this.paymentComponentSettings.savedCards[0];
                if (savedCard && savedCard.id === savedcardDetails.id) {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(savedCard.id);
                }
                else {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedCards[0].id);
                }
                this.selectedpayvisionCardInfo = savedcardDetails;
            }
        }
    };
    OrderEditComponent.prototype.ngOnDestroy = function () {
        this._cacheService.remove(CacheKey.COUNTRY_CODE);
        this._cacheService.remove(CacheKey.COUNTRY_ID);
    };
    /**
     * Get Store Info
     * @param countryCode
     */
    OrderEditComponent.prototype.getStoreInfo = function (countryCode) {
        var _this = this;
        if (countryCode) {
            this._orderService.getStoreInfo(countryCode).subscribe(function (response) {
                if (response) {
                    _this.storeInfo = response;
                    if (_this.memberInfo) {
                        _this.memberInfo = __assign({}, _this.memberInfo, { displayMiddleName: _this.storeInfo.displayMiddleName });
                    }
                    if (_this.storeInfo) {
                        _this.getStoreMetaData(_this.storeInfo.id);
                    }
                    _this.storeId = response.id;
                    _this.getOrderRules();
                    if (response.languages && response.languages.length > 0) {
                        _this.storeDefaultLanguage = response.languages.find(function (languageCulture) { return languageCulture.default; }).cultureName;
                    }
                    else {
                        _this.storeDefaultLanguage = _this.languageCode;
                    }
                    if (_this.customBankTransferDetailsConfiguration && _this.customWireTransferDetailsConfiguration && _this.selectedIsoCountryCode) {
                        var language = _this._cacheService.get(CacheKey.Language);
                        _this.showCustomerBankTransferDetails = _this.customBankTransferDetailsConfiguration.includes(_this.selectedIsoCountryCode) && language.toLowerCase() == _this.storeDefaultLanguage.toLowerCase();
                        _this.showCustomerWireTransferDetails = _this.customWireTransferDetailsConfiguration.includes(_this.selectedIsoCountryCode) && language.toLowerCase() == _this.storeDefaultLanguage.toLowerCase();
                    }
                    // tslint:disable-next-line:max-line-length
                    var shipAddress = _this.orderInformation ? _this.orderInformation.addresses : null;
                    if (shipAddress && shipAddress.length > 0 && _this.countries && _this.countries.length > 0) {
                        if (shipAddress[0]) {
                            var countryCode_1 = shipAddress[0].countryCode;
                            var country = _this.countries.find(function (x) { return x.isocodeThree === countryCode_1; });
                            _this.countryTaxInclusive = _this.getCountryTaxInclusiveInfo(country);
                        }
                    }
                    _this.appConfig = _this._appConfigService.getSettings(_this.countryCode, _this.memberInfo);
                    if (_this.appConfig.isWireTransferLabelWithoutGmbh) {
                        _this.translateOptions.translateText = "checkout.Forever Living Products {{countryName}}";
                    }
                    if (_this.orderInformation.createdDate && (_this.orderInformation.storePostedOffset || _this.orderInformation.storePostedOffset === 0)) {
                        _this.orderInformation.createdDate = moment.utc(_this.orderInformation.createdDate)
                            .utcOffset(_this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                    }
                    if (_this.orderInformation.orderPostedDate && (_this.orderInformation.storePostedOffset || _this.orderInformation.storePostedOffset === 0)) {
                        _this.orderInformation.orderPostedDate = moment.utc(_this.orderInformation.orderPostedDate)
                            .utcOffset(_this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                    }
                    if (_this.orderInformation && _this.orderInformation.addresses) {
                        _this.pudoShippingAddressInfo = _this.orderInformation.addresses.find(function (z) { return z.addressType == AddressType.PICKUP_PERSON; });
                        if (_this.pudoShippingAddressInfo && _this.orderInformation && _this.orderInformation.orderShippings && _this.orderInformation.orderShippings.length) {
                            var externalId = _this.orderInformation.orderShippings[0].pudoExternalId;
                            _this.pudoLocationSearchForm.controls['externalId'].setValue(externalId);
                            _this.buildPudoLocationSearchForm(_this.pudoShippingAddressInfo.postalCode, _this.pudoShippingAddressInfo.city, _this.pudoShippingAddressInfo.addressLine1, _this.pudoShippingAddressInfo.countryCode, externalId);
                            _this.getPudoLocations();
                        }
                    }
                    _this.createdDate_show = true;
                    _this.storeInfo.ccNumberDecimals = 3;
                    _this.storeInfo.ccNumberFormat = 'CR';
                    _this.storeInfo.ccSymbol = 'CC';
                    _this.paymentComponentSettings.languageCode = _this.languageCode;
                    _this.paymentComponentSettings.storeId = _this.storeInfo.id;
                    _this.paymentComponentSettings.currencyCode = _this.storeInfo.currencyCode;
                    _this.paymentComponentSettings.numberDecimals = _this.storeInfo.numberDecimals;
                    _this.countryCode = countryCode;
                    _this.memberId = _this.memberInfo.memberId;
                    _this.getProducts();
                    _this.getSavedEchecks();
                    //  this.getZipCodePatterns();
                    _this.shippingAddressInfoConfig = _this._shippingAddressInfoConfigService.getSettings(_this.countryCode);
                    var memberType = void 0;
                    var memberTypeID = _this.currentMemberTypeID ? _this.currentMemberTypeID : +_this.memberInfo.memberTypeId;
                    if (memberTypeID === MemberTypeEnum.GUEST) {
                        memberType = MemberType.GUEST;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                    }
                    else if (memberTypeID === MemberTypeEnum.DISTRIBUTOR) {
                        memberType = MemberType.Distributor;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    }
                    else if (memberTypeID === MemberTypeEnum.FPC) {
                        memberType = MemberType.PREFERRED_CUSTOMER;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    }
                    else if (memberTypeID === MemberTypeEnum.RETAIL) {
                        memberType = MemberType.RETAIL;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                    }
                    if (!_this.shoppingBagClicked && _this.orderFormGroup.value.orderType === _this.orderType.REGULAR && _this.memberTypeId && _this.memberTypeId !== MemberTypeEnum.GUEST) {
                        _this.getShoppingCartCount(_this.storeInfo);
                    }
                    var getDeliveryOptionsRequest = {
                        memberTypeId: _this.orderInformation
                            && _this.orderInformation.memberTypeId ? _this.orderInformation.memberTypeId : _this.memberInfo ? _this.memberInfo.memberTypeId : null,
                        memberType: memberType.toUpperCase(),
                        source: Source.CSP,
                        countryCode: countryCode,
                        purchaseFlow: _this.deliveryOptionPurchaseFlow,
                        storeId: _this.storeId
                    };
                    _this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
                    _this.shippingDeliveryOptionAvailable = false;
                    _this.pickupDeliveryOptionAvailable = false;
                    _this.dropshipDeliveryOptionAvailable = false;
                    _this.getMemberDiscountPercentages();
                    _this._orderService.getDeliveryOptions(countryCode, getDeliveryOptionsRequest).subscribe(function (res) {
                        if (res) {
                            res.forEach(function (option) {
                                if (option.optionValue === DelivaryOptionType.Delivery) {
                                    _this.shippingDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Pickup) {
                                    _this.pickupDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Dropship) {
                                    _this.dropshipDeliveryOptionAvailable = true;
                                }
                            });
                            var isDropShip = res.find(function (x) { return x.optionValue == DelivaryOptionType.Dropship; });
                            var isPickUp = res.find(function (x) { return x.optionValue == DelivaryOptionType.Pickup; });
                            if (environment.scandinavianCountries && _this.countryCode) {
                                var scandinavianCountries = environment.scandinavianCountries;
                                _this.scandinavianCountry = scandinavianCountries.split(",").find(function (country) { return country === _this.countryCode; });
                            }
                            // For Scandian country checking for Pickup
                            if (_this.scandinavianCountry && isPickUp) {
                                _this.isPickUpOptionExist = true;
                            }
                            // For Non-Scandian country checking for DropShip
                            if (!_this.scandinavianCountry && isDropShip && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && !_this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                _this.isDropShipOptionExist = true;
                            }
                            // For Non-Scandian country checking for PickUp
                            if (!_this.scandinavianCountry && isPickUp && _this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                _this.isPickUpOptionExist = true;
                            }
                            if (!_this.scandinavianCountry && isPickUp && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && _this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                _this.isPickUpOptionExist = true;
                            }
                        }
                    });
                    _this.phoneNumberFormat = _this._commonService.getPhoneNumberFormatByCountryCode(_this.countryCode);
                    _this.getStorePromotions(memberTypeID);
                }
                _this.getPaymentMethodsByStore();
                if (_this.orderSession && _this.orderSession.deliveryPreference === _this.deliveryPreference.DROPSHIP
                    && _this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                    _this.getPudoLocations();
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order. Unable to fetch Store Details');
                _this._commonService.createNotification('', notification.value, 'error');
            });
        }
    };
    /**
    * @description
    * @date 2019-10-21
    * @private
    * @memberof OrderPromotionComponent
    */
    OrderEditComponent.prototype.getMemberDiscountPercentages = function () {
        var _this = this;
        var wholesaleQualified = this.orderInformation ? this.orderInformation.wholesaleQualified : null;
        if (wholesaleQualified == null) {
            wholesaleQualified = false;
        }
        if (this.orderInformation) {
            this.memberInfo.transactionalWholesaleQualified = this.orderInformation.wholesaleQualified ? this.orderInformation.wholesaleQualified : false;
            this.memberInfo.transactionalOptin = this.orderInformation.optIn ? this.orderInformation.optIn : false;
        }
        this.loadMemberShoppingCart(this.storeInfo);
        var optin = this.orderInformation ? this.orderInformation.optIn : false;
        var memberTitleID = this.orderInformation && this.orderInformation.memberLevelId
            ? this.orderInformation.memberLevelId : this.memberInfo.memberTitleId;
        this._commonService.getDiscountPercentages(wholesaleQualified, optin, memberTitleID, this.storeId).
            subscribe(function (response) {
            _this.memberDiscountPercentage = response;
        });
    };
    //getPaymentMethod by Store
    OrderEditComponent.prototype.getPaymentMethodsByStore = function () {
        var _this = this;
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode, this.storeDefaultLanguage, this.memberInfo.memberTypeId, this.memberInfo.wholeSaleQualified).subscribe(function (response) {
            if (response) {
                var storePaymentInfo = response;
                _this.initializePaymentMethods();
                if ((_this.orderInformation.orderStatusId === OrderStatus.Pending && _this.orderInformation.orderPayments && _this.orderInformation.orderPayments.length > 0 &&
                    (_this.orderInformation.orderPayments[0].paymentMode === _this.paymentMethodTypes.Wire_Transfer))) {
                    _this.wire_Transfer_show = true;
                    _this.getBankDetailsByCountry(_this.countryCode, PaymentModeConstants.Wire_Transfer);
                }
                else {
                    storePaymentInfo.forEach(function (paymentMethod) {
                        paymentMethod.paymentMethodId;
                        if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                            _this.credit_Card_show = true;
                            if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NEXIO) {
                                _this.NexioPayment = true;
                            }
                            else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.ADYEN) {
                                _this.isAdyenPayment = true;
                            }
                            else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NI) {
                                _this.isNIPayment = true;
                            }
                            else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.WPAYXML) {
                                _this.isWorldpayPayment = true;
                            }
                        }
                        else if (paymentMethod.paymentMethodId == PaymentType.Money_order) {
                            _this.money_Order_show = true;
                            _this.getBankDetailsByCountry(_this.countryCode, PaymentModeConstants.Money_Order);
                        }
                        else if (paymentMethod.paymentMethodId == PaymentType.Orange_Money) {
                            _this.orange_Money_show = true;
                        }
                        else if (paymentMethod.paymentMethodId == PaymentType.Wire_Transfer) {
                            _this.wire_Transfer_show = true;
                            _this.getBankDetailsByCountry(_this.countryCode, PaymentModeConstants.Wire_Transfer);
                        }
                        else if (paymentMethod.paymentMethodId == PaymentType.Cash_On_Delivery) {
                            _this.cash_on_delivery_show = true;
                        }
                        else if (paymentMethod.paymentMethodId == PaymentType.Bank_Transfer) {
                            _this.bank_transfer_show = true;
                            _this.getBankDetailsByCountry(_this.countryCode);
                        }
                        else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                            _this.ach_show = true;
                        }
                        else if (paymentMethod.paymentMethodId === PaymentType.BanContact_MisterCash_and_Maestro) {
                            _this.banContact_misterCash_and_maestro_show = true;
                        }
                        else if (paymentMethod.paymentMethodId === PaymentType.MisterCash_and_Maestro) {
                            _this.misterCash_and_maestro_show = true;
                        }
                        else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                            _this.pay_by_link_show = true;
                        }
                    });
                }
                _this.savePaymentMethod = _this.orderSession && _this.orderSession.savePaymentMethod ?
                    _this.orderSession.savePaymentMethod : false;
            }
        });
    };
    OrderEditComponent.prototype.initializePaymentMethods = function () {
        this.isWorldpayPayment = false;
        this.isAdyenPayment = false;
        this.isNIPayment = false;
        this.isNexioPayment = false;
    };
    OrderEditComponent.prototype.populateCountries = function (memberAllowedCountries) {
        var _this = this;
        if (memberAllowedCountries && memberAllowedCountries.length > 0 && this.countries && this.countries.length > 0) {
            memberAllowedCountries.forEach(function (allowedCountry) {
                var countryObj = _this.countries
                    .filter(function (country) { return country.titanPlatformEnabled && allowedCountry.isoCodeThree === country.isocodeThree; })[0];
                if (countryObj) {
                    if (!(_this.stores.findIndex(function (country) { return country.isoCodeThree === countryObj.isocodeThree; }) >= 0)) {
                        _this.stores.push({
                            id: countryObj.countryId, name: countryObj.name, isoCodeThree: countryObj.isocodeThree,
                            isoCodeTwo: countryObj.isocodeTwo, homeCountry: allowedCountry.homeCountry
                        });
                    }
                }
            });
        }
    };
    //#endregion
    // region #Start Member Function Section
    /**
   * Get Member Info by EmailID or FBOID
   */
    OrderEditComponent.prototype.getMemberInfo = function (memberDetails, countryCode) {
        var _this = this;
        var type = '';
        type = memberDetails.indexOf('@') > -1 ? 'email' : 'fboId';
        this._orderService.getMemberInfo(memberDetails, type).subscribe(function (response) {
            if (response && response.memberId) {
                _this.getMemberLevelInfo(response, countryCode);
            }
            else {
                var notification = _this._translatePipe.get('order.Member Details Not Found');
                if (_this.orderInformation.createdDate(_this.orderInformation.storePostedOffset || _this.orderInformation.storePostedOffset === 0)) {
                    _this.orderInformation.createdDate = moment.utc(_this.orderInformation.createdDate)
                        .utcOffset(_this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                }
                if (_this.orderInformation.orderPostedDate(_this.orderInformation.storePostedOffset || _this.orderInformation.storePostedOffset === 0)) {
                    _this.orderInformation.orderPostedDate = moment.utc(_this.orderInformation.orderPostedDate)
                        .utcOffset(_this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                }
                _this.createdDate_show = true;
                _this._commonService.createNotification('', notification.value, 'error');
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to retrieve Member Details');
            _this._commonService.createNotification('', notification.value, 'error');
        });
    };
    OrderEditComponent.prototype.getMemberLevelInfo = function (memberResponse, countryCode) {
        this.processMemberResponse(memberResponse, countryCode);
        // this._commonService.getMemberLevelDetails(memberResponse.fboId).subscribe((response) => {
        //     if (response && response.memberLevel) {
        //         this.accountMemberInfo = Object.assign({}, memberResponse);
        //         memberResponse.memberTitle = response.memberLevel;
        //     }
        //     this.processMemberResponse(memberResponse, countryCode);
        // }, (error) => {
        //     this.processMemberResponse(memberResponse, countryCode);
        // });
    };
    OrderEditComponent.prototype.processMemberResponse = function (response, countryCode) {
        var _this = this;
        this.memberInfo = response;
        this.isBWPEnabledMember = this.memberInfo.memberMetaData.find(function (x) { return x.customKey === MemberMetaDataEnum.BWPENABLED && x.customValue === '1'; });
        if (response && response.memberTitle) {
            this.memberInfo.memberTitle = response.memberTitle;
        }
        else if (this.memberInfo && !this.memberInfo.memberTitle) {
            this.memberInfo.memberTitle = this.accountMemberInfo.memberTitle;
        }
        if (+response.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        if (response.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
            this.getMembergovernmentIdentificationsInfo(response.memberId);
        }
        if (this.memberInfo && this.memberInfo.memberTypeId && this.memberInfo.memberTypeId === this.memberTypeEnums.GUEST) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        }
        // else if (+response.memberTypeId === MemberTypeEnum.FPC) {
        //     this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        // }
        if (this.memberInfo && this.memberInfo.memberAllowedCountries) {
            this.populateCountries(this.memberInfo.memberAllowedCountries);
        }
        this.memberTypeId = this.memberInfo.memberTypeId;
        this.selectedCountry(countryCode);
        if (this.isCloneOrder) {
            this.loadSavedCardsForMemberId(this.memberInfo.memberId, countryCode);
        }
        this.getStoreInfo(this.orderInformation.countryCode);
        if (this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        this.paymentComponentSettings.memberId = this.memberInfo.memberId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        this.paymentComponentSettings.distributorId = this.memberInfo ? this.memberInfo.fboId : '';
        this.paymentComponentSettings.uniqueRefId = this.memberInfo.uniqueRefID ? this.memberInfo.uniqueRefID : '';
        var country = this.countries.filter(function (x) { return x.countryId === _this.memberInfo.address.countryId; })[0];
        this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
        this.paymentComponentSettings.memberTypeId = this.memberInfo.memberTypeId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        this.personalDiscountPercentage = this._commonService.getPersonalDiscount(this.orderInformation
            && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : this.memberInfo.memberTitleId);
    };
    /**
    *
    * @param memberId get Member Addresses
    */
    OrderEditComponent.prototype.getMemberAddressByMemberId = function (memberId, countryId) {
        var _this = this;
        this.shippingAddressInfo = null;
        this.showAddressForm = false;
        this.billingAddressInfo = null;
        this._orderService.getMemberAddressByMemberId(memberId, countryId).subscribe(function (response) {
            _this.memberAddressDetails = [];
            _this.memberShippingDetails = [];
            if (response && response.length > 0) {
                _this.memberAddressDetails = response.filter(function (x) { return x.addressTypeId === AddressType.SHIPPING; });
                _this.memberAddressDetails = _this._commonService.sortMemberAddress(_this.memberAddressDetails);
                _this.addressSearchResult = _this.memberAddressDetails;
                if (!_this.isOrderSessionInfo && (_this.orderSession === null || !_this.orderSession.shippingAddressId)) {
                    _this.address = _this.memberAddressDetails.find(function (x) { return x.defaultAddress === true; });
                    if (!_this.address && _this.orderInformation.orderShippings.length > 0) {
                        var memberAddressDetails_1 = [];
                        _this.orderInformation.addresses.forEach(function (address) {
                            var name = address.middleName ?
                                address.firstName + ' ' + address.middleName + ' ' + address.lastName :
                                address.firstName + ' ' + address.lastName;
                            memberAddressDetails_1.push({
                                id: address.id,
                                shippingAddress: {
                                    shipToName: name || address.name,
                                    addressLine1: address.addressLine1,
                                    addressLine2: address.addressLine2,
                                    addressLine3: address.addressLine3,
                                    addressLine4: address.addressLine4,
                                    addressType: address.addressType,
                                    city: address.city,
                                    stateId: address.stateId,
                                    countryId: address.countryId,
                                    postalCode: address.postalCode,
                                    addressVerified: address.addressVerified,
                                    shippingPhone: address.phone,
                                    email: address.email,
                                    firstName: address.firstName,
                                    lastName: address.lastName,
                                    middleName: address.middleName,
                                    type: address.type
                                }
                            });
                        });
                        if (memberAddressDetails_1.length > 0) {
                            var shippingAddressDetails = memberAddressDetails_1.find(function (address) {
                                return (address.shippingAddress.addressType === AddressType.SHIPPING);
                            });
                            if (shippingAddressDetails) {
                                var stateObj = _this.getStateByStateId(shippingAddressDetails.shippingAddress.stateId);
                                if (stateObj) {
                                    shippingAddressDetails.shippingAddress.state = stateObj.stateId;
                                    shippingAddressDetails.shippingAddress.stateCode = stateObj.stateCode;
                                }
                                var countryObj = _this.getCountryByCountryId(shippingAddressDetails.shippingAddress.countryId);
                                if (countryObj) {
                                    shippingAddressDetails.shippingAddress.country = countryObj.name;
                                    shippingAddressDetails.shippingAddress.countryCode = countryObj.isocodeThree;
                                    shippingAddressDetails.shippingAddress.countryId = countryObj.countryId;
                                }
                                shippingAddressDetails.shippingAddress.phoneNumber = shippingAddressDetails.shippingAddress.shippingPhone;
                                _this.address = shippingAddressDetails.shippingAddress;
                                _this.shippingAddressInfo = shippingAddressDetails.shippingAddress;
                            }
                        }
                    }
                    if (_this.address) {
                        _this.address.isSavedAddress = true;
                        _this.address.phone = _this.address.phoneNumber;
                        _this.shippingAddressInfo = _this.address;
                        _this.shippingSchemaUrl = _this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                            + environment.templateVersion;
                        _this.billingSchemaUrl = _this.countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
                            + environment.templateVersion;
                        _this.showShippingData = true;
                    }
                }
                _this.memberShippingDetails = response.filter(function (x) { return x.addressTypeId === AddressType.SHIPPING; });
                if (_this.isOrderSessionInfo) {
                    // check for shpping address when order info is in cache
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(_this.orderSession.saveForFutureUse);
                    if (_this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                        _this.orderFormGroup.controls['deliveryPreference'].setValue(_this.orderSession.deliveryPreference);
                        _this.orderFormGroup.controls['shipMethodId'].setValue(_this.orderSession.shipMethodId.toString());
                        _this.validationsOnDeliveryPreference();
                    }
                    else if (_this.orderSession.shippingAddressId) {
                        _this.address = _this.orderInformation.addresses[0];
                        // this.address = this.memberShippingDetails.find((x: any) => x.id === this.orderSession.shippingAddressId);
                        _this.orderFormGroup.controls['shippingAddressId'].setValue(_this.orderSession.shippingAddressId, { onlySelf: true });
                        if (_this.address) {
                            if (_this.address.phoneNumber) {
                                _this.address.phone = _this.address.phoneNumber;
                            }
                            _this.address.isSavedAddress = true;
                            _this.shippingAddressInfo = _this.address;
                            _this.savedAddressId = _this.address.id;
                        }
                        else {
                            _this.address = _this.orderSession.shippingAddressInfo;
                            _this.address.phone = _this.address.shippingPhone;
                            _this.shippingAddressInfo = _this.address;
                            _this.savedAddressId = _this.address.id;
                            _this.address.isSavedAddress = _this.orderSession.isSavedAddress;
                        }
                        _this.shippingSchemaUrl = _this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                            + environment.templateVersion;
                        _this.billingSchemaUrl = _this.countryCode.toLowerCase()
                            + '-billing-schema-form.json?templateVersion=' + environment.templateVersion;
                        _this.showShippingData = true;
                    }
                    else if (_this.memberShippingDetails && !_this.orderSession.shippingAddressId && _this.orderSession.deliveryPreference === DeliveryPreference.DELIVERY) {
                        _this.orderFormGroup.controls['shippingAddressId'].setValue(AddressType.SHIPPING, { onlySelf: true });
                        _this.address = _this.orderSession.shippingAddressInfo;
                        _this.address.phone = _this.address.shippingPhone;
                        _this.shippingAddressInfo = _this.address;
                        _this.savedAddressId = _this.address.id;
                        _this.address.isSavedAddress = _this.orderSession.isSavedAddress;
                        _this.shippingSchemaUrl = _this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                            + environment.templateVersion;
                        _this.billingSchemaUrl = _this.countryCode.toLowerCase()
                            + '-billing-schema-form.json?templateVersion=' + environment.templateVersion;
                        _this.showShippingData = true;
                    }
                }
                else if (!_this.isOrderSessionInfo && _this.orderInformation.orderShippings.length > 0
                    && _this.orderInformation.orderShippings[0].shippingAddressId) {
                    _this.orderFormGroup.controls['shippingAddressId']
                        .setValue(_this.orderInformation.orderShippings[0].shippingAddressId);
                    if (_this.orderInformation && _this.orderInformation.addresses && _this.orderInformation.addresses.length > 0) {
                        var orderShippingInfo = _this.orderInformation.addresses[0];
                        // --address to change
                        _this.address = _this.orderInformation.addresses[0];
                        // this.address = this.memberShippingDetails.find((x: any) => x.id === this.orderInformation.orderShippings[0].shippingAddressId);
                        if (_this.address) {
                            _this.address.isSavedAddress = true;
                            _this.shippingAddressInfo = _this.address;
                            _this.savedAddressId = _this.address.id;
                        }
                        else {
                            _this.shippingAddressInfo = orderShippingInfo;
                            _this.savedAddressId = orderShippingInfo.id;
                            _this.address = orderShippingInfo;
                            _this.address.phoneNumber = orderShippingInfo.phone;
                        }
                        var name_1 = orderShippingInfo.middleName ?
                            orderShippingInfo.firstName + ' ' + orderShippingInfo.middleName + ' ' + orderShippingInfo.lastName :
                            orderShippingInfo.firstName + ' ' + orderShippingInfo.lastName;
                        orderShippingInfo.shipToName = name_1 || orderShippingInfo.name;
                        orderShippingInfo.id = _this.orderInformation.orderShippings[0].shippingAddressId;
                    }
                    if (_this.orderInformation.orderShippings[0].billingAddressId) {
                        var billingInfo = response
                            .find(function (address) { return address.id === _this.orderInformation.orderShippings[0].billingAddressId; });
                        _this.billingAddressInfo = billingInfo;
                    }
                }
                else if (!_this.orderInformation.orderShippings[0].billingAddressId
                    && !_this.orderInformation.orderShippings[0].shippingAddressId) {
                    if (_this.orderFormGroup.controls['billingAddressId']) {
                        _this.orderFormGroup.controls['billingAddressId'].setValue(_this.memberAddressDetails[0].id);
                    }
                    _this.billingAddressInfo = _this.memberAddressDetails[0].shippingAddress;
                }
                _this.appConfig = _this._appConfigService.getSettings(_this.countryCode, _this.memberInfo); //storeConfiguration
                _this.showAddressForm = true;
                if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) {
                    _this.getShipMethods();
                }
            }
            else {
                _this.appConfig = _this._appConfigService.getSettings(_this.countryCode, _this.memberInfo);
                if (_this.isOrderSessionInfo) {
                    // check for shpping address when order info is in cache
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(_this.orderSession.saveForFutureUse);
                    if (_this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                        _this.orderFormGroup.controls['deliveryPreference'].setValue(_this.orderSession.deliveryPreference);
                        if (_this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                            _this.orderFormGroup.controls['deliveryPreference'].setValue(_this.orderSession.deliveryPreference);
                        }
                        _this.constructSchemaFormUrl(_this.countryCode);
                        _this.validationsOnDeliveryPreference();
                    }
                    else if (_this.orderSession.shippingAddressId) {
                        _this.address = _this.orderSession.shippingAddressInfo;
                        _this.orderFormGroup.controls['shippingAddressId'].setValue(_this.orderSession.shippingAddressId, { onlySelf: true });
                        if (_this.address) {
                            _this.address.isSavedAddress = _this.orderSession.isSavedAddress;
                            _this.address.phone = _this.address.shippingPhone;
                            _this.shippingAddressInfo = _this.address;
                            _this.savedAddressId = _this.address.id;
                            _this.shippingSchemaUrl = _this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                                + environment.templateVersion;
                            _this.billingSchemaUrl = _this.countryCode.toLowerCase()
                                + '-billing-schema-form.json?templateVersion=' + environment.templateVersion;
                            _this.showShippingData = true;
                        }
                    }
                    if (!_this.orderSession.shippingAddressId && _this.orderSession.shippingAddressInfo) {
                        if (_this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                            _this.orderFormGroup.controls['deliveryPreference'].setValue(_this.orderSession.deliveryPreference);
                            _this.orderFormGroup.controls['shipMethodId'].setValue(_this.orderSession.shipMethodId.toString());
                            _this.validationsOnDeliveryPreference();
                        }
                        else {
                            _this.address = _this.orderSession.shippingAddressInfo;
                            _this.orderFormGroup.controls['shippingAddressId'].setValue(AddressType.SHIPPING, { onlySelf: true });
                            if (_this.address) {
                                _this.address.isSavedAddress = _this.orderSession.isSavedAddress;
                                _this.address.phone = _this.address.shippingPhone;
                                _this.shippingAddressInfo = _this.address;
                                _this.savedAddressId = _this.address.id;
                                _this.shippingSchemaUrl = _this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                                    + environment.templateVersion;
                                _this.billingSchemaUrl = _this.countryCode.toLowerCase()
                                    + '-billing-schema-form.json?templateVersion=' + environment.templateVersion;
                                _this.showShippingData = true;
                            }
                        }
                    }
                }
                else if (!_this.isOrderSessionInfo && _this.orderInformation.orderShippings.length > 0) {
                    if (_this.orderInformation.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DELIVERY) {
                        if (_this.orderInformation.orderShippings[0].shippingAddressId) {
                            _this.orderFormGroup.controls['shippingAddressId']
                                .setValue(_this.orderInformation.orderShippings[0].shippingAddressId);
                        }
                        if (_this.orderInformation && _this.orderInformation.addresses && _this.orderInformation.addresses.length > 0) {
                            var orderShippingInfo = _this.orderInformation.addresses[0];
                            var name_2 = orderShippingInfo.middleName ?
                                orderShippingInfo.firstName + ' ' + orderShippingInfo.middleName + ' ' + orderShippingInfo.lastName :
                                orderShippingInfo.firstName + ' ' + orderShippingInfo.lastName;
                            orderShippingInfo.shipToName = name_2 || orderShippingInfo.name;
                            if (_this.orderInformation.orderShippings[0].shippingAddressId) {
                                orderShippingInfo.id = _this.orderInformation.orderShippings[0].shippingAddressId;
                            }
                            if (_this.appConfig && _this.appConfig.skipAddressVerification) {
                                orderShippingInfo.addressVerified = true;
                            }
                            orderShippingInfo.shippingPhone = orderShippingInfo.phone;
                            _this.shippingAddressInfo = orderShippingInfo;
                            _this.savedAddressId = orderShippingInfo.id;
                            _this.address = orderShippingInfo;
                        }
                    }
                }
                _this.appConfig = _this._appConfigService.getSettings(_this.countryCode, _this.memberInfo); //storeConfiguration
                _this.showAddressForm = true;
                _this.shippingAddressSelectionChange();
            }
            _this.setPayByLinkEmail();
        }, function (error) {
            _this.showAddressForm = true;
            var notification = _this._translatePipe.get('order.Unable to retrieve Member Addresses');
            _this._commonService.createNotification('', notification.value, 'error');
        });
    };
    /**
     * @description constructing the schema form url
     * @date 2018-11-27
     * @memberof OrderPromotionComponent
     */
    OrderEditComponent.prototype.constructSchemaFormUrl = function (countryCode) {
        var _this = this;
        this.shippingSchemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;
        this.billingSchemaUrl = countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
            + environment.templateVersion;
        setTimeout(function () {
            _this.address = _this.address;
            _this.showAddressForm = true;
        }, 500);
    };
    // endregion
    /**
    * Delivery Preference On Change
    * @param value delivery preference
    */
    OrderEditComponent.prototype.deliveryPreferenceOnChange = function () {
        this.deliveryPreferenceType = this.orderFormGroup.value.deliveryPreference;
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.shippingAddressChanged = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
            //  this.showPudoPickupPersonAddressForm = true;
        }
        else {
            this.showDropShipPersonAddressForm = false;
            this.displayDropAddress = false;
        }
        this.constructSchemaFormUrl(this.countryCode);
        this.updateTotalsAndShipMethod();
        this.validationsOnDeliveryPreference();
    };
    /**
     * update validations on delivery preference
     */
    OrderEditComponent.prototype.validationsOnDeliveryPreference = function () {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.shippingAddressInfo = {};
            this.orderFormGroup.controls['shipMethodId'].setValue('');
            this.orderFormGroup.controls['shippingCostSelector'].setValue('');
            this.orderFormGroup.controls['shippingCostSelector'].disable();
            this.shippingCostChange(true);
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY) {
            this.orderFormGroup.controls['shippingCostSelector'].enable();
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.orderFormGroup.controls['shippingCostSelector'].enable();
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                this.showDropShipPersonAddressForm = true;
                this.displayDropAddress = true;
            }
            if (this.orderSession && this.orderSession.buildPudoLocationSearchForm) {
                this.pudoLocationSearchForm.controls['zipCode'].setValue(this.orderSession.buildPudoLocationSearchForm.zipCode);
                this.pudoLocationSearchForm.controls['city'].setValue(this.orderSession.buildPudoLocationSearchForm.city);
                this.pudoLocationSearchForm.controls['externalId'].setValue(this.orderSession.buildPudoLocationSearchForm.externalId);
                this.pudoLocationSearchForm.controls['zipCode'].updateValueAndValidity();
                this.pudoLocationSearchForm.controls['city'].updateValueAndValidity();
                this.pudoLocationSearchForm.controls['externalId'].updateValueAndValidity();
                if (this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    // this.showPudoPickupPersonAddressForm = true;
                    this.displayPudoAddress = true;
                }
                else if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                    this.showDropShipPersonAddressForm = true;
                    this.displayDropAddress = true;
                }
                this.shippingAddressSelectionChange();
                this.updateTotalsAndShipMethod();
                // this.getPudoLocations();
            }
        }
    };
    /**
     * On Shipping Address Selected
     */
    OrderEditComponent.prototype.selectedShippingAddress = function (address) {
        this.addressSearchResult = this.memberAddressDetails;
        var addressDetailId = address.id;
        address.isSavedAddress = true;
        if (addressDetailId && this.memberShippingDetails) {
            var shippingAddress = this.memberShippingDetails.filter(function (x) { return x.id === addressDetailId; });
            if (shippingAddress && shippingAddress[0]) {
                this.shippingAddressInfo = shippingAddress[0].shippingAddress;
            }
        }
        this.savedAddressId = address.id;
        address.phone = address.phoneNumber;
        address.email = address.email ? address.email : null;
        this.shippingAddressInfo = address;
        this.address = address;
        this.showSavedAddress = false;
        this.updateTotalsAndShipMethod();
    };
    /**
    *
    * @param enableValidation
    */
    OrderEditComponent.prototype.updateShippingAddressFormValidations = function (enableNewAddressValidation, removeAllValidations) {
        var shippingAddressForm = this.orderFormGroup.get('shippingAddressForm');
        if (shippingAddressForm && shippingAddressForm.length > 0) {
            if (enableNewAddressValidation) {
                this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
                shippingAddressForm.controls[0].controls['addressLine1'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['name'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['city'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['stateId'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['countryId'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['postalCode'].setValidators([Validators.required]);
            }
            else {
                this.orderFormGroup.controls['shippingAddressId'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['addressLine1'].setValidators([]);
                shippingAddressForm.controls[0].controls['name'].setValidators([]);
                shippingAddressForm.controls[0].controls['addressLine2'].setValidators([]);
                shippingAddressForm.controls[0].controls['addressLine3'].setValidators([]);
                shippingAddressForm.controls[0].controls['addressLine4'].setValidators([]);
                shippingAddressForm.controls[0].controls['city'].setValidators([]);
                shippingAddressForm.controls[0].controls['stateId'].setValidators([]);
                shippingAddressForm.controls[0].controls['countryId'].setValidators([]);
                shippingAddressForm.controls[0].controls['postalCode'].setValidators([]);
            }
            if (removeAllValidations) {
                this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
            }
            shippingAddressForm.controls[0].controls['name'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine1'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine2'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine3'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine4'].setValue('');
            shippingAddressForm.controls[0].controls['city'].setValue('');
            shippingAddressForm.controls[0].controls['phone'].setValue('');
            shippingAddressForm.controls[0].controls['postalCode'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine1'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['name'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['city'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['stateId'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['stateId'].setValue('');
            shippingAddressForm.controls[0].controls['countryId'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['countryId'].setValue('');
            shippingAddressForm.controls[0].controls['postalCode'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingAddressId'].setValue('');
            this.orderFormGroup.controls['shippingAddressId'].updateValueAndValidity();
            if (this.currentCountryObj) {
                shippingAddressForm.controls[0].controls['countryId'].setValue(this.currentCountryObj.countryId);
                this.getStatesByCountry();
            }
        }
    };
    OrderEditComponent.prototype.prepareNewAddress = function (address) {
        if (address) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(+address.countryId, null);
            var stateObj = this.getStateDetailsByStateIdOrCode(+address.stateId, null);
            var addressObj = {
                name: address.name,
                phone: address.phone,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: stateObj.stateCode || '',
                stateId: address.stateId,
                postalCode: address.postalCode,
                country: countryObj.isocodeThree || '',
                countryCodeThree: countryObj.isocodeThree || '',
                countryId: address.countryId,
                firstName: address.firstName,
                lastName: address.lastName,
                middleName: address.middleName,
                type: address.type,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse
            };
            return addressObj;
        }
    };
    OrderEditComponent.prototype.addressChangedByUser = function (changed) {
        this.shippingAddressChanged = changed;
    };
    /**
       * verified Address Mapping
       * @param  {any}  address
       * @returns any
       */
    OrderEditComponent.prototype.mapVerifiedAddressToFormFields = function (address) {
        if (address) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, address.country);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, address.state, address.country);
            var mapAddressToFields = {
                name: address.name,
                firstName: address.firstName,
                lastName: address.lastName,
                middleName: address.middleName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                postalCode: address.postalCode,
                city: address.city,
                stateId: stateObj.id,
                stateCode: stateObj.stateCode,
                countryCode: countryObj.countryCode || countryObj.isocodeThree,
                countryId: countryObj.countryId,
                phone: address.phone ? address.phone.replace(/[^a-zA-Z0-9]/g, '') : null,
                addressVerified: (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified,
                id: address.id,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null
            };
            return mapAddressToFields;
        }
    };
    /**
    * Add new Shipping Address
    * @param shippingAddressForm
    */
    OrderEditComponent.prototype.useNewShippingAddress = function (addressInfo) {
        if (addressInfo) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(addressInfo.countryId, null);
            var stateObj = this.getStateDetailsByStateIdOrCode(addressInfo.stateId, null);
            var name_3 = addressInfo.middleName ?
                addressInfo.firstName + ' ' + addressInfo.middleName + ' ' + addressInfo.lastName :
                addressInfo.firstName + ' ' + addressInfo.lastName;
            this.shippingAddressInfo = {
                shipToName: name_3 || addressInfo.name,
                addressLine1: addressInfo.addressLine1,
                addressLine2: addressInfo.addressLine2,
                addressLine3: addressInfo.addressLine3,
                addressLine4: addressInfo.addressLine4,
                city: addressInfo.city,
                stateId: stateObj.id,
                stateName: stateObj.stateName || '',
                state: stateObj.stateCode || '',
                stateCode: stateObj.stateCode || '',
                countryId: countryObj.countryId,
                countryName: countryObj.name || '',
                country: countryObj.isocodeThree || '',
                countryCode: countryObj.isocodeThree || '',
                postalCode: addressInfo.postalCode || addressInfo.zip,
                zip: addressInfo.postalCode || addressInfo.zip,
                phone: addressInfo.phone,
                addressVerified: addressInfo.addressVerified,
                firstName: addressInfo.firstName,
                lastName: addressInfo.lastName,
                middleName: addressInfo.middleName,
                type: addressInfo.type,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction: addressInfo.deliveryInstruction,
                email: addressInfo.email ? addressInfo.email : null
            };
            this.isNewCard = false;
            this.updateTotalsAndShipMethod();
        }
        else {
            this.showAddressFormValidations = true;
        }
    };
    /**
     * save address method
     */
    OrderEditComponent.prototype.saveAddress = function (addressDetails) {
        var _this = this;
        var name = addressDetails.middleName ?
            addressDetails.firstName + ' ' + addressDetails.middleName + ' ' + addressDetails.lastName :
            addressDetails.firstName + ' ' + addressDetails.lastName;
        var saveAddressRequest = {
            id: null,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            addressLine1: addressDetails.addressLine1,
            addressLine2: addressDetails.addressLine2,
            addressLine3: addressDetails.addressLine3,
            addressLine4: addressDetails.addressLine4,
            shipToName: name || addressDetails.name,
            city: addressDetails.city,
            stateId: addressDetails.stateId,
            countryId: addressDetails.countryId,
            postalCode: addressDetails.postalCode || addressDetails.zip,
            contactTypeID: 1,
            defaultAddress: false,
            addressVerified: addressDetails.addressVerified,
            addressTypeId: 40,
            loggedInUserId: this.memberInfo.userId,
            responseCodes: addressDetails.responseCodes ? addressDetails.responseCodes : null,
            phone: addressDetails.phone,
            phoneNumber: addressDetails.phone,
            firstName: addressDetails.firstName,
            lastName: addressDetails.lastName,
            middleName: addressDetails.middleName,
            type: addressDetails.type,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse
        };
        this._orderService.saveVerifiedAddress(saveAddressRequest).subscribe(function (response) {
            if (response && response.addressDetail) {
                _this.verifiedShippingAddressId = response.addressDetail.id;
                _this.address = addressDetails;
                _this.address.phone = _this.address.phoneNumber;
                _this.address.id = response.addressDetail.id;
                _this.orderFormGroup.controls['shippingAddressId'].setValue(response.addressDetail.id, { onlySelf: true });
                _this.savedAddressId = response.addressDetail.id;
                if (saveAddressRequest.saveForFutureUse) {
                    _this.messageService.setAddressSaved(true);
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(false);
                }
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order. Unable to Save Member Address');
            _this._commonService.createNotification('', notification.value, 'error');
        });
    };
    OrderEditComponent.prototype.reEnterShippingAddress = function () {
        this.orderFormGroup.get('shippingAddressForm').reset();
        this.updateShippingAddressFormValidations(true);
    };
    // endregion
    // region #Start ShipMethods Section
    /**
       * on Shipping Method Change
       */
    OrderEditComponent.prototype.selectShippingMethod = function (shippingMethod, isTaxCalculated) {
        var _this = this;
        if (this.isOrderFormLoad && this.orderInformation.orderShippings.length > 0) {
            var shipmethodId = this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP
                ? this.orderInformation.orderShippings[0].shipMethodId.toString() : this.orderInformation.orderShippings[0].shipMethodId;
            this.orderFormGroup.controls['shipMethodId'].setValue(shipmethodId);
        }
        if (!this.isOrderSessionInfo && this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
            var option = this.selectEnum.firstOption.toString();
            if (this.isOrderFormLoad) {
                if (this.orderInformation && this.orderInformation.orderShippings && this.orderInformation.orderShippings.length > 0) {
                    if (this.orderInformation.orderShippings[0].shippingWaived) {
                        var waiverPercentage = this.orderInformation.orderShippings[0].shippingWaiverPercentage;
                        this.orderFormGroup.controls['shippingCostPercentage'].setValue(waiverPercentage);
                        option = waiverPercentage > 0 ? this.selectEnum.thirdOption.toString() : this.selectEnum.secondOption.toString();
                    }
                }
            }
            this.orderFormGroup.controls['shippingCostSelector'].setValue(option);
            this.shippingCostChange(false, true);
        }
        this.isRestrictedProduct = false;
        if (shippingMethod) {
            if (shippingMethod.pickUpLocation && this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) {
                this.orderFormGroup.controls['shippingCostPercentage'].setValue(0);
                this.shippingCost = this.orginalShippingCost;
                this.orderFormGroup.controls['originalShippingCost'].setValue(this.orginalShippingCost);
                var productRestrictionModel = this.prepareProductRestrictionModelRequest(shippingMethod.pickUpLocation);
                this.shipMethod = shippingMethod;
                this._commonService.getProductRestrictions(productRestrictionModel).subscribe(function (response) {
                    if (response && response.success && response.productModels) {
                        _this.isRestrictedProduct = true;
                        _this.getRestrictedProducts(response.productModels);
                    }
                    else {
                        _this.taxCalculationStatus = true;
                        _this.showSelectedShipMethod = true;
                        _this.importFeeValue = _this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, _this.storeInfo);
                        if (_this.isOrderSessionInfo) {
                            _this.shippingCost = _this.orderSession.shippingCostValue || 0;
                            _this.shippingTax = _this.orderSession.shippingTax || 0;
                        }
                        else if (_this.isOrderFormLoad) {
                            _this.shippingCost = _this.orderInformation.shippingCost || 0;
                            _this.shippingTax = _this.orderInformation.shippingTax || 0;
                            _this.orderFormGroup.patchValue({
                                shippingCost: _this.shippingCost.toFixed(2)
                            });
                        }
                        else {
                            _this.shippingCost = shippingMethod.shippingCharge || 0;
                            _this.shippingTax = shippingMethod.shippingTax || 0;
                            _this.orderFormGroup.patchValue({
                                shippingCost: _this.shippingCost.toFixed(2)
                            });
                        }
                        _this.orginalShippingCost = shippingMethod.shippingCharge;
                        _this.orderFormGroup.patchValue({
                            originalShippingCost: shippingMethod.shippingCharge.toFixed(2)
                        });
                        if (!isTaxCalculated) {
                            _this.calculateOrderTax();
                        }
                    }
                });
            }
            else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, this.storeInfo);
                if (this.isOrderSessionInfo) {
                    this.shippingCost = this.orderSession.shippingCostValue || 0;
                }
                else if (this.isOrderFormLoad) {
                    /* Logic changes for CSP-817: CSP- Shipping tax is not calculating for the retail order placed
                        from Shop portal when we view the orders in the CSP */
                    this.shippingCost = this.orderInformation.shippingCost || 0;
                    this.shippingTax = this.orderInformation.shippingTax || 0;
                    this.orderFormGroup.patchValue({
                        shippingCost: this.shippingCost.toFixed(2),
                    });
                }
                else {
                    this.shippingCost = shippingMethod.shippingCharge || 0;
                    this.shippingTax = shippingMethod.shippingTax || 0;
                    this.orderFormGroup.patchValue({
                        shippingCost: this.shippingCost.toFixed(2)
                    });
                }
                this.originalShippingTax = this.shippingTax || 0;
                this.orginalShippingCost = this.memberInfo && this.memberInfo.vatRegistered ? this.shippingCost
                    : (this.appConfig.calculateShippingWithTax) ? this.shippingCost + this.originalShippingTax : this.shippingCost;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this._currencyPipe.getFormatedCurrency(this.orginalShippingCost || 0, this.storeInfo),
                    originalShippingTax: shippingMethod.shippingTax
                });
                if (!isTaxCalculated) {
                    this.calculateOrderTax();
                }
            }
        }
        // if (!isTaxCalculated && this.orderFormGroup.value.deliveryPreference ===  ShippingType.DELIVERY) {
        //     this.calculateOrderTax();
        // }
    };
    /**
     * @description To Show Shipping Restriction Error message
     * @date 2019-08-01
     * @private
     * @returns {string}
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.getShippingRestrictionError = function () {
        var _this = this;
        if (this.shippingAddressInfo
            && this.shippingAddressInfo.stateCode && this.shippingAddressInfo.countryId && this.states && this.states.length > 0) {
            var stateName = this.states.find(function (x) { return x.stateCode === _this.shippingAddressInfo.stateCode; }).stateName;
            var error = this._translatePipe.get('order.' + Translations.SHIPPING_RESTRICTION_ERROR, { stateName: stateName });
            this.productErrorMsg = error.value;
        }
        else {
            var error = this._translatePipe.get('order.Following products are not allowed for selected shipping address.');
            this.productErrorMsg = error.value;
        }
        return this.productErrorMsg;
    };
    /**
     * @description this method used for preparing product restriction odel request for pickup
     */
    OrderEditComponent.prototype.getProcuctRestrictions = function (pickupAddress) {
        var _this = this;
        var productRestrictionModel = this.prepareProductRestrictionModelRequest(pickupAddress);
        this._commonService.getProductRestrictions(productRestrictionModel).subscribe(function (response) {
            if (response && response.success && response.productModels) {
                _this.getRestrictedProducts(response.productModels);
            }
        });
    };
    /**
     * @description this method used for preparing product restriction odel request for pickup
     */
    OrderEditComponent.prototype.prepareProductRestrictionModelRequest = function (pickupAddress) {
        var productRestrictionModel;
        productRestrictionModel = {
            countryCode: pickupAddress.countryCode,
            stateCode: pickupAddress.stateCode
        };
        var productModel = [];
        if (this.products && this.products && this.products.length > 0) {
            this.products.forEach(function (item) {
                productModel.push({ itemNumber: item.itemNumber });
            });
        }
        productRestrictionModel.productModels = productModel;
        return productRestrictionModel;
    };
    OrderEditComponent.prototype.getShippingCost = function (isTaxCalculated) {
        if (!isTaxCalculated) {
            this.calculateOrderTax();
        }
    };
    /**
     * Get Ship Methods By Products and Store
     */
    OrderEditComponent.prototype.getShipMethods = function () {
        var _this = this;
        var items;
        this.taxCalculationStatus = true;
        this.shippingMethods = [];
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.showSelectedShipMethod = false;
        this.shipMethodValidation = null;
        this.restrictedProducts = [];
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
            this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValue('');
        }
        if (this.memberInfo && this.storeInfo && this.products && this.products.length > 0
            && (this.shippingAddressInfo || (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP || this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP))) {
            var shippingOptions_1 = {
                productModels: this.getProductModels(),
                orderSourceId: OrderSourceType.Web,
                languageCode: this.languageCode,
                orderTypeId: ShippingOrderType.Personal,
                fromAddress: this.getWarehouseAddress(),
                // toAddress: this.orderFormGroup.value.deliveryPreference ===
                //     this.deliveryPreference.DELIVERY ? this.getShippingAddress() : {},
                toAddress: this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY ? this.getShippingAddress() :
                    (this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) ? this.getPudoDropShipPersonAddress(this.selectedPudoCollectionPoint) : {},
                storeId: this.storeInfo.id,
                requestID: 2,
                memberTypeId: (this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR || this.memberInfo.memberTypeId === MemberTypeEnum.FPC)
                    ? ShippingMemberType.DISTRIBUTOR : ShippingMemberType.RETAIL,
                priceTypeId: this.getPriceTypeId(),
                memberLevelId: (this.orderInformation && this.orderInformation.memberLevelId === MemberLevel.PREFERREDCUSTOMER) ? ShippingMemberTitle.NOVUS : ShippingMemberTitle.ASSISTANTMANAGER,
                orderSubTotal: this.subTotal,
                orderCaseCredits: this.totalCommissionableVolume,
                purchaseFlowId: this.getPurchaseFlowId(),
                shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
                    this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY : (this.orderFormGroup.value.deliveryPreference ===
                    this.deliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) ? ShippingType.DROPSHIP : ShippingType.PICKUP,
                storeHomeCountryCode: this.selectedIsoCountryCode,
                vatInclusive: this.memberInfo && this.memberInfo.vatRegistered == true ? this.memberInfo.vatRegistered : false,
                initialOrder: false,
                vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
                bwpEnabled: this.isBWPEnabledMember && this.isBWPEnabledProduct && this.storeInfo && this.storeInfo.bwpEnabled ? true : false
            };
            //order source only for AUT && DEU Country
            if (this.shippingAddressInfoConfig.sendSourceToShippingOptions) {
                shippingOptions_1.source = this.orderInformation && this.orderInformation.source === Source.Customer_Service ? Source.CSP : this.orderInformation.source;
            }
            this._orderService.getShipmentService(shippingOptions_1).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    _this.shipMethods = response;
                    _this.shippingMethods = response.shippingMethods;
                    _this.importFeeEnabled = response.importFeeEnabled;
                    if (_this.shippingMethods.length > 0) {
                        _this.shippingMethods.forEach(function (shipMethod) {
                            shipMethod.shippingCharge = shipMethod.shippingCharge - shipMethod.shippingTax;
                            shipMethod.shippingCharge = _this._currencyPipe.getFormatedCurrency(shipMethod.shippingCharge, _this.storeInfo);
                            shipMethod.importFeeEnabled = response.importFeeEnabled;
                        });
                        if (_this.isOrderSessionInfo && !_this.isOrderFormLoad) {
                            _this.orderFormGroup.patchValue({
                                shippingCostSelector: _this.orderSession.shippingCostSelector,
                                originalShippingCost: _this.orderSession.originalShippingCost ? parseFloat(_this.orderSession.originalShippingCost).toFixed(2) : 0,
                                shipMethodId: _this.orderSession.shipMethodId,
                                shippingCost: _this.orderSession.shippingCost ? parseFloat(_this.orderSession.shippingCost).toFixed(2) : 0,
                                shippingCostPercentage: _this.orderSession.shippingCostPercentage,
                                isShippingDiscountApplied: _this.orderSession.isShippingDiscountApplied
                            });
                            var shipMethodId_1 = _this.orderFormGroup.value.shipMethodId;
                            if (shipMethodId_1 && _this.shippingMethods) {
                                var shippingObj = _this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +shipMethodId_1; })[0];
                                if (shippingObj) {
                                    _this.shippingCost = shippingObj.shippingCharge;
                                    _this.selectShippingMethod(shippingObj, false);
                                    _this.getShippingCost(true);
                                    //this.calculateOrderTax();
                                }
                            }
                            _this.getShippingCost();
                        }
                        else if (_this.isOrderFormLoad || (_this.orderInformation && _this.orderInformation.orderShippings.length > 0
                            && _this.orderInformation.orderShippings[0].shipMethodId)) {
                            if (_this.orderInformation.orderShippings.length > 0) {
                                var shipmethodId = _this.orderFormGroup.value.deliveryPreference
                                    === ShippingType.PICKUP ? _this.orderInformation.orderShippings[0].shipMethodId.toString()
                                    : _this.orderInformation.orderShippings[0].shipMethodId;
                                _this.orderFormGroup.controls['shipMethodId'].setValue(shipmethodId);
                            }
                            var shippingMethodId_1 = (+_this.orderFormGroup.value.shipMethodId);
                            if (shippingMethodId_1 && _this.shippingMethods) {
                                var shippingObj = _this.shippingMethods.filter(function (shipMethod) {
                                    return shipMethod.shippingMethodId === shippingMethodId_1;
                                })[0];
                                if (shippingObj) {
                                    _this.shippingCost = shippingObj.shippingCharge;
                                    _this.selectShippingMethod(shippingObj, false);
                                    _this.getShippingCost(true);
                                    //this.calculateOrderTax();
                                }
                                else {
                                    _this.orderFormGroup.controls['shipMethodId'].setValue(_this.shippingMethods[0].shippingMethodId);
                                    _this.selectShippingMethod(_this.shippingMethods[0], false);
                                    _this.getShippingCost(true);
                                    //this.calculateOrderTax();
                                }
                            }
                        }
                        else {
                            _this.orderFormGroup.patchValue({
                                shippingCost: 0,
                                originalShippingCost: 0,
                                shippingCostPercentage: 0,
                                isShippingDiscountApplied: false,
                                originalShippingTax: 0
                            });
                            if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                _this.orderFormGroup.controls['shipMethodId'].setValue(_this.shippingMethods[0].shippingMethodId.toString());
                            }
                            else if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
                                _this.orderFormGroup.controls['shipMethodId'].setValue(_this.shippingMethods[0].shippingMethodId.toString());
                            }
                            else {
                                _this.orderFormGroup.controls['shipMethodId'].setValue(_this.shippingMethods[0].shippingMethodId);
                            }
                            _this.selectShippingMethod(_this.shippingMethods[0]);
                        }
                        _this.isOrderFormLoad = false;
                        _this.orderSession = null;
                        _this.isOrderSessionInfo = false;
                    }
                }
                else if (response && response.productModels && response.productModels.length > 0) {
                    _this.getRestrictedProducts(response.productModels);
                }
                else if (response && response.validations.length > 0) {
                    _this.shipMethodValidation = response.validations[0];
                }
                if (_this.isDropShipOptionExist && !_this.pudoShippingMethod) {
                    _this.getDropShipPudoShippingMethods(shippingOptions_1, response.shippingMethods, false);
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to fetch Ship Methods');
                _this._commonService.createNotification('', notification.value, 'error');
            });
        }
        else {
            this.orderFormGroup.patchValue({
                shippingCost: 0,
                originalShippingCost: 0,
                shippingCostPercentage: 0,
                isShippingDiscountApplied: false,
                originalShippingTax: 0
            });
        }
    };
    /** Products
    * @returns Products
    */
    OrderEditComponent.prototype.getProductModels = function () {
        var productModels = [];
        if (this.products && this.products.length > 0) {
            for (var index = 0; index < this.products.length; index++) {
                var product = this.products[index];
                if (product) {
                    var productModel = {
                        productID: product.id,
                        productHeight: product.shipping ? product.shipping.height : 0,
                        productWeight: product.shipping ? product.shipping.weight : 0,
                        productQuantity: product.quantity,
                        productLength: product.shipping ? product.shipping.length : 0,
                        productWidth: product.shipping ? product.shipping.width : 0,
                        wholesalePrice: product.wholesalePrice,
                        sellingPrice: product.applicablePrice,
                        isOrderLiteratureOnly: product.literature,
                        retailPrice: product.retailPrice,
                        weightMetricId: ProductWeightMetric.KGS,
                        isShippable: product.shipping ? product.shipping.shippingRequired : 0,
                        itemNumber: product.itemNumber
                    };
                    productModels.push(productModel);
                }
            }
        }
        return productModels;
    };
    /**
     * Add products on load
     */
    OrderEditComponent.prototype.getProducts = function () {
        var productsIds = [];
        if (this.isOrderSessionInfo) {
            this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
            this.validationsOnDeliveryPreference();
            productsIds = this.orderSession.products.map(function (product) { return product.productId; });
            if (productsIds.length > 0) {
                this.getProductsByIds(productsIds);
            }
            else {
                this.getMemberAddressByMemberId(this.memberInfo.memberId, this.currentCountryObj.countryId);
                this.deliveryPreferenceOnChange();
            }
        }
        else {
            var productLineItems = this.orderInformation && this.orderInformation.orderLineItems.filter(function (item) {
                return item.lineItemTypeId != OrderLineItemTypeEnum.CHILD_PRODUCT;
            });
            this.orderInformation.orderLineItems = productLineItems;
            productsIds = this.orderInformation && this.orderInformation.orderLineItems.map(function (product) { return product.productId; });
            this.getProductsByIds(productsIds);
        }
    };
    /**
     * get products by Ids
     */
    OrderEditComponent.prototype.getProductsByIds = function (productsIds) {
        var _this = this;
        var wholesaleQualified = this.orderInformation ? this.orderInformation.wholesaleQualified : false;
        if (wholesaleQualified == null) {
            wholesaleQualified = false;
        }
        var memberTitleId = this.orderInformation && this.orderInformation.memberLevelId
            ? this.orderInformation.memberLevelId : this.memberInfo.memberTitleId;
        var fpc5percentEnabled = false;
        if (this.appConfig) {
            fpc5percentEnabled = this.appConfig.fpc5PercentEnabled;
        }
        var isEnrollment = (this.orderInformation && this.orderInformation.orderTypeId === PurchaseFlow.Enrollment) ? true : false;
        var purchaseFlowType;
        if (isEnrollment) {
            purchaseFlowType = PurchaseFlows.ENROLLMENT;
        }
        else {
            purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5percentEnabled, isEnrollment, memberTitleId);
        }
        var optin = (this.orderInformation && this.orderInformation.optIn) ? this.orderInformation.optIn : false;
        this._orderService.getProductsByIds(productsIds, this.storeDefaultLanguage, this.storeInfo.id, memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, this.storeInfo.taxInclusive, true).subscribe(function (response) {
            if (response && !response.status && response.length > 0) {
                _this.checkLoadedProducts(productsIds, response);
                _this.deliveryPreferenceOnChange();
                _this.getMemberAddressByMemberId(_this.memberInfo.memberId, _this.currentCountryObj.countryId);
            }
            else if (response && response.status === 204 && productsIds && productsIds.length) {
                _this.checkLoadedProducts(productsIds);
                _this.deliveryPreferenceOnChange();
                _this.getMemberAddressByMemberId(_this.memberInfo.memberId, _this.currentCountryObj.countryId);
            }
        });
    };
    /**
     * @description get wholesale property
     * @date 2019-06-24
     * @returns {boolean}
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.getWholeSaleQualified = function () {
        if (this.orderInformation && this.orderInformation.priceTierId !== PriceTier.RETAIL
            && this.orderInformation.priceTierId !== PriceTier.NEWDST) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Decrement the item Quantity
     * @returns void
     */
    OrderEditComponent.prototype.decrementQuantity = function (index) {
        this.taxCalculationStatus = true;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            this.orderFormGroup.markAsDirty();
            this.updateTotalsAndShipMethod();
        }
    };
    /**
    * Increment the item Quantity
    * @returns void
    */
    OrderEditComponent.prototype.incrementQuantity = function (index) {
        this.taxCalculationStatus = true;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            var product = items.controls[index].controls['productItem'].value;
            if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock || !product.stockAvailable)
                && !(product.stockAvailable && !product.manageStock)) {
                var cartStockErrors = this._translatePipe.get('stockError.No Stock Available');
                this._commonService.createNotification('', cartStockErrors.value, 'error');
                items.controls[index].controls['disableIncrement'].setValue(true);
            }
            else {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            items.controls[index].controls['quantity'].updateValueAndValidity();
            this.orderFormGroup.markAsDirty();
            this.updateTotalsAndShipMethod();
        }
    };
    OrderEditComponent.prototype.quantityChange = function (event, index) {
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    };
    /**
    * @param  {number} index
    * @returns void
    */
    OrderEditComponent.prototype.updateQuantity = function (event, index) {
        if (!this.isRestrictionPopupOpened) {
            var items = this.orderFormGroup.get('items');
            if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
                if (items.controls[index].controls['quantity'].value > 1 ||
                    (event.target.value && parseInt(event.target.value, 10))) {
                    var product = items.controls[index].controls['productItem'].value;
                    if (product && event.target.value > product.stockQuantity && product.manageStock) {
                        items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                        var cartStockErrors = this._translatePipe.get('stockError.No Stock Available');
                        this._commonService.createNotification('', cartStockErrors.value, 'error');
                        items.controls[index].controls['disableIncrement'].setValue(true);
                    }
                    else {
                        items.controls[index].controls['quantity'].setValue(event.target.value);
                        items.controls[index].controls['disableIncrement'].setValue(false);
                    }
                    this.orderFormGroup.markAsDirty();
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod();
                }
                this.isFocused = false;
            }
        }
    };
    /**
     * @description open/close when restricted products shown
     * @date 2019-08-07
     * @param {boolean} isOpen
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.restrictionPopupOpen = function (isOpen) {
        this.isRestrictionPopupOpened = isOpen;
    };
    /**
     * @returns void
     */
    OrderEditComponent.prototype.deleteItem = function (index) {
        var _this = this;
        var items = this.orderFormGroup.get('items');
        var productQuantity = +items.controls[index].controls['quantity'].value;
        if (items && items.length > 0) {
            if (this.productAssociationInfo) {
                var depositFeeEnabledCount = this._commonService.depositFeeEnabledProducts(items);
                var productId_1 = items.value[index].productId;
                var parentProduct_1 = this.productAssociationInfo.find(function (x) { return x.productId === productId_1; });
                if (parentProduct_1) {
                    // remove the parent product
                    items.removeAt(index);
                    var depositFeeProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === parentProduct_1.depositFeeProductId; });
                    if (depositFeeEnabledCount > 1) {
                        if (depositFeeProductIndex > -1) {
                            var depositFeeProductQuantity = +items.value[depositFeeProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - productQuantity;
                            if (depositFeeProductQuantity > 0) {
                                items.value[depositFeeProductIndex].quantity = depositFeeProductQuantity;
                                items.setValue(items.value);
                            }
                            else {
                                items.removeAt(depositFeeProductIndex);
                            }
                        }
                    }
                    else {
                        if (depositFeeProductIndex > -1) {
                            items.removeAt(depositFeeProductIndex);
                        }
                    }
                }
                else {
                    items.removeAt(index);
                }
            }
            else {
                items.removeAt(index);
            }
        }
        setTimeout(function () {
            if (_this.addItemInput && _this.addItemInput.nativeElement) {
                _this.addItemInput.nativeElement.focus();
            }
        }, 500);
        this.updateTotalsAndShipMethod();
        //New logic to bind promtoion product from promotion engine
        var freeProductsInfo = this.validatePromotionCriteria(items);
        var productIds = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
        if (productIds && productIds.length) {
            this.addPromotionEngineProducts(productIds, freeProductsInfo);
        }
        this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
        this.updateTotalsAndShipMethod();
    };
    /**
     * To Get Promotion Product details and bind it to order line items
     * @param productIds
     */
    OrderEditComponent.prototype.addPromotionEngineProducts = function (productIds, freeProductsInfo) {
        var _this = this;
        var items = this.orderFormGroup.get('items');
        var wholesaleQualified = this.orderInformation ? this.orderInformation.wholesaleQualified : false;
        if (wholesaleQualified == null) {
            wholesaleQualified = false;
        }
        // const notification: any = this._translatePipe.get('order.Invalid Item Number');
        var fpc5percentEnabled = false;
        if (this.appConfig) {
            fpc5percentEnabled = this.appConfig.fpc5PercentEnabled;
        }
        var isEnrollment = (this.orderInformation && this.orderInformation.orderTypeId === PurchaseFlow.Enrollment) ? true : false;
        var purchaseFlowType;
        var memberTitleId = this.memberInfo ? this.memberInfo.memberTitleId : null;
        if (isEnrollment) {
            purchaseFlowType = PurchaseFlows.ENROLLMENT;
        }
        else {
            purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5percentEnabled, isEnrollment, memberTitleId);
        }
        if (items && items.length >= 0) {
            this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, this.memberInfo.memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, false, false, this.storeInfo.taxInclusive).subscribe(function (products) {
                if (products && products.length > 0) {
                    products.forEach(function (product) {
                        var freeProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === product.id; });
                        if (items && items.length >= 0 && freeProductIndex < 0) {
                            var currentFreeProduct = freeProductsInfo.find(function (freeProduct) { return freeProduct.productId === product.id; });
                            var stockQuantity = _this._commonService.stockQuantityCheck(product, currentFreeProduct);
                            if (stockQuantity.currentFreeProductQuantity > 0) {
                                _this.addItemNumber();
                                var index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (currentFreeProduct.promotionId && currentFreeProduct.promotionId.length > 0) {
                                    currentFreeProduct.promotionId.forEach(function (promotionId) {
                                        if (_this.promotionIds.indexOf(promotionId) == -1) {
                                            _this.promotionIds.push(promotionId);
                                        }
                                    });
                                }
                                currentFreeProduct.quantity = stockQuantity.currentFreeProductQuantity;
                                items = _this._commonService.addPromoItem(items, index, product, environment.uiTemplateBaseUrl, environment.cdnURL);
                                var productItem = items.controls[index].controls['productItem'].value;
                                productItem.orderPromotionTrackings = stockQuantity.orderPromotionTrackings;
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(currentFreeProduct.quantity);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                productItem.quantity = currentFreeProduct.quantity;
                                items.controls[index].controls['productItem'].setValue(productItem);
                            }
                        }
                    });
                    _this.updateTotalsAndShipMethod();
                }
            });
        }
    };
    /**
     * Validate Promotions based on all criteria
     * @param product
     * @returns
     */
    OrderEditComponent.prototype.validatePromotionCriteria = function (product) {
        var items = this.orderFormGroup.get('items');
        var freeProductsInfo = [];
        if (this.promotionModels && this.promotionModels.length > 0) {
            this._commonService.setSubTotalAndOrderCC(this.subTotal, this.totalCommissionableVolume, this.countryTaxInclusive);
            this._commonService.validateOrderCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderSubTotalCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderCCCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductAtQuantityCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateMultipleProductCriteria(this.promotionModels, freeProductsInfo, items);
        }
        return this._commonService.removeDuplicates(freeProductsInfo);
    };
    OrderEditComponent.prototype.confirm = function (index) {
        if (index === 0 || index > 0) {
            this.deleteItem(index);
        }
    };
    OrderEditComponent.prototype.addItemNumber = function () {
        this.items = this.orderFormGroup.get('items');
        this.items.push(this.createItemNumberGroup());
    };
    // endregion
    // region #Start Common Methods Section
    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    OrderEditComponent.prototype.clearForm = function () {
        this.items = [];
        this.getOrderDetails();
        this.isOrderFormLoad = true;
        this.verifiedBillingAddressId = 0;
        this.verifiedShippingAddressId = 0;
    };
    /**
     * disabling Submit button
     */
    OrderEditComponent.prototype.disableSubmitButton = function () {
        this.taxCalculationStatus = true;
    };
    /**
     * update Totals and ShipMethod
     */
    OrderEditComponent.prototype.updateTotalsAndShipMethod = function () {
        this.orderLevelDiscount = 0;
        this.taxCalculationStatus = true;
        this.subTotal = 0;
        this.retailSubTotal = 0.0;
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.itemCount = this.shoppingCartCount;
        }
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
            var _loop_1 = function (index) {
                var product = items.controls[index].controls['productItem'].value;
                var quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    var existProduct_1 = this_1.products.filter(function (productObj) { return productObj.id === product.id; })[0];
                    if (!existProduct_1) {
                        product.quantity = quantity;
                        this_1.products.push(product);
                    }
                    else {
                        var productIndex = this_1.products.findIndex(function (item) { return item.id === existProduct_1.id; });
                        this_1.products[productIndex].quantity = this_1.products[productIndex].quantity + quantity;
                    }
                    var shippingAddress_1 = this_1.getShippingAddress();
                    if (shippingAddress_1 && shippingAddress_1.countryId && this_1.countries && this_1.countries.length > 0) {
                        var country = this_1.countries.find(function (x) { return x.countryId === shippingAddress_1.countryId; });
                        this_1.countryTaxInclusive = this_1.getCountryTaxInclusiveInfo(country);
                    }
                    var isEnableVATCalculation = this_1.appConfig && this_1.appConfig.enableVATCalculation;
                    var taxCalculated = this_1.appConfig.displayTaxInclusivePrice ? false : true;
                    this_1.displayPriceConfig = this_1._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this_1.storeInfo.taxInclusive, this_1.memberInfo, taxCalculated, this_1.countryTaxInclusive, this_1.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                    var price = this_1.countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    if (this_1.displayPriceConfig) {
                        price = this_1.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (this_1.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice : product.catalogPrice);
                    }
                    if (product.bwpEnableProduct && this_1.isBWPEnabledMember && this_1.storeInfo && this_1.storeInfo.bwpEnabled) {
                        var subTotalprice = price * +quantity;
                        this_1.orderLevelDiscount = this_1.orderLevelDiscount + ((subTotalprice * 5) / 100);
                    }
                    this_1.subTotal = this_1.subTotal + (price * +quantity);
                    this_1.retailSubTotal = this_1.retailSubTotal + (product.retailPrice * +quantity);
                    this_1.totalCommissionableVolume = this_1.totalCommissionableVolume + (product.commissionableVolume * +quantity);
                    this_1.total = this_1.taxableAmount + (+this_1.shippingCost) + this_1.subTotal + this_1.importFeeValue;
                    this_1.shoppingCartCount += +product.quantity;
                }
            };
            var this_1 = this;
            for (var index = 0; index < items.length; index++) {
                _loop_1(index);
            }
            if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
                this.itemCount = this.shoppingCartCount - this.itemCount;
            }
            else {
                this.itemCount = this.shoppingCartCount;
            }
            if (this.orderFormGroup.value.backDateOrder) {
                this.getMemberOrderRules(this.memberInfo, true);
            }
            else {
                this.getMemberOrderRules(this.memberInfo, false);
            }
            this.validateThreshold();
            this.validateOrderLimit(true);
            this.getShipMethods();
        }
        else {
            !this.isOrderSessionInfo && !this.isOrderFormLoad ? this.getShipMethods() : '';
        }
    };
    // endregion
    /**
     * Selected Shipping Address
     */
    OrderEditComponent.prototype.getShippingAddress = function () {
        var shippingAddressdata = null;
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            this.shippingAddressInfo = this.pudoShippingAddressInfo;
        }
        else if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.shippingAddressInfo = this.pudoShippingAddressInfo;
        }
        else {
            shippingAddressdata = this.shippingAddressInfo;
        }
        if (this.shippingAddressInfo) {
            var shippingAddress = {
                addressLine1: this.shippingAddressInfo.addressLine1,
                addressLine2: this.shippingAddressInfo.addressLine2,
                addressLine3: this.shippingAddressInfo.addressLine3,
                addressLine4: this.shippingAddressInfo.addressLine4,
                city: this.shippingAddressInfo.city || null,
                state: this.shippingAddressInfo.stateName,
                stateCode: this.shippingAddressInfo.stateCode,
                countryCode: this.shippingAddressInfo.countryCode,
                country: this.shippingAddressInfo.countryName,
                postalCode: this.shippingAddressInfo.postalCode ? this.shippingAddressInfo.postalCode.toUpperCase() : null,
                zip: this.shippingAddressInfo.postalCode ? this.shippingAddressInfo.postalCode.toUpperCase() : null,
                countryId: this.shippingAddressInfo.countryId,
                stateId: this.shippingAddressInfo.stateId,
                name: this.shippingAddressInfo.shipToName,
                addressType: this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP ? AddressType.PICKUP_PERSON : AddressType.SHIPPING,
                phone: this.shippingAddressInfo.phone ? this.getValidPhoneNumber(this.shippingAddressInfo.phone) : null,
                countryCodeTwo: this.selectedCountryCodeTwo,
                addressVerified: this.shippingAddressInfo.addressVerified,
                firstName: this.shippingAddressInfo.firstName,
                middleName: this.shippingAddressInfo.middleName,
                lastName: this.shippingAddressInfo.lastName,
                phoneType: this.shippingAddressInfo.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction: this.shippingAddressInfo.deliveryInstruction,
                email: this.shippingAddressInfo.email ? this.shippingAddressInfo.email : null
            };
            this.setShippingAddress = shippingAddress;
            return shippingAddress;
        }
    };
    OrderEditComponent.prototype.getValidPhoneNumber = function (phoneNumber) {
        if (phoneNumber && this.storeInfo && this.storeInfo.foreverDirectEnabled) {
            phoneNumber = phoneNumber.replace(/[a-zA-Z ]/g, '');
            if (phoneNumber.substring(0, 1) !== '+' && phoneNumber.substring(0, 2) !== '00') {
                phoneNumber = '+' + phoneNumber;
            }
        }
        else {
            phoneNumber = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        }
        return phoneNumber;
    };
    /**
* Selected Shipping Address
*/
    OrderEditComponent.prototype.getBillingAddress = function () {
        var _this = this;
        var countryId = 0;
        if (!this.billingAddressInfo) {
            this.billingAddressInfo = this.paymentComponentSettings.billingAddress || (this.shippingAddressInfo ? this.shippingAddressInfo : null);
        }
        if (this.countries && this.billingAddressInfo && !this.billingAddressInfo.countryId) {
            var countryList = this.countries.find(function (x) { return x.isocodeThree === _this.billingAddressInfo.countryCode; });
            if (countryList && countryList.length > 0) {
                countryId =
                    this.countries.find(function (x) { return x.isocodeThree === _this.billingAddressInfo.countryCode; }).countryId;
            }
        }
        var stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        var billingAddress = {
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2,
            addressLine3: this.billingAddressInfo.addressLine3,
            addressLine4: this.billingAddressInfo.addressLine4,
            city: this.billingAddressInfo.city || null,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            countryCode: this.billingAddressInfo.countryCode,
            country: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            zip: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            countryId: this.billingAddressInfo.countryId || countryId,
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            addressType: AddressType.BILLING,
            countryCodeTwo: this.selectedCountryCodeTwo
        };
        return billingAddress;
    };
    OrderEditComponent.prototype.getPickUpAddress = function () {
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            this.shipMethod.pickUpLocation.addressType = AddressType.PICKUP;
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, this.shipMethod.pickUpLocation.stateCode);
            if (countryObj) {
                this.shipMethod.pickUpLocation.countryId = countryObj.countryId;
                this.shipMethod.pickUpLocation.country = countryObj.isocodeThree ? countryObj.isocodeThree : '';
                this.shipMethod.pickUpLocation.countryCodeTwo = countryObj.isocodeTwo ? countryObj.isocodeTwo : '';
                this.shipMethod.pickUpLocation.countryCode = countryObj.isocodeThree ? countryObj.isocodeThree : '';
            }
            if (stateObj) {
                this.shipMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.shipMethod.pickUpLocation.name = this.shipMethod.pickUpLocation.pickupCenterName;
            this.shipMethod.pickUpLocation.postalCode = this.shipMethod.pickUpLocation.zip;
            this.setPickupAddress = this.shipMethod.pickUpLocation;
            return this.shipMethod.pickUpLocation;
        }
        else {
            return this.getWarehouseAddress();
        }
    };
    /**
     * Store Ware house Address
     */
    OrderEditComponent.prototype.getWarehouseAddress = function () {
        if (this.storeInfo && this.storeInfo.warehouseAddress) {
            var warehouseAddress = {
                addressLine1: this.storeInfo.warehouseAddress.addressLine1,
                addressLine2: this.storeInfo.warehouseAddress.addressLine2,
                addressLine3: this.storeInfo.warehouseAddress.addressLine3,
                addressLine4: this.storeInfo.warehouseAddress.addressLine4,
                city: this.storeInfo.warehouseAddress.city,
                state: this.storeInfo.warehouseAddress.stateCode,
                stateCode: this.storeInfo.warehouseAddress.stateCode,
                countryCode: this.storeInfo.warehouseAddress.countryCode,
                country: this.storeInfo.warehouseAddress.countryCode,
                postalCode: this.storeInfo.warehouseAddress.zipCode,
                zip: this.storeInfo.warehouseAddress.zipCode,
                countryId: this.storeInfo.warehouseAddress.countryId,
                stateId: this.storeInfo.warehouseAddress.stateOrProvinceId,
                name: null
            };
            return warehouseAddress;
        }
    };
    /**
     *
     * @param shippingMethod
     */
    OrderEditComponent.prototype.getShippingMethodWarehouseAddress = function () {
        if (this.shipMethod && this.shipMethod.warehouseAddress) {
            this.shipMethod.warehouseAddress.postalCode = this.shipMethod.warehouseAddress.zip;
            this.shipMethod.warehouseAddress.country = this.shipMethod.warehouseAddress.countryCode;
            return this.shipMethod.warehouseAddress;
        }
    };
    OrderEditComponent.prototype.getPurchaseFlowId = function () {
        if (this.memberTypeId === this.memberTypeEnums.GUEST || this.memberTypeId === this.memberTypeEnums.RETAIL) {
            return PurchaseFlowType.Retail;
        }
        else {
            return PurchaseFlowType.WholeSale;
        }
    };
    OrderEditComponent.prototype.getPriceTypeId = function () {
        if (this.memberTypeId === this.memberTypeEnums.GUEST || this.memberTypeId === this.memberTypeEnums.RETAIL) {
            return PriceType.RETAILPRICE;
        }
        else {
            return PriceType.WHOLESALEPRICE;
        }
    };
    OrderEditComponent.prototype.subscribeSaveAddress = function () {
        var _this = this;
        this.messageService.getAddressSaved().subscribe(function (data) {
            if (!_this.address) {
                _this.address = {};
            }
            _this.address.isSavedAddress = data;
        });
    };
    //#endregion---------------------payment section End using world pay-----------------------------------
    OrderEditComponent.prototype.updateOrder = function (url) {
        var _this = this;
        if (this.isCloneOrder) {
            this.calculateOrderTax();
        }
        var productRestrictionModel = this.prepareProductRestrictionModelRequest(this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP ? this.getPickUpAddress() : this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP ? this.getPudoDropShipPersonAddress(this.selectedPudoCollectionPoint) : this.getShippingAddress());
        if (productRestrictionModel) {
            this._commonService.getProductRestrictions(productRestrictionModel).subscribe(function (response) {
                if (response && response.success && response.productModels) {
                    _this.getRestrictedProducts(response.productModels);
                }
                else {
                    var items = _this.orderFormGroup.get('items');
                    var productids_1 = [];
                    items.value.forEach(function (element) {
                        productids_1.push(element.productId);
                    });
                    if (_this.validateEnteredAmount) {
                        if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                            _this.posStockAvailabilityCheck(productids_1, +_this.orderFormGroup.controls['shipMethodId'].value, url);
                        }
                        else {
                            _this.proceedUpdateOrder(url);
                        }
                    }
                }
            });
        }
        else {
            var items = this.orderFormGroup.get('items');
            var productids_2 = [];
            items.value.forEach(function (element) {
                productids_2.push(element.productId);
            });
            if (this.validateEnteredAmount) {
                if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                    this.posStockAvailabilityCheck(productids_2, +this.orderFormGroup.controls['shipMethodId'].value, url);
                }
                else {
                    this.proceedUpdateOrder(url);
                }
            }
        }
    };
    OrderEditComponent.prototype.proceedUpdateOrder = function (url) {
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        this.isUpdated = true;
        this.orderSubmitted = true;
        if (this.address && !this.address.isSavedAddress && this.orderFormGroup.value.saveForFutureUse) {
            this.saveAddress(this.getShippingAddress());
        }
        if (this.orderSubmitted) {
            this.constructPlaceOrderRequest(url);
        }
    };
    OrderEditComponent.prototype.posStockAvailabilityCheck = function (productIds, posLocationid, url) {
        var _this = this;
        var noStockItems = [];
        if (posLocationid && posLocationid > 0 && productIds && productIds.length > 0) {
            this._customerService.getProductsByLocation(posLocationid, productIds).subscribe(function (response) {
                var posProducts = response;
                if (posProducts && posProducts.length > 0) {
                    posProducts.forEach(function (pickUpProduct) {
                        var cartProduct = _this.orderFormGroup.value.items.find(function (product) { return product.productId === pickUpProduct.productId; });
                        if (cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity) {
                            cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                            noStockItems.push(cartProduct);
                        }
                    });
                }
                _this.outOfStockItems = noStockItems;
                if (_this.outOfStockItems && _this.outOfStockItems.length > 0) {
                    _this.outOfStockModal.open();
                }
                else {
                    _this.proceedUpdateOrder(url);
                }
            }, function (error) {
                var errorMessage = _this._translateService.get('common.Sorry, Something Went Wrong: Please try again later.');
                _this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            });
        }
    };
    OrderEditComponent.prototype.closeOutOfStockForm = function () {
        this.outOfStockModal.close();
        this.orderSubmitted = false;
    };
    OrderEditComponent.prototype.clearOutOfStockItems = function () {
        var items = this.orderFormGroup.get('items');
        if (this.outOfStockItems && this.outOfStockItems.length) {
            var productIds = this.outOfStockItems.map(function (product) { return product.productId; });
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.orderFormGroup.controls['moneyOrderAmount'].disable();
            this.orderFormGroup.controls['moneyOrderAmount'].setValue('');
            this.orderFormGroup.controls['enableStatus'].setValue(false);
            this.orderSubmitted = false;
            this.outOfStockModal.close();
        }
    };
    OrderEditComponent.prototype.removeOutOfStockItems = function (items, productIds) {
        productIds.forEach(function (id) {
            var productIndex = items.value.findIndex(function (product) { return product.productId === id; });
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    };
    /**
     * @description construct place order request
     * @date 2019-05-06
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.constructPlaceOrderRequest = function (url) {
        var requestUrl = '';
        if (url) {
            requestUrl = url;
        }
        else {
            requestUrl = ApiUrlConstants.orderApiUrl + '/V1/orders/' + this.webOrderId.toUpperCase();
        }
        if (this.unTouchedOrderRequest) {
            var modifiedOrderRequest = this.mapModifiedOrderResponse();
            var isOrderChanged = isEqual(modifiedOrderRequest, this.unTouchedOrderRequest);
            if ((isOrderChanged && !(this.orderStatusId.Failed == this.orderInformation.orderStatusId))
                && !this.orderFormGroup.value.backDateOrder && !this.orderFormGroup.controls['enableStatus'].value) {
                this.isUpdated = false;
                this.orderMessage.open();
            }
            else {
                this.placeOrder(requestUrl);
            }
        }
        else {
            this.placeOrder(requestUrl);
        }
        // For now commenting the changes need to do some changes as part of T10-8437
        // if (this.unTouchedOrderRequest && this.unTouchedOrderRequest.orderPayments
        //     && this.unTouchedOrderRequest.orderPayments.length > 0
        //     && this.unTouchedOrderRequest.orderPayments[0].paymentMode === PaymentMethodTypes.Money_order
        //     && this.orderFormGroup.controls['enableStatus'].value) {
        //    const modifiedOrderRequest = this.mapModifiedOrderResponse();
        //    const isOrderChanged = isEqual(modifiedOrderRequest, this.unTouchedOrderRequest);
        //     if (isOrderChanged) {
        //         const moneyOrderRequest: MoneyOrderRequest = {
        //             paymentStatusId: 5,
        //             orderId: this.orderInformation && this.orderInformation.orderPayments
        //              && this.orderInformation.orderPayments.length > 0 ? this.orderInformation.orderPayments[0].orderId : null,
        //             paymentType: PaymentMethodTypes.Money_order,
        //             notes: ''
        //         };
        //         this._orderService.processMoneyOrder(this.webOrderId, moneyOrderRequest).subscribe((response) => {
        //             if (response) {
        //                 let orderLog;
        //                 const paymentInfo = this.getOrderPaymentInfo();
        //                 if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Money_order
        //                     && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
        //                     orderLog = 'Money Order funds $' + this.orderFormGroup.controls['moneyOrderAmount'].value
        //                      + this.storeInfo.currencyCode + ' are received.';
        //                 }
        //                 const notification: any = this._translatePipe.get('order.Order Updated successfully');
        //                 this._commonService.createNotification('', notification.value, 'success');
        //                 this.orderSubmitted = false;
        //                 this.orderFormGroup.controls['backDateOrder'].setValue(false);
        //                 const updatedOrderInfo = {
        //                     webOrderId: this.webOrderId ? this.webOrderId.toUpperCase() : null,
        //                     countryCode: this.selectedIsoCountryCode
        //                 };
        //                 this._cacheService.set('UpdatedOrderInfo', updatedOrderInfo);
        //                 this.router.navigate(['/customerservice/orders']);
        //                 this.createOrderLog(orderLog);
        //             } else {
        //                 const notification: any = this._translatePipe.get('order.Unable to Update Order');
        //                 this._commonService.createNotification('', notification.value, 'error');
        //             }
        //         }, (error: any) => {
        //             const notification: any = this._translatePipe.get('order.Unable to Update Order');
        //             this._commonService.createNotification('', notification.value, 'error');
        //             this.isUpdated = false;
        //         });
        //     } else {
        //         this.placeOrder(requestUrl);
        //     }
        // } else {
        //     this.placeOrder(requestUrl);
        // }
    };
    OrderEditComponent.prototype.validateThreshold = function () {
        var totalPoints = this.calculateTotalPoints();
        var subTotal = this.calculateItemsSubTotal(this.storeInfo);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            totalPoints <= this.orderRules.maxValue) {
            this.thresholdCrossed = false;
        }
        else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
            subTotal <= this.orderRules.maxValue) {
            this.thresholdCrossed = false;
        }
        else if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            var totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            var details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC);
            this.thresholdCrossed = details.thresholdCrossed;
            this.memberCCLimitExceeded = details.monthlyCCValid;
            this.monthlyCCValue = details.monthlyCCValue;
        }
        else {
            this.thresholdCrossed = true;
        }
        // Monthly CC override for member
        if (this.memberCCOverride && this.memberCCOverride.overrideFlag && this.memberOrderCCInfo) {
            var currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
            var endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                .format(DateConstants.DateFormat);
            if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                && (new Date(currentDate) <= new Date(endDate))) {
                this.thresholdCrossed = true;
            }
            else if ((this.orderRules.maxCCValue < this.memberCCOverride.cVLimit) &&
                ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                && (new Date(currentDate) <= new Date(endDate))) {
                this.thresholdCrossed = false;
            }
        }
    };
    /**
     * @description place order
     * @date 2019-05-04
     * @param {string} requestUrl
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.placeOrder = function (requestUrl) {
        var memberTypeId = this.currentMemberTypeID ? this.currentMemberTypeID : this.memberTypeId;
        if (memberTypeId !== MemberTypeEnum.RETAIL && memberTypeId !== MemberTypeEnum.GUEST) {
            if (this.orderFormGroup.value.backDateOrder) {
                this.getMemberOrderRules(this.memberInfo, true, requestUrl);
            }
            else {
                this.getMemberOrderRules(this.memberInfo, false, requestUrl);
            }
        }
        else {
            this.validateThreshold();
            this.submitOrder(requestUrl);
        }
    };
    /** get Member Order rules
 * @description
 * @date 2019-05-20
 * @memberof OrderPromotionComponent
 */
    OrderEditComponent.prototype.getMemberOrderRules = function (userInfo, isBackOrderDate, requestUrl) {
        var _this = this;
        this.memberOrderCCInfo = null;
        this._orderService.getMemberOrderBusinessRules(userInfo.memberId, this.storeId, isBackOrderDate, this.selectedIsoCountryCode, this.orderInformation && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : userInfo.memberTitleId, this.webOrderId.toUpperCase())
            .subscribe(function (response) {
            if (response) {
                var memberOrderRules = response;
                _this.memberOrderCCInfo = memberOrderRules.memberOrderCCInfo.filter(function (x) { return x.frequency === 'MONTHLY'; })[0];
                var validateOrderRule = _this.verifyOrderRules(isBackOrderDate);
                _this.thresholdCrossed = validateOrderRule.thresholdCrossed;
                _this.memberCCLimitExceeded = validateOrderRule.monthlyCCValid;
                _this.monthlyCCValue = validateOrderRule.monthlyCCValue;
                _this.memberCCOverrideLimitExceeded = validateOrderRule.memberCCOverride;
                if (requestUrl) {
                    _this.submitOrder(requestUrl);
                }
            }
        }, function (error) {
        });
    };
    /**
 * Get member cc overrides
 * @param memberId
*/
    OrderEditComponent.prototype.getMemberCCOverrides = function (memberId) {
        var _this = this;
        this._customerService.getMemberCCOverride(this.storeId, memberId)
            .subscribe(function (response) {
            if (response && response.length) {
                _this.memberCCOverride = response[0];
            }
        }, function (err) {
        });
    };
    OrderEditComponent.prototype.validateOrderLimit = function (quantityUpdate) {
        if (!this.orderRules) {
            return;
        }
        var exceedMonthlyCCPopup = this._translatePipe
            .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
        var exceedMonthlyCCOverridePopup = this._translatePipe
            .get('order.Monthly CC limit reached');
        //   const exceedPerOrderCC: any = this._translatePipe.get('order.Retail Max Order limit reached');
        var orderRulesMaxValue = this.orderRules.maxValue ? this.orderRules.maxValue : this.orderRules.literatureMaxValue;
        var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this._commonService.validateNumberDecimalPoint(orderRulesMaxValue ? orderRulesMaxValue : orderRulesMaxValue) + '.00' || '0', this.storeInfo);
        var exceedPerOrderCC = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.', { max: maxValue });
        if (this.thresholdCrossed && this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
            if (this.memberCCLimitExceeded) {
                var monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                    + this.monthlyCCValue + '</b>';
                this._commonService.createNotification('', monthlyCCContent, 'error');
            }
            else if (!quantityUpdate) {
                var isLiteratureValidation = this.isLiteratureValidation(this.products);
                var invalidProductPopup = this._translateService.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}', {
                    min: isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue,
                    max: isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue
                });
                this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR);
            }
        }
        if ((this.memberCCLimitExceeded || this.thresholdCrossed) && !this.memberCCOverrideLimitExceeded
            && this.orderRules.valueType !== ValueType.BOTH) {
            var monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                + this.monthlyCCValue + '</b>';
            if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                this._commonService.createNotification('', monthlyCCContent, 'error');
            }
            else {
                this._commonService.createNotification('', exceedPerOrderCC.value, 'error');
            }
            this.isUpdated = false;
        }
        if (this.memberCCOverrideLimitExceeded) {
            var monthlyCCOverrideContent = exceedMonthlyCCOverridePopup.value + ' <b class="helvetica-bold">'
                + this.memberCCOverride.cVLimit + ' CC</b>';
            this._commonService.createNotification('', monthlyCCOverrideContent, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
            this.isUpdated = false;
        }
    };
    /**
     * @description place order
     * @date 2019-05-22
     * @param {string} requestUrl
     * @memberof OrderPromotionComponent
     */
    OrderEditComponent.prototype.submitOrder = function (requestUrl) {
        var _this = this;
        var orderLogMessage = this.getOrderLogMessage();
        if (!this.isCloneOrder) {
            var orderRequest = this.prepareOrderRequest();
            this.updateFinalOrder(orderRequest, requestUrl, orderLogMessage);
        }
        else {
            this.validateOrderLimit(false);
            if (((this.orderRules && !this.thresholdCrossed) || !this.orderRules) && (!this.memberCCOverrideLimitExceeded) &&
                ((this.memberOrderCCInfo && !this.memberCCLimitExceeded) || !this.memberOrderCCInfo)) {
                if (orderLogMessage == '' && this.orderFormGroup.value.backDateOrder && !this.isOrderBackdated
                    && this.orderStatusId.Failed !== this.orderInformation.orderStatusId) {
                    this._orderService.backDateOrder(this.webOrderId.toUpperCase()).subscribe(function (response) {
                        if (response) {
                            if (response.json().success) {
                                _this.orderSuccess(response.json());
                            }
                            else {
                                _this.orderPending(response);
                            }
                            _this.isUpdated = false;
                        }
                    }, function (error) {
                        var notification = _this._translatePipe.get('order.Unable to Update Order');
                        _this._commonService.createNotification('', notification.value, 'error');
                        _this.isUpdated = false;
                    });
                }
                else {
                    var orderRequest = this.prepareOrderRequest();
                    if (this.orderStatusId.Failed === this.orderInformation.orderStatusId) {
                        this.placeFinalOrder(orderRequest);
                    }
                    else {
                        this.updateFinalOrder(orderRequest, requestUrl, orderLogMessage);
                    }
                }
            }
        }
    };
    /**
     * @description cloning the failed order as new Order
     * @date 2020-04-27
     * @param {string} requestUrl
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.placeFinalOrder = function (orderRequest) {
        var _this = this;
        if (orderRequest) {
            var url = ApiUrlConstants.orderApiUrl + '/V1/orders';
            this._orderService.createNewOrder(orderRequest, url).subscribe(function (response) {
                if (response) {
                    if (response.json().status === 'COMPLETED' && response.json().responseModel
                        && response.json().responseModel.success) {
                        var shippingLogInfo = _this.getShippingLogInfo();
                        if (shippingLogInfo) {
                            _this.createOrderLog(response.json().responseModel, true, shippingLogInfo);
                        }
                        // this.createOrderLog(response.json().responseModel, true);
                        _this.orderSuccess(response.json().responseModel);
                        var sessionGuid = ((_this.memberCart && _this.memberCart.sessionGuid) || _this.memberCartSessionGuid);
                        if (sessionGuid && _this.memberTypeId && _this.memberTypeId !== MemberTypeEnum.GUEST && _this.shoppingBagClicked) {
                            _this.deleteCart(sessionGuid);
                        }
                    }
                    else if (response.json().responseModel && !response.json().responseModel.success
                        && response.json().responseModel.validations.length > 0) {
                        _this._commonService.createNotification('', response.json().responseModel.validations[0].message, 'error');
                    }
                    else {
                        _this.orderPending(response);
                    }
                    _this.isUpdated = false;
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.It looks like there was a technical issue while processing the order. Please call our Sales Support team at 1-888-440-ALOE (2563) to try again.');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                _this.isUpdated = false;
            });
        }
    };
    /**
     * @description edit Order
     * @date 2020-04-27
     * @param {string} requestUrl
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.updateFinalOrder = function (orderRequest, requestUrl, orderLogMessage) {
        var _this = this;
        this._orderService.updateOrder(orderRequest, requestUrl).subscribe(function (response) {
            if (response) {
                if (response.json().success) {
                    _this.orderSuccess(response.json());
                    _this.createOrderLog(orderLogMessage);
                }
                else {
                    _this.orderPending(response);
                }
                _this.isUpdated = false;
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to Update Order');
            _this._commonService.createNotification('', notification.value, 'error');
            _this.isUpdated = false;
        });
    };
    /**
    * @description
    * frame content to be logged for shipping price change
    * @date 2020-03-18
    * @returns {string}
    * @memberof OrderPromotionComponent
    */
    OrderEditComponent.prototype.getShippingLogInfo = function () {
        var shippingLogInfo;
        var shippingCost = this.getOrderShippingCost();
        if (this.orderFormGroup && this.orderFormGroup.controls['shippingCostSelector']) {
            var hasWaived = (this.orderFormGroup.controls['shippingCostSelector'].value !== this.selectEnum.firstOption.toString()) ? true : false;
            if (hasWaived && this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()) {
                var discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value;
                shippingLogInfo = discountPercentage > 0 ? 'Shipping Cost was discounted by ' +
                    (discountPercentage + '%') + '.' : '';
            }
            else if (hasWaived && this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
                var costDifference = shippingCost - this.orginalShippingCost;
                shippingLogInfo = costDifference > 0 ? 'Shipping Cost was increased by ' + this._currencyPipe.
                    transform(costDifference, this.storeInfo, true) +
                    '.' : 'Shipping Cost was discounted by ' + this._currencyPipe.
                    transform(-costDifference, this.storeInfo, true) + '.';
            }
        }
        return shippingLogInfo;
    };
    OrderEditComponent.prototype.orderSuccess = function (response) {
        this.showSelectedShipMethod = false;
        this.updateShippingAddressFormValidations(false);
        var notification;
        var validation = 'success';
        if (this.orderInformation && !(this.orderStatusId.Failed == this.orderInformation.orderStatusId)) {
            notification = this._translatePipe.get('order.Order Updated successfully');
        }
        else {
            // only for cloned order
            if (response && response.orderStatusId === OrderStatus.Failed) {
                notification = this._translatePipe.get('order.Order Creation failed');
                validation = 'error';
            }
            else {
                notification = this._translatePipe.get('order.Order Created successfully');
            }
        }
        this._commonService.setNotification('', notification.value, validation, 0, false, 500);
        this.orderSubmitted = false;
        this.orderFormGroup.controls['backDateOrder'].setValue(false);
        var updatedOrderInfo = {
            webOrderId: response.webOrderId,
            countryCode: this.selectedIsoCountryCode
        };
        this._cacheService.set('UpdatedOrderInfo', updatedOrderInfo);
        this.router.navigate(['/customerservice/orders']);
    };
    OrderEditComponent.prototype.orderPending = function (response) {
        if ((response.json().status === 'IN-PROGRESS') || (response.json().status === 'QUEUED')) {
            if (this.pollCount < this.maxPollCount) {
                if (localStorage.getItem('appadmin.pollCount')) {
                    this.pollCount = +(localStorage.getItem('appadmin.pollCount'));
                }
                else {
                    localStorage.setItem('appadmin.pollCount', '1');
                }
                this.pollCount = this.pollCount + 1;
                localStorage.setItem('appadmin.pollCount', this.pollCount + '');
                this.updateOrder(response.json().location);
            }
        }
        else {
            localStorage.removeItem('appadmin.pollCount');
            if (response.json().validations && response.json().validations.length > 0) {
                var notification = this._translatePipe.get('order.Order is in Processing status');
                this._commonService.createNotification('', notification.value, 'error');
            }
        }
        localStorage.removeItem('appadmin.pollCount');
    };
    OrderEditComponent.prototype.prepareOrderRequest = function () {
        var _this = this;
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        var orderTypeId = PurchaseFlow.Personal_Order;
        var shippingAddress;
        var memberTypeId = this.currentMemberTypeID ? this.currentMemberTypeID : this.memberTypeId;
        if (memberTypeId === this.memberTypeEnums.GUEST || memberTypeId === this.memberTypeEnums.RETAIL) {
            orderTypeId = PurchaseFlow.Retail;
        }
        var shippingTax = this._enrollService.prepareShippingTax(this.orderTaxResponse) || this.shippingTax;
        shippingAddress = this.getShippingAddress();
        if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === shippingAddress.countryId; });
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        var shippingObj = this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === _this.orderFormGroup.value.shipMethodId; })[0];
        if (this.hasManageOrderUpdatePermission && this.orderInformation.orderPayments.length > 0 && this.paymentStatusEnum.PEND !== this.orderInformation.orderPayments[0].paymentStatusId) {
            this.orderStatusShippedORPickUP = +this.orderFormGroup.controls['shippedOrderStatus'].value;
        }
        else {
            this.orderStatusShippedORPickUP = this.orderFormGroup.value.enableStatus ? OrderStatus.Accepted : OrderStatus.Pending;
        }
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            shippingAddress = this.getShippingAddress();
        }
        else {
            shippingAddress = this.getShippingAddress();
        }
        var orderRequest = {
            backDateOrder: this.isOrderBackdated ? this.isOrderBackdated : this.orderFormGroup.value.backDateOrder,
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: this.orderStatusShippedORPickUP,
            memberTypeId: memberTypeId,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            email: this.memberInfo ? this.memberInfo.email : null,
            languageCode: this.languageShortCode,
            storeId: this.storeInfo.id,
            orderTypeId: orderTypeId,
            memberLevelId: this.orderInformation && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : MemberLevel.RETAIL,
            shippingCost: this.getTaxExclusiveShippingCost(),
            moneyOrderAmount: this.orderFormGroup.controls['moneyOrderAmount'].value,
            importFeeValue: this.importFeeValue,
            retailDeliveryFee: this.retailDeliveryFee,
            shippingTax: (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice || this.appConfig && this.appConfig.displayTaxInclusivePrice) ? 0 : shippingTax,
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : null,
            orderSubTotal: this.subTotal,
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: 'Customer Service',
            orderGroupId: this.orderFormGroup.value.orderType,
            orderNotes: null,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: this.getOrderPaymentInfo(),
            shippingAddressModel: shippingAddress,
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            taxMetaData: this.orderTaxResponse ? this.orderTaxResponse.taxMetaData : null,
            erpTaxMetaData: (this.orderInformation && this.orderInformation.erpTaxMetaData) ? this.orderInformation.erpTaxMetaData : null,
            priceTierName: this.getPriceTier(),
            wholesaleQualified: this.orderInformation ? this.orderInformation.wholesaleQualified : null,
            sponsorId: this.orderInformation ? this.orderInformation.sponsorId : null,
            personalDiscountPercentage: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage)
                : this.personalDiscountPercentage,
            memberLevelDiscount: this.orderInformation ? this.orderInformation.memberLevelDiscount : 0,
            // we have to send the wholesale discount percentage of the user,
            // how much discount he will get if he is an wholesaleQualified User
            wholesaleQualifiedDiscount: this.orderInformation ? this.orderInformation.wholesaleQualifiedDiscount : 0,
            optIn: this.orderInformation ? this.orderInformation.optIn : null,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            vatID: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.governmentId : null,
            accountLevelId: this._commonService.getMemberAccountLevelId(this.memberInfo),
            coldProtection: shippingObj ? shippingObj.coldProtection : false,
            languageCulture: (this.orderInformation && this.orderInformation.languageCulture) ? this.orderInformation.languageCulture : null,
            overrideMinimumLimit: (this.orderInformation.overrideMinimumLimit === true) ? this.orderInformation.overrideMinimumLimit : false,
            retailFreeShippingOrder: this.orderInformation && this.orderInformation.retailFreeShippingOrder ? this.orderInformation.retailFreeShippingOrder : false,
            retailFreeShippingCost: this.orderInformation && this.orderInformation.retailFreeShippingCost ? +this.orderInformation.retailFreeShippingCost : 0,
            orderLevelDiscount: this.orderLevelDiscount,
            paymentLinkEmail: this.emailForm.value.payByLinkEmail,
            sourceTypeId: 5,
            freeShippingPromotionOrder: this.orderInformation && this.orderInformation.freeShippingPromotionOrder ? this.orderInformation.freeShippingPromotionOrder : false,
        };
        return orderRequest;
    };
    /**
  * @description
  * @memberof CommonService
  */
    OrderEditComponent.prototype.getCountryTaxInclusiveInfo = function (country) {
        var countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    };
    /**
    * @returns OrderLineItem
    */
    OrderEditComponent.prototype.getOrderLineItems = function (countryTaxInclusive) {
        var _this = this;
        var lineItems = [];
        if (this.products && this.products.length > 0) {
            var itemLineNumber_1 = 0;
            var lineItemTax_1;
            this.products.sort(function (x, y) {
                return (x.comboBOMEnabled === y.comboBOMEnabled) ? 0 : x.comboBOMEnabled ? 1 : -1;
            });
            this.products.forEach(function (product) {
                if (product) {
                    var unitPrice = countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    var retailPrice = countryTaxInclusive ? product.retailPrice : product.baseRetailPrice;
                    var wholesalePrice = countryTaxInclusive ? product.wholesalePrice : product.baseWholesalePrice;
                    if (_this.displayPriceConfig) {
                        unitPrice = _this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (_this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice :
                                (_this.displayPriceConfig.displayCatalogPrice ? product.catalogPrice : product.applicablePrice));
                        retailPrice = _this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            _this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice;
                        wholesalePrice = _this.displayPriceConfig.displayWholesalePrice ? product.wholesalePrice :
                            _this.displayPriceConfig.displayBaseWholesalePrice ? product.baseWholesalePrice : product.wholesalePrice;
                    }
                    if (_this.orderTaxResponse && _this.orderTaxResponse.cart && _this.orderTaxResponse.cart.orderLineItems
                        && _this.orderTaxResponse.cart.orderLineItems.length > 0) {
                        lineItemTax_1 = _this.orderTaxResponse.cart.orderLineItems.find(function (y) { return y.itemNumber === product.itemNumber; });
                    }
                    var unitDiscountPrice = _this.memberInfo && _this.memberInfo.transactionalWholesaleQualified ?
                        (product.baseWholesalePrice - product.catalogPrice) : 0;
                    var lineItem = {
                        discountPercentage: product.discountPercentage,
                        literature: product.literature,
                        orderLineNumber: ++itemLineNumber_1,
                        productId: product.id,
                        itemNumber: product.itemNumber,
                        productName: product.displayName ? product.displayName : product.name,
                        unitRetailPrice: retailPrice,
                        unitWholeSalePrice: wholesalePrice,
                        unitBaseWholeSalePrice: product.baseWholesalePrice,
                        unitPaidPrice: unitPrice,
                        taxInclusive: (_this.checkoutConfig && _this.checkoutConfig.storeTaxExclusivePrice) ? false : countryTaxInclusive,
                        unitTaxExclusiveRetailPrice: product.baseRetailPrice,
                        unitTaxExclusivePaidPrice: product.catalogPrice,
                        unitCommissionablePrice: 0,
                        importedMeasurementUnit: product.importedMeasurementUnit,
                        revisionNumber: product.revisionNumber,
                        taxRate: product.taxRate || 0,
                        unitTax: lineItemTax_1 ? lineItemTax_1.salesTax : 0,
                        unitTaxablePrice: lineItemTax_1 && lineItemTax_1.taxablePrice ? lineItemTax_1.taxablePrice : 0,
                        unitQualificationValue: product.commissionableVolume || 0,
                        quantity: product.quantity,
                        freeshipping: false,
                        shippable: product.shipping ? product.shipping.shippingRequired : null,
                        fboEligible: _this.getFBOEigibleProduct(product),
                        downloadActivated: product.downloadableProduct,
                        weight: product.shipping ? product.shipping.weight : null,
                        height: product.shipping ? product.shipping.height : null,
                        length: product.shipping ? product.shipping.length : null,
                        width: product.shipping ? product.shipping.width : null,
                        totalAmount: _this._currencyPipe.getFormatedCurrency(_this.getItemTotalSum(product), _this.storeInfo),
                        discountAmount: _this._currencyPipe.getFormatedCurrency(_this.calculateDiscountAmount(product, _this.displayPriceConfig), _this.storeInfo),
                        personalDiscount: _this._currencyPipe.getFormatedCurrency(((parseFloat(product.retailPrice.toFixed(2)) * product.quantity
                            * _this.personalDiscountPercentage) / 100), _this.storeInfo),
                        priceTierName: product.priceTierName,
                        netUnitPrice: _this.appConfig && _this.appConfig.calculateNetUnitPrice
                            && _this.memberInfo && _this.memberInfo.transactionalWholesaleQualified
                            && _this.memberInfo.transactionalOptin ? _this.calculateNetUnitPrice(product) : 0,
                        unitDiscount: unitDiscountPrice,
                        lineDiscount: unitDiscountPrice * product.quantity,
                        comboBOMEnabledProduct: product.comboBOMEnabledProduct ? product.comboBOMEnabledProduct : false,
                        depositFeeProduct: product.display ? (product.display.depositFeeProduct ? true : false) : false,
                        depositFeeEnabledProduct: product.productMetaData ? (product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; }) ? true : false) : false,
                        orderPromotionTrackings: product.orderPromotionTrackings ? product.orderPromotionTrackings : null,
                        shippableFulfillment: product.shipping ? (product.shipping.shippableFulfillment ? true : false) : false,
                        bondedProduct: product.bwpEnableProduct ? true : false
                    };
                    lineItems.push(lineItem);
                }
            });
        }
        return lineItems;
    };
    OrderEditComponent.prototype.calculateDiscountAmount = function (item, displayPriceConfig) {
        var discountAmount = 0;
        discountAmount = (parseFloat(item.baseRetailPrice.toFixed(2)) * item.quantity) -
            (parseFloat(item.catalogPrice.toFixed(2)) * item.quantity);
        return discountAmount;
    };
    /**
     * @description will return Unit retail price
     * @date 2020-07-25
     * @private
     * @param {*} product
     * @param {DisplayPriceConfig} displayPriceConfig
     * @returns {number}
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.getUnitRetailPrice = function (product, displayPriceConfig) {
        var unitRetailPrice = 0;
        if (displayPriceConfig && product) {
            if (displayPriceConfig.displayRetailPrice) {
                unitRetailPrice = product.retailPrice;
            }
            else if (displayPriceConfig.displayBaseRetailPrice) {
                unitRetailPrice = product.baseRetailPrice;
            }
            else {
                unitRetailPrice = product.retailPrice;
            }
        }
        return unitRetailPrice;
    };
    /**
     * @description will return unitwholeSale price
     * @date 2020-07-25
     * @private
     * @param {*} product
     * @param {DisplayPriceConfig} displayPriceConfig
     * @returns {number}
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.getUnitWholesalePrice = function (product, displayPriceConfig) {
        var unitWholesalePrice = 0;
        if (displayPriceConfig && product) {
            if (displayPriceConfig.displayWholesalePrice) {
                unitWholesalePrice = product.wholesalePrice;
            }
            else if (displayPriceConfig.displayBaseWholesalePrice) {
                unitWholesalePrice = product.baseWholesalePrice;
            }
            else {
                unitWholesalePrice = product.wholesalePrice;
            }
        }
        return unitWholesalePrice;
    };
    /**
     * @description will return UnitPaidPrice
     * @date 2020-07-25
     * @private
     * @param {*} product
     * @param {DisplayPriceConfig} displayPriceConfig
     * @returns {number}
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.getUnitPaidPrice = function (product, displayPriceConfig) {
        var unitPaidPrice = 0;
        if (displayPriceConfig && product) {
            if (displayPriceConfig.displayApplicablePrice) {
                unitPaidPrice = product.applicablePrice;
            }
            else if (displayPriceConfig.displayCatalogPrice) {
                unitPaidPrice = product.catalogPrice;
            }
            else if (displayPriceConfig.displayComputedTaxInclusivePrice) {
                unitPaidPrice = product.computedTaxInclusivePrice;
            }
            else {
                unitPaidPrice = product.applicablePrice;
            }
        }
        return unitPaidPrice;
    };
    /**
     * @description get FBO eligible product
     * @date 2019-07-04
     * @private
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    OrderEditComponent.prototype.getFBOEigibleProduct = function (product) {
        if (product.productMetaData) {
            var fboEligibilty = product.productMetaData.
                find(function (x) { return x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE; });
            if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                return true;
            }
        }
    };
    OrderEditComponent.prototype.getOrderShippings = function () {
        var orderShippings = [];
        var shippingAddressId = null;
        if (this.savedAddressId) {
            shippingAddressId = this.savedAddressId;
        }
        else if (this.verifiedShippingAddressId) {
            shippingAddressId = this.verifiedShippingAddressId;
        }
        var discountPercentage = this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
            && this.orderFormGroup.controls['shippingCostPercentage'].value > 0
            ? this.orderFormGroup.controls['shippingCostPercentage'].value : 0;
        var hasWaived = (this.orderFormGroup.controls['shippingCostSelector'].value !== this.selectEnum.firstOption.toString()) ? true : false;
        var orderShipping = {
            deliveryPreferenceId: this.orderFormGroup.value.deliveryPreference,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingAddressId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) ?
                shippingAddressId : null,
            shortCode: this.shipMethod.shortCode,
            preferredTime: null,
            notes: null,
            shipmentDate: null,
            shippingWaived: hasWaived,
            shippingWaiverPercentage: hasWaived ? (discountPercentage > 0 ? discountPercentage : null) : null,
            distributionCenter: this.shipMethods.distributionCenterName
        };
        if (orderShipping.deliveryPreferenceId === ShippingType.PICKUP) {
            orderShipping.distributionCenter = (this.shipMethod.pickUpLocation.pickupCenterName) ? this.shipMethod.pickUpLocation.pickupCenterName : '';
        }
        orderShippings.push(orderShipping);
        return orderShippings;
    };
    /**
      * @returns payment method id
      */
    OrderEditComponent.prototype.getPaymentMethodId = function (paymentMethod) {
        var paymentType;
        switch (paymentMethod) {
            case 'Credit_Card':
                paymentType = PaymentType.Credit_Card;
                break;
            case 'eCheck':
                paymentType = PaymentType.eCheck;
                break;
            case 'Money_Order':
                paymentType = PaymentType.Money_order;
                break;
            case 'Wire_Transfer':
                paymentType = PaymentType.Wire_Transfer;
                break;
            case 'Bank_Transfer':
                paymentType = PaymentType.Bank_Transfer;
                break;
            case 'Ideal':
                paymentType = PaymentType.Ideal;
                break;
            case 'PayPal':
                paymentType = PaymentType.PayPal;
                break;
            default:
                paymentType = PaymentType.Credit_Card;
                break;
        }
        return paymentType;
    };
    /*
    */
    OrderEditComponent.prototype.getPaymentMethod = function (paymentMethod) {
        var paymentType;
        switch (paymentMethod) {
            case 'Credit_Card':
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            case 'eCheck':
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case 'Money_Order':
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case 'Wire_Transfer':
                paymentType = PaymentMethodTypes.Wire_Transfer;
                break;
            case 'Cash':
                paymentType = PaymentMethodTypes.Cash;
                break;
            case 'Ideal':
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case 'PayPal':
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case 'Cash_On_Delivery':
                paymentType = PaymentMethodTypes.Cash_On_Delivery;
                break;
            case 'Orange_Money':
                paymentType = PaymentMethodTypes.Orange_Money;
                break;
            case 'Bank_Transfer':
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
        }
        return paymentType;
    };
    OrderEditComponent.prototype.getAddresses = function () {
        var addresses = [];
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation) {
            var pickupAddress = this.getPickUpAddress();
            if (pickupAddress) {
                pickupAddress.deliveryInstruction = pickupAddress && pickupAddress.instruction ? pickupAddress.instruction : '';
                pickupAddress.email = pickupAddress.email ? pickupAddress.email : null;
                addresses.push(pickupAddress);
            }
        }
        else {
            addresses.push(this.getShippingAddress());
        }
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            var pudoDropAddress = this.getPudoDropAddress(this.pudoShippingAddressInfo, this.shipMethod);
            if (pudoDropAddress) {
                pudoDropAddress.deliveryInstruction = pudoDropAddress && pudoDropAddress.instruction ? pudoDropAddress.instruction : '';
                pudoDropAddress.email = pudoDropAddress.email ? pudoDropAddress.email : null;
                addresses.push(pudoDropAddress);
            }
        }
        if ((this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) || (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString())) {
            addresses.push(this.getBillingAddress());
        }
        return addresses;
    };
    OrderEditComponent.prototype.calculateOrderTotal = function () {
        var totalCost = 0;
        this.isBWPEnabledProduct = false;
        var taxableAmount = (this.checkoutConfig && this.checkoutConfig.storeTaxInclusivePrice) ? 0 : (+this.taxableAmount);
        var isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
        if (this.memberInfo && this.memberInfo.vatRegistered && this.orderTaxResponse && this.countryTaxInclusive) {
            totalCost = +this.subTotal + (this.importFeeValue) + (+this.getShippingCostForOrderSummary() || 0) + taxableAmount;
        }
        else {
            totalCost = +this.subTotal + (this.importFeeValue) + (+this.getShippingCostForOrderSummary() || 0) +
                ((this.countryTaxInclusive === false || isCalculateTaxExclusivePrice) ? (+this.taxableAmount || 0) : 0);
        }
        this.totalOrderCost = this._currencyPipe.getFormatedCurrency(totalCost, this.storeInfo);
        if (this.orderLevelDiscount > 0 && this.storeInfo && this.storeInfo.bwpEnabled) {
            this.isBWPEnabledProduct = true;
            this.totalOrderCost = this.totalOrderCost - this.orderLevelDiscount;
            this.totalOrderCost = Number((this.totalOrderCost).toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
        }
        this.itemTotal = totalCost - (this.itemShippingCost + this.shippingTax);
        ;
        return this.totalOrderCost;
    };
    /**
    * @param  {any} shippingInfo
    * @returns void
    */
    OrderEditComponent.prototype.calculateOrderTax = function () {
        var _this = this;
        // Get the caluculated tax from valence else Prepare ordered tax from order details
        if (!this.isOrderedTax) {
            this.taxCalculationStatus = true;
            if (this.memberInfo && this.storeInfo && this.products && this.products.length > 0 && this.orderFormGroup.value.shipMethodId) {
                var taxRequest = this.prepareTaxRequest();
                this._orderService.calculateOrderTax(taxRequest)
                    .subscribe(function (taxResponse) {
                    if (taxResponse && taxResponse.success) {
                        _this.processTaxResponse(taxResponse);
                        setTimeout(function () {
                            _this.taxCalculationStatus = false;
                        }, 500);
                    }
                }, function (error) {
                    if (error) {
                        var taxResponse = error;
                        if (taxResponse && taxResponse.validations && taxResponse.validations.length > 0) {
                            if ((taxResponse.validations.map(function (validation) { return validation.name; }).indexOf(CommonConstant.Order_Tax)) > -1) {
                                var notification = _this._translatePipe.get('order.Tax cannot be calculated now. Please try again later.');
                                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }
                            else {
                                var notification = _this._translatePipe.get('order.' + taxResponse.validations[0].message);
                                _this._commonService.createNotification('', notification.value, 'error');
                            }
                        }
                    }
                });
            }
        }
        else {
            // Prepare taxmeta data from Order details
            var orderedTaxResponse = this.prepareCalculatedTax();
            this.processTaxResponse(orderedTaxResponse);
            setTimeout(function () {
                _this.taxCalculationStatus = false;
            }, 1000);
            this.isOrderedTax = false;
        }
    };
    /**
     * @description Process Tax value from valence data
     * @author njagadeesan
     * @date 2020-02-20
     * @param {*} taxResponse
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.processTaxResponse = function (taxResponse) {
        if (taxResponse.cart && taxResponse.cart.totalTax >= 0) {
            taxResponse.cart.totalTax = this._currencyPipe.getFormatedCurrency(taxResponse.cart.totalTax, this.storeInfo);
            this.orderTaxResponse = taxResponse;
            this.taxableAmount = taxResponse.cart.totalTax;
            this.retailDeliveryFee = taxResponse.cart.retailDeliveryFee ? taxResponse.cart.retailDeliveryFee : 0;
            if (this.orderTaxResponse && this.orderTaxResponse.taxMetaData
                && this.orderTaxResponse.taxMetaData.orderTaxCharges
                && this.orderTaxResponse.taxMetaData.orderTaxCharges.length > 0) {
                var gst = this.orderTaxResponse.taxMetaData
                    .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.GST_TAX; });
                var pst = this.orderTaxResponse.taxMetaData
                    .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.PST_TAX; });
                this.gstTax = gst ? gst.taxAmount : 0;
                this.pstTax = pst ? pst.taxAmount : 0;
                if (this.countryTaxInclusive) {
                    var shippingLineItem = this.orderTaxResponse.taxMetaData
                        .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.NOR && tax.lineNo === 0; });
                    if (shippingLineItem && this.orderFormGroup.controls['shippingCostSelector'].value != this.selectEnum.secondOption.toString() && this.orderFormGroup.controls['shippingCostSelector'].value != this.selectEnum.thirdOption.toString()) {
                        this.shippingTax = shippingLineItem.taxAmount;
                    }
                }
            }
            if (this.isOrderedTax) {
                this.importFeeValue = taxResponse.cart.importFeeValue;
            }
            this.total = this.taxableAmount + (+this.shippingCost) + this.subTotal + this.importFeeValue;
        }
    };
    /**
     * @description To prepare Ordered Tax Value
     * @author njagadeesan
     * @date 2020-02-20
     * @returns
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.prepareCalculatedTax = function () {
        var taxOrderLineItems = [];
        if (this.orderInformation && this.orderInformation.orderLineItems) {
            this.orderInformation.orderLineItems.forEach(function (element) {
                var taxOrderLineItem = {
                    itemNumber: element.itemNumber,
                    salesTax: element.unitTax,
                    taxablePrice: element.unitTaxablePrice
                };
                taxOrderLineItems.push(taxOrderLineItem);
            });
        }
        if (this.orderInformation && this.orderInformation.taxMetaData) {
            return {
                taxMetaData: this.orderInformation.taxMetaData,
                cart: {
                    totalTax: this.orderInformation.orderTax,
                    importFeeValue: this.orderInformation.importFeeValue,
                    retailDeliveryFee: this.orderInformation.retailDeliveryFee,
                    orderLineItems: taxOrderLineItems
                }
            };
        }
        else {
            this.isOrderedTax = false;
            this.calculateOrderTax();
        }
    };
    OrderEditComponent.prototype.prepareTaxRequest = function () {
        var taxRequest = {
            orderID: 0,
            memberID: this.memberInfo ? this.memberInfo.memberId : null,
            shopingCart: this.mapCartToTaxCart(),
            fromAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation) ?
                this.getPickUpAddress() : this.getShippingMethodWarehouseAddress(),
            // toAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation) ?
            //     this.getPickUpAddress() : this.getShippingAddress(),
            toAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation)
                ? this.getPickUpAddress() : (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) ? this.getPudoDropShipPersonAddress(this.selectedPudoCollectionPoint) : this.getShippingAddress(),
            memberNumber: this.memberInfo ? this.memberInfo.fboId : null,
            orderNumber: 0,
            storeID: this.storeInfo.id,
            priceTierName: this.getPriceTier(),
            currencyCode: this.storeInfo.currencyCode,
            countryCode: this.selectedIsoCountryCode.toLowerCase(),
            deliveryTypeId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                ShippingType.PICKUP : ShippingType.DELIVERY,
            orderSource: 'CUSTOMER SERVICE',
            orderTypeId: 2,
            conversionRate: 1,
            memberLevelId: this.orderInformation && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : MemberLevel.RETAIL,
            wholesaleQualified: this.orderInformation ? this.orderInformation.wholesaleQualified : null,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            isDiscountedShipping: this.orderFormGroup.value.isShippingDiscountApplied,
            memberType: this.orderInformation && this.orderInformation.memberTypeId ? MemberTypeEnum[this.orderInformation.memberTypeId] : this.memberInfo ? MemberTypeEnum[this.memberInfo.memberTypeId] : ''
        };
        return taxRequest;
    };
    /**
      * @returns TaxCart
      */
    OrderEditComponent.prototype.mapCartToTaxCart = function () {
        var taxCart = {
            shippingTax: 0,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingCost: this.getTaxExclusiveShippingCost() || 0,
            importFeeValue: this.importFeeValue || 0,
            importFeeEnabled: this.importFeeEnabled,
            orderLineItems: this.mapItemstoTaxItems()
        };
        return taxCart;
    };
    /**
     * @returns CartItems
     */
    OrderEditComponent.prototype.mapItemstoTaxItems = function () {
        var _this = this;
        // PS2020-496 PR applicable tax issue
        var address = (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation) ?
            this.getPickUpAddress() : this.getShippingAddress();
        /*
            TASK : HOTFIX PS2020-387
            TO:DO : taxablePrice price coloumn mapping should be based on Provider. We will adopt this changes as part of R7 release
        */
        var taxItems = [];
        if (this.products && this.products.length > 0) {
            var itemLineNumber_2 = 0;
            if (address && address.countryId && this.countries && this.countries.length > 0) {
                var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
                this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
            }
            this.products.forEach(function (x) {
                var taxablePrice;
                var paidPrice;
                if (_this.checkoutConfig && _this.checkoutConfig.calculateTaxExclusivePrice) {
                    taxablePrice = x.catalogPrice;
                    paidPrice = x.applicablePrice;
                }
                else {
                    taxablePrice = ((_this.checkoutConfig.catalogPriceAsTaxablePrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.catalogPrice : x.retailPrice);
                    paidPrice = ((_this.checkoutConfig.applicablePriceAspaidPrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.applicablePrice : x.retailPrice);
                }
                var taxItem = {
                    lineNumber: ++itemLineNumber_2,
                    itemNumber: x.itemNumber,
                    taxablePrice: _this.getTaxablePrice(taxablePrice, x),
                    quantity: +x.quantity,
                    taxCode: null,
                    description: '',
                    taxInclusive: _this.countryTaxInclusive ? true : false,
                    resale: false,
                    resalePrice: 0,
                    taxBreakDown: x.taxBreakDown,
                    productIdentifier: null,
                    retailPrice: x.retailPrice,
                    paidPrice: _this.getPaidPrice(paidPrice, x),
                    wholeSalePrice: x.wholesalePrice,
                    salesTax: 0,
                    revisionNumber: x.revisionNumber,
                    itemWeight: x.shipping && x.shipping.weight ? x.shipping.weight : 0,
                    importedMeasurementUnit: x.importedMeasurementUnit,
                    unitTaxExclusiveRetailPrice: x.baseRetailPrice,
                    computedTaxInclusivePrice: x.computedTaxInclusivePrice,
                    comboBOMEnabled: x.display ? (x.display.comboBOMEnabled ? x.display.comboBOMEnabled : false) : false,
                    computedComboTaxTotals: x.computedComboTaxTotals && x.computedComboTaxTotals.length > 0 ? x.computedComboTaxTotals : [],
                    bondedProduct: (x.bwpEnableProduct && _this.isBWPEnabledMember) ? true : false
                };
                taxItems.push(taxItem);
            });
        }
        return taxItems;
    };
    OrderEditComponent.prototype.getPaidPrice = function (paidPrice, item) {
        if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === 'NEWDST' || item.priceTierName === 'WHLSAL')) {
            return item.applicablePrice;
        }
        else {
            return paidPrice;
        }
    };
    OrderEditComponent.prototype.getTaxablePrice = function (taxablePrice, item) {
        var enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.selectedIsoCountryCode);
        if (this.appConfig && this.appConfig.calculateNetUnitPrice
            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
            && this.memberInfo.transactionalOptin &&
            (this.memberInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                    && enableWHLSAL00ForAsstSupervisor)) {
            return this.calculateNetUnitPrice(item);
        }
        else if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
            && !enableWHLSAL00ForAsstSupervisor) {
            return item.catalogPrice;
        }
        else {
            return taxablePrice;
        }
    };
    OrderEditComponent.prototype.getPriceTier = function () {
        var priceTierName = '';
        if (this.products && this.products.length > 0) {
            priceTierName = this.products[0].priceTierName;
        }
        return priceTierName;
    };
    OrderEditComponent.prototype.addNewProductItem = function (items, index, product) {
        var itemValue = product.itemNumber + ' - ' + product.name;
        items.controls[index].controls['itemNumber'].setValue(itemValue);
        var itemImage = (product.imageModelList && product.imageModelList.length > 0)
            ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
        var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
            : (environment.uiTemplateBaseUrl + '/images/no_image.png');
        items.controls[index].controls['productImage'].setValue(imageUrl);
        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
        items.controls[index].controls['productId'].setValue(product.id);
        items.controls[index].controls['productItem'].setValue(product);
        items.controls[index].controls['disableIncrement'].setValue(false);
        return items;
    };
    OrderEditComponent.prototype.setFocusbyID = function (id) {
        setTimeout(function () {
            var element = document.getElementById(id);
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    };
    OrderEditComponent.prototype.itemLevelSearchEvent = function (event) {
        var _this = this;
        if (event.currentTarget.value) {
            this.taxCalculationStatus = true;
            this.observableSource(event.currentTarget.value, true).subscribe(function (products) {
                var responseproducts = products;
                if (responseproducts.length > 0) {
                    var product_1 = responseproducts[0];
                    if (product_1.stockAvailable) {
                        var items = _this.orderFormGroup.get('items');
                        if (items && items.length > 0) {
                            var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productNumber'].value === product_1.itemNumber; });
                            if (sameProductIndex >= 0) {
                                items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                                _this.setFocusbyID('quantity-' + (sameProductIndex));
                            }
                            else {
                                _this.addItemNumber();
                                var index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(1);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                _this.orderFormGroup.controls['itemSearch'].setValue('');
                                items = _this.addNewProductItem(items, index, product_1);
                                _this.setFocusbyID('quantity-' + (items.length - 1));
                                _this.disableUpdateQuanitity[index] = false;
                            }
                        }
                        _this.updateTotalsAndShipMethod();
                        if (_this.orderFormGroup.controls['orderType'].value === OrderType.POS || _this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                            _this.deliveryPreferenceOnChange();
                        }
                    }
                    else if (!product_1.stockAvailable) {
                        _this._commonService.createNotification('', 'Out of stock - '
                            + (product_1.name || ''), 'error');
                        if (_this.itemLevelSearchInput && _this.itemLevelSearchInput.nativeElement) {
                            _this.itemLevelSearchInput.nativeElement.focus();
                        }
                        _this.taxCalculationStatus = false;
                    }
                }
                else {
                    if (_this.itemLevelSearchInput && _this.itemLevelSearchInput.nativeElement) {
                        _this.itemLevelSearchInput.nativeElement.focus();
                    }
                    var notification = _this._translatePipe.get('order.Invalid Item Number');
                    _this._commonService.createNotification('', notification.value, 'error');
                }
                _this.itemLevelSearchInput.nativeElement.value = '';
            });
        }
    };
    OrderEditComponent.prototype.onItemSelect = function () {
        var _this = this;
        if (this.orderFormGroup.controls['itemSearch'].value && this.orderFormGroup.controls['itemSearch'].value.id
            && this.orderFormGroup.controls['itemSearch'].value.stockAvailable) {
            var items = this.orderFormGroup.get('items');
            if (items && items.length >= 0) {
                this.taxCalculationStatus = true;
                var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productNumber'].value === _this.orderFormGroup.controls['itemSearch'].value.itemNumber; });
                if (sameProductIndex >= 0) {
                    items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                    this.orderFormGroup.controls['itemSearch'].setValue('');
                    this.setFocusbyID('quantity-' + (sameProductIndex));
                }
                else {
                    this.addItemNumber();
                    var index = (items.length - 1);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    if (!items.controls[index].controls['quantity'].value) {
                        items.controls[index].controls['quantity'].setValue(1);
                    }
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    if (this.orderFormGroup.controls['itemSearch'].value) {
                        var typHeadItem = this.orderFormGroup.controls['itemSearch'].value;
                        this.orderFormGroup.controls['itemSearch'].setValue('');
                        items = this.addNewProductItem(items, index, typHeadItem);
                    }
                    this.setFocusbyID('quantity-' + (items.length - 1));
                    this.isFocused = true;
                    this.disableUpdateQuanitity[index] = false;
                }
            }
            this.updateTotalsAndShipMethod();
            if (this.orderFormGroup.controls['orderType'].value === OrderType.POS || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                this.deliveryPreferenceOnChange();
            }
        }
        else if (this.orderFormGroup.controls['itemSearch'].value && this.orderFormGroup.controls['itemSearch'].value.id && !this.orderFormGroup.controls['itemSearch'].value.stockAvailable) {
            setTimeout(function () {
                if (_this.addItemInput && _this.addItemInput.nativeElement) {
                    _this.addItemInput.nativeElement.focus();
                }
            }, 500);
            this._commonService.createNotification('', 'Out of stock - ' + (this.orderFormGroup.controls['itemSearch'].value.name || ''), 'error');
            this.orderFormGroup.controls['itemSearch'].setValue('');
        }
    };
    OrderEditComponent.prototype.shippingAddressSelectionChange = function () {
        this.shippingAddressInfo = this.address;
        this.getShipMethods();
    };
    /**
     * get shipping cost in percentage
     */
    OrderEditComponent.prototype.getShippingCostInPercentage = function () {
        var shippingOriginalCost = this.orginalShippingCost;
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                ? this.orderFormGroup.controls['originalShippingCost'].value
                : this.orderFormGroup.controls['originalShippingCost'].value - this.orderFormGroup.controls['originalShippingTax'].value;
            this.shippingTax = this.orderFormGroup.controls['originalShippingTax'].value;
        }
        else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
            this.shippingTax = 0;
        }
        else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()) {
            var discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            shippingOriginalCost = this.memberInfo && this.memberInfo.vatRegistered
                ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            var shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            }
            else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
            this.shippingTax = 0;
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.getShippingCost();
    };
    /**
     * on chnage on shipping charge selector
     */
    OrderEditComponent.prototype.shippingCostChange = function (removeValidations, calculateTax) {
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            if (this.showSelectedShipMethod) {
                this.orderFormGroup.controls['originalShippingCost'].setValue(this._currencyPipe.getFormatedCurrency(this.orginalShippingCost || 0, this.storeInfo));
                this.orderFormGroup.controls['originalShippingTax'].setValue(this.originalShippingTax);
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            }
            else {
                this.orderFormGroup.controls['originalShippingCost'].setValue(0);
                this.orderFormGroup.controls['originalShippingTax'].setValue(0);
            }
            this.orderFormGroup.controls['originalShippingCost'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].setValue('');
            this.orderFormGroup.controls['shippingCostPercentage'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(false);
        }
        else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['shippingCostPercentage'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
            this.shippingTax = 0;
        }
        else {
            //this.shippingCost = this.orderFormGroup.controls['shippingCostPercentage'].value;
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['shippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([Validators.required]);
            //this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            var shippingOriginalCost = this.orginalShippingCost;
            var discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            shippingOriginalCost = this.memberInfo && this.memberInfo.vatRegistered
                ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            var shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            }
            else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
            this.shippingTax = 0;
        }
        if (removeValidations) {
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(+this.shippingCost, this.storeInfo);
        if (!calculateTax && !removeValidations) {
            this.calculateOrderTax();
        }
    };
    OrderEditComponent.prototype.shippingPercentChange = function (event) {
        if (event.keyCode !== 8) {
            var value = (this.orderFormGroup.controls['shippingCostPercentage'].value
                ? this.orderFormGroup.controls['shippingCostPercentage'].value : '') + (event.key ? event.key : '');
            var pattern = /^(?:100|[1-9]?[0-9])$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    };
    OrderEditComponent.prototype.allowOnlyNumbers = function (event) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            var value = (event.key ? event.key : '');
            var pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    };
    /**
     * Save Shipping Address
     */
    OrderEditComponent.prototype.saveShippingAddress = function (address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        }
        else if (this.address && this.address.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        this.useNewShippingAddress(address);
        setTimeout(function () {
            var addtoSavedAddresses = document.getElementById('addtoSavedAddresses');
            if (addtoSavedAddresses) {
                addtoSavedAddresses.focus();
            }
        }, 200);
    };
    /**
     * @description save billing address
     * @date 2018-11-19
     * @param {Address} address
     * @memberof OrderPromotionComponent
     */
    OrderEditComponent.prototype.saveBillingAddress = function (address) {
        if (address) {
            this.billingAddressInfo = this.mapVerifiedAddressToFormFields(address);
            if (this.saveEcheckFormBtn) {
                this.saveEcheckFormBtn.nativeElement.click();
            }
        }
    };
    // *************************payvision payment section*******************************/
    /**
     * @description Load Member Saved Cards
     * @date 2018-08-30
     * @memberof PaymentComponent
     */
    OrderEditComponent.prototype.loadSavedCardsForMemberId = function (memberId, countryCode) {
        var _this = this;
        var paymentStatus = this._cacheService.get(CacheKey.PaymentStatus);
        if (paymentStatus) {
            var newCardError = this._translatePipe.get('order.Payment gateway not responding');
            this._commonService.createNotification('', newCardError.value, NotificationType.ERROR);
            this._cacheService.remove(CacheKey.PaymentStatus);
        }
        var paymentInstrumentId = this._cacheService.get(CacheKey.PaymentInstrumentId);
        this._payvisionService.getSavedPayvisonCards(memberId, countryCode, paymentInstrumentId).subscribe(function (savedCardResponse) {
            if (savedCardResponse && savedCardResponse.savedCards && savedCardResponse.savedCards.length > 0) {
                _this.paymentComponentSettings.savedCards = savedCardResponse.savedCards;
                _this.paymentComponentSettings.savedCards.forEach(function (card) {
                    card.notes = card.defaultCard ? PaymentConstants.default : '';
                });
                if (paymentInstrumentId) {
                    _this.isPaymentChanged = true;
                    _this.isNewPayment = true;
                    var selectedCard = _this.paymentComponentSettings.savedCards.find(function (x) { return x.id === paymentInstrumentId; });
                    if (selectedCard) {
                        var indexPostion = _this.paymentComponentSettings.savedCards.findIndex(function (x) { return x.id === paymentInstrumentId; });
                        _this.paymentComponentSettings.savedCards.splice(indexPostion, 1);
                        _this.paymentComponentSettings.savedCards.unshift(selectedCard);
                        _this.selectedpayvisionCardInfo = selectedCard;
                    }
                    _this.orderFormGroup.controls['paymentInstrumentId'].setValue(paymentInstrumentId);
                    _this._cacheService.remove(CacheKey.PaymentInstrumentId);
                }
                else if (_this.payvisionCardId) {
                    if (_this.selectedpayvisionCardInfo.paymentMethod === _this.paymentMethodTypes.Credit_Card
                        || _this.selectedpayvisionCardInfo.paymentMethod === _this.paymentMethodTypes.PayPal) {
                        var card = _this.paymentComponentSettings.savedCards.find(function (x) { return x.id === +_this.payvisionCardId; });
                        if (card) {
                            _this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                            _this.selectSavedCard(card);
                        }
                    }
                }
                else {
                    if (_this.paymentComponentSettings.savedCards && _this.paymentComponentSettings.savedCards.length > 0) {
                        var isDefaultCard_1 = false;
                        _this.paymentComponentSettings.savedCards.forEach(function (card) {
                            if (card.expired === false && isDefaultCard_1 === false) {
                                isDefaultCard_1 = true;
                                if (_this.selectedpayvisionCardInfo.paymentMethod === _this.paymentMethodTypes.Credit_Card
                                    || _this.selectedpayvisionCardInfo.paymentMethod === _this.paymentMethodTypes.PayPal) {
                                    _this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                                    _this.selectSavedCard(card);
                                }
                            }
                        });
                    }
                    else {
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
                        _this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                    }
                }
            }
            else {
                _this.paymentComponentSettings.savedCards = [];
            }
        }, function (error) {
            _this.paymentComponentSettings.isAddNewCard = false;
        });
    };
    /**
     * @description To get the card image
     * @date 2018-08-27
     * @param {*} cardType
     * @returns {string}
     * @memberof PaymentComponent
     */
    OrderEditComponent.prototype.getImagePath = function (cardType) {
        if (cardType) {
            switch (true) {
                case cardType.toUpperCase() === PaymentCardTypes.VISA:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/visa.png';
                    break;
                case (cardType.toUpperCase() === PaymentCardTypes.MASTER
                    || cardType.toUpperCase() === PaymentCardTypes.MASTER_WORLDPAY
                    || cardType.toUpperCase() === PaymentCardTypes.MASTERCARD):
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/mastercard.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.AMEX:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/amercianexpress.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.MAESTRO:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/maestro.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DINERS:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/dinner-club.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.JCB:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/jcb.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DISCOVER:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/discovernetwork.png';
                    break;
                default:
                    this.paymentComponentSettings.cardTypeImage = null;
                    break;
            }
        }
        return this.paymentComponentSettings.cardTypeImage;
    };
    /**
     * On change of card
     */
    OrderEditComponent.prototype.selectSavedCard = function (cardDetails, isNewCard, isPaymentChanged) {
        if (isPaymentChanged) {
            this.isPaymentChanged = true;
        }
        this.mapBillingAddress();
        this.mapShippingAddress();
        if (isNewCard) {
            if (this.shippingAddressChanged) {
                this.showVerifyAddressMessage();
                return;
            }
            this._cacheService.set(CacheKey.IsRefreshed, true);
            this.addOrderInfoToSession();
            if (this.isWorldpayPayment) {
                this.showWorldpayXml = true;
                this.showWorldPayXMLPopup.open();
            }
            else if (this.isAdyenPayment) {
                this.showAdyenPayment = true;
                this.showAdyenPaymentPopup.open();
            }
            else if (this.isNIPayment) {
                this.showNIPayment = true;
                this.showNIPopup.open();
            }
            else if (this.NexioPayment) {
                this.isNexioPayment = true;
                this.showNexioPayment.open();
            }
            else {
                this.addNewpayvisionCard = true;
                this.payvisionPayment.open();
            }
        }
        else {
            this.selectedpayvisionCardInfo = cardDetails;
            this.addNewpayvisionCard = false;
            this.showWorldpayXml = false;
            this.showNIPayment = false;
            this.isNexioPayment = false;
            this.showAdyenPayment = false;
        }
    };
    OrderEditComponent.prototype.showVerifyAddressMessage = function () {
        var verifyAddressError = this._translatePipe.get('order.Shipping Address must be verified. Please click on VERIFY ADDRESS');
        this._commonService.createNotification('', verifyAddressError.value, 'error');
    };
    OrderEditComponent.prototype.addOrderInfoToSession = function () {
        this._cacheService.remove('UpdateOrderInfo');
        var formValues = this.orderFormGroup.value;
        var OrderInfo = {
            products: formValues.items,
            countryId: formValues.countryId,
            deliveryPreference: formValues.deliveryPreference,
            memberInfo: formValues.memberInfo,
            orderType: formValues.orderType,
            paymentSelector: formValues.paymentSelector,
            shippingAddressId: formValues.shippingAddressId,
            shippingAddressInfo: this.shippingAddressInfo,
            shipMethodId: formValues.shipMethodId,
            shippingCost: formValues.shippingCost,
            shippingCostPercentage: formValues.shippingCostPercentage,
            shippingCostSelector: formValues.shippingCostSelector,
            shippingCostValue: this.shippingCost,
            webOrderId: this.webOrderId,
            saveForFutureUse: formValues.saveForFutureUse,
            isSavedAddress: this.address ? this.address.isSavedAddress : null,
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            shoppingBagClicked: this.shoppingBagClicked ? true : false,
            memberCartSessionGuid: this.shoppingBagClicked && this.memberCart
                && this.memberCart.sessionGuid ? this.memberCart.sessionGuid :
                this.shoppingBagClicked && this.memberCartSessionGuid ? this.memberCartSessionGuid : null,
            isShippingDiscountApplied: this.orderFormGroup.value.isShippingDiscountApplied,
            originalShippingCost: formValues.originalShippingCost,
        };
        this._cacheService.set('UpdateOrderInfo', OrderInfo);
    };
    /**
     *load procducts from session
     */
    OrderEditComponent.prototype.loadproducts = function (products, isDisableUpdateQuantity) {
        var _this = this;
        products.forEach(function (product) {
            _this.addItemNumber();
            var items = _this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                var index = (items.length - 1);
                if (product) {
                    var itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    var itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
                    var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    if (_this.isOrderSessionInfo) {
                        var productInfo = _this.orderSession.products.find(function (item) { return product.id === item.productId; });
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    }
                    else if (_this.isOrderFormLoad && !_this.isOrderSessionInfo) {
                        var productInfo = null;
                        if (_this.memberCart && _this.memberCart.items.length > 0) {
                            productInfo = _this.memberCart.items.find(function (item) { return product.id === item.productId; });
                        }
                        else {
                            productInfo = _this.orderInformation.orderLineItems.find(function (item) { return product.id === item.productId; });
                        }
                        var isDepositFeeProduct = productInfo ? (productInfo.depositFeeProduct ? true : false) : false;
                        var depositFeeEnabled = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords; });
                        items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                        items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                        product.orderPromotionTrackings = productInfo && productInfo.orderPromotionTrackings ? productInfo.orderPromotionTrackings : null;
                        items.controls[index].controls['productItem'].setValue(product);
                        if (items.controls[index].controls['productItem'].value.orderPromotionTrackings && items.controls[index].controls['productItem'].value.orderPromotionTrackings.length > 0) {
                            items.controls[index].controls['disableDelete'].setValue(true);
                            items.controls[index].controls['disableIncrement'].setValue(true);
                            _this.disableUpdateQuanitity[index] = true;
                        }
                        else {
                            items.controls[index].controls['disableDelete'].setValue(false);
                        }
                    }
                    if (isDisableUpdateQuantity || product.orderPromotionTrackings != null) {
                        _this.disableUpdateQuanitity[index] = true;
                    }
                    else {
                        _this.disableUpdateQuanitity[index] = false;
                    }
                }
            }
        });
        //this.updateTotalsAndShipMethod();
        // this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && !this.isOrderSessionInfo ? this.getShipMethods() : '';
    };
    /**
     * map shipping Info with the shipping form
     */
    OrderEditComponent.prototype.mapShippingAddressToShippingInfo = function () {
        var formAddress = this.orderSession.shippingAddressForm;
        var shippingAddressForm = this.orderFormGroup.get('shippingAddressForm');
        shippingAddressForm.controls[0].controls['name'].setValue(formAddress.name);
        shippingAddressForm.controls[0].controls['addressLine1'].setValue(formAddress.addressLine1);
        shippingAddressForm.controls[0].controls['addressLine2'].setValue(formAddress.addressLine2 || '');
        shippingAddressForm.controls[0].controls['addressLine3'].setValue(formAddress.addressLine3 || '');
        shippingAddressForm.controls[0].controls['addressLine4'].setValue(formAddress.addressLine4 || '');
        shippingAddressForm.controls[0].controls['city'].setValue(formAddress.city);
        shippingAddressForm.controls[0].controls['stateId'].setValue(formAddress.stateId);
        shippingAddressForm.controls[0].controls['countryId'].setValue(formAddress.countryId);
        shippingAddressForm.controls[0].controls['postalCode'].setValue(formAddress.postalCode);
        shippingAddressForm.controls[0].controls['phone'].setValue(formAddress.phone || '');
        if (this.orderSession.shipVerificationProcessDone) {
            this.shippingAddressInfo = this.orderSession.shippingAddressInfo;
        }
    };
    /**
     * map billing Info with the billing form
     */
    OrderEditComponent.prototype.mapBillingAddressToBillingInfo = function () {
        var formAddress = this.orderSession.billingAddressForm;
        var billingAddressForm = this.orderFormGroup.get('billingAddressForm');
        billingAddressForm.controls[0].controls['name'].setValue(formAddress.name);
        billingAddressForm.controls[0].controls['addressLine1'].setValue(formAddress.addressLine1);
        billingAddressForm.controls[0].controls['addressLine2'].setValue(formAddress.addressLine2 || '');
        billingAddressForm.controls[0].controls['addressLine3'].setValue(formAddress.addressLine3 || '');
        billingAddressForm.controls[0].controls['addressLine4'].setValue(formAddress.addressLine4 || '');
        billingAddressForm.controls[0].controls['city'].setValue(formAddress.city);
        billingAddressForm.controls[0].controls['stateId'].setValue(formAddress.stateId);
        billingAddressForm.controls[0].controls['countryId'].setValue(formAddress.countryId);
        billingAddressForm.controls[0].controls['postalCode'].setValue(formAddress.postalCode);
        billingAddressForm.controls[0].controls['phone'].setValue(formAddress.phone || '');
        if (this.orderSession.billVerificationProcessDone) {
            this.billingAddressInfo = this.orderSession.billingAddressInfo;
        }
    };
    /**
     * on close of payvision form popup
     */
    OrderEditComponent.prototype.onPayvisionFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this._cacheService.remove('UpdateOrderInfo');
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.addNewpayvisionCard = false;
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.payvisionPayment.close();
        this.paymentComponentSettings.payvisionFormLoaded = false;
        // To remove payvision Configurations
        this._commonService.unloadPayvisionWidget();
    };
    /**
    * @returns any
    */
    OrderEditComponent.prototype.getOrderPaymentInfo = function () {
        var payments = [];
        var orderPayment = {
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            paymentAmount: this.calculateOrderTotal(),
            redirect: false,
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
            memberPaymentMethodId: +this.orderFormGroup.controls['paymentSelector'].value,
            authorizationCode: this.orderInformation && this.orderInformation.orderPayments[0].authCode ? this.orderInformation.orderPayments[0].authCode : null,
            creditCardModel: {
                currencyCode: this.storeInfo.currencyCode,
                paymentToken: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.token : null,
                paymentMethodType: this.getPaymentMethodById(+this.orderFormGroup.controls['paymentSelector'].value),
                maskedCreditCardNumber: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.maskedCard : null,
                cardHolderName: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.nameOnTheCard : null,
                expMonth: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.expiryMonth : null,
                expYear: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.expiryYear : null
            },
            paymentECheck: (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) ? this.getEcheckInfo() : null
            // paymentECheck: (this.orderFormGroup.controls['paymentSelector'].value === this.paymentTypeEnum.eChek) ? this.getAchInfo():  null
        };
        payments.push(orderPayment);
        return payments;
    };
    /**
    * @returns payment method
    */
    OrderEditComponent.prototype.getPaymentMethodById = function (paymentMethodId) {
        var paymentType;
        switch (paymentMethodId) {
            case this.paymentTypeEnum.Credit_Card:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            case this.paymentTypeEnum.eCheck:
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case this.paymentTypeEnum.Money_order:
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case this.paymentTypeEnum.Wire_Transfer:
                paymentType = PaymentMethodTypes.Wire_Transfer;
                break;
            case this.paymentTypeEnum.Cash:
                paymentType = PaymentMethodTypes.Cash;
                break;
            case this.paymentTypeEnum.Ideal:
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case this.paymentTypeEnum.PayPal:
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case this.paymentTypeEnum.Cash_On_Delivery:
                paymentType = PaymentMethodTypes.Cash_On_Delivery;
                break;
            case this.paymentTypeEnum.Bank_Transfer:
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            case this.paymentTypeEnum.BanContact_MisterCash_and_Maestro:
                paymentType = PaymentMethodTypes.BanContact_MisterCash_and_Maestro;
                break;
            case this.paymentTypeEnum.MisterCash_and_Maestro:
                paymentType = PaymentMethodTypes.MisterCash_and_Maestro;
                break;
            case this.paymentTypeEnum.Saved_Cards:
                paymentType = PaymentMethodTypes.Saved_Cards;
                break;
            case this.paymentTypeEnum.Orange_Money:
                paymentType = PaymentMethodTypes.Orange_Money;
                break;
            case this.paymentTypeEnum.Google_Pay:
                paymentType = PaymentMethodTypes.Google_Pay;
                break;
            case this.paymentTypeEnum.Apple_Pay:
                paymentType = PaymentMethodTypes.Apple_Pay;
                break;
            case this.paymentTypeEnum.Pay_By_Link:
                paymentType = PaymentMethodTypes.Pay_By_Link;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
        }
        return paymentType;
    };
    /**
        * @returns payment method id
        */
    OrderEditComponent.prototype.getPaymentMethodEnumByName = function (paymentMethodName) {
        var paymentType;
        switch (paymentMethodName) {
            case PaymentMethodTypes.Credit_Card:
                paymentType = this.paymentTypeEnum.Credit_Card;
                break;
            case PaymentMethodTypes.eCheck:
                paymentType = this.paymentTypeEnum.eCheck;
                break;
            case PaymentMethodTypes.Money_order:
                paymentType = this.paymentTypeEnum.Money_order;
                break;
            case PaymentMethodTypes.Wire_Transfer:
                paymentType = this.paymentTypeEnum.Wire_Transfer;
                break;
            case PaymentMethodTypes.Cash:
                paymentType = this.paymentTypeEnum.Cash;
                break;
            case PaymentMethodTypes.Ideal:
                paymentType = this.paymentTypeEnum.Ideal;
                break;
            case PaymentMethodTypes.PayPal:
                paymentType = this.paymentTypeEnum.PayPal;
                break;
            case PaymentMethodTypes.Cash_On_Delivery:
                paymentType = this.paymentTypeEnum.Cash_On_Delivery;
                break;
            case PaymentMethodTypes.Bank_Transfer:
                paymentType = this.paymentTypeEnum.Bank_Transfer;
                break;
            case PaymentMethodTypes.Orange_Money:
                paymentType = this.paymentTypeEnum.Orange_Money;
                break;
            case PaymentMethodTypes.Google_Pay:
                paymentType = this.paymentTypeEnum.Google_Pay;
                break;
            case PaymentMethodTypes.Apple_Pay:
                paymentType = this.paymentTypeEnum.Apple_Pay;
                break;
            case PaymentMethodTypes.Pay_By_Link:
                paymentType = this.paymentTypeEnum.Pay_By_Link;
                break;
            default:
                paymentType = this.paymentTypeEnum.Credit_Card;
                break;
        }
        return paymentType;
    };
    /**
     * @description get selectedPayment Type
     * @date 2019-05-04
     * @returns {string}
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.getSelectedPaymentType = function () {
        var paymentMethodType;
        if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()) {
            paymentMethodType = this.getPaymentMethod('Credit_Card');
        }
        else if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) {
            paymentMethodType = this.getPaymentMethod('eCheck');
            this.savePaymentMethod = this.echeckRequest ? this.echeckRequest.reusable : false;
        }
        else if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.thirdOption.toString()) {
            paymentMethodType = this.getPaymentMethod('Money_Order');
        }
        else if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.sixthOption.toString()) {
            paymentMethodType = this.getPaymentMethod('Orange_Money');
        }
        else if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.fifthOption.toString()) {
            paymentMethodType = this.getPaymentMethod('Wire_Transfer');
        }
        return paymentMethodType;
    };
    /**
     * get controls of items
     */
    OrderEditComponent.prototype.getItemsControl = function () {
        return this.orderFormGroup.get('items');
    };
    /**
     * get payment Details
     */
    OrderEditComponent.prototype.getOrderPaymentInfoUsingWebOrderId = function (webOrderId, orderId) {
        var _this = this;
        this._customerService.getPaymentInfo(webOrderId.toUpperCase(), orderId).subscribe(function (response) {
            if (response) {
                _this.billingAddressInfo = response.billingAddress;
                _this.payvisionCardId = response.cardId;
                _this.selectedpayvisionCardInfo = response;
                _this.selectedpayvisionCardInfo.nameOnTheCard = response.cardHolderName;
                _this.selectedpayvisionCardInfo.expiryMonth = response.expiryMonth;
                _this.selectedpayvisionCardInfo.expiryYear = response.expiryYear;
                _this.selectedCardId = response.cardId;
                _this.orderFormGroup.controls['paymentInstrumentId'].setValue(_this.selectedCardId);
                if (_this.orderSession && _this.orderSession.paymentSelector) {
                    _this.orderFormGroup.controls['paymentSelector'].setValue(_this.orderSession.paymentSelector);
                }
                else {
                    var paymentMethodId_1 = _this.getPaymentMethodEnumByName(_this.selectedpayvisionCardInfo.paymentMethod);
                    _this.orderFormGroup.controls['paymentSelector'].setValue(paymentMethodId_1.toString());
                    var options = [_this.paymentTypeEnum.Money_order, _this.paymentTypeEnum.Bank_Transfer,
                        _this.paymentTypeEnum.Cash_On_Delivery, _this.paymentTypeEnum.Wire_Transfer, _this.paymentTypeEnum.Pay_By_Link, _this.paymentTypeEnum.Orange_Money];
                    if (options.some(function (x) { return x == (+paymentMethodId_1); })) {
                        if (paymentMethodId_1 === _this.paymentTypeEnum.Bank_Transfer && (_this.orderInformation && _this.orderInformation.memberTypeId)) {
                            _this.currentMemberTypeID = _this.orderInformation.memberTypeId;
                        }
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValidators([]);
                        _this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                    }
                }
            }
        });
    };
    /**
     * @description
     * @date 2019-05-23
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.disablePlaceOrderBtn = function () {
        var _this = this;
        var paymentMethodTypes = [PaymentMethodTypes.PayPal, PaymentMethodTypes.Credit_Card];
        if (this.isOrderStatusUpdateEnableStatus) {
            return !this.taxCalculationStatus && this.orderFormGroup.valid && this.unTouchedOrderRequest ? true : this.orderFormGroup.dirty;
        }
        else {
            return !this.taxCalculationStatus && this.orderFormGroup.valid && this.isPayByLinkValid &&
                (((this.unTouchedOrderRequest && this.unTouchedOrderRequest.orderPayments
                    && this.unTouchedOrderRequest.orderPayments.length > 0
                    && paymentMethodTypes.some(function (x) { return x === _this.unTouchedOrderRequest.orderPayments[0].paymentMode; })) || this.isNewPayment)
                    ? true : this.isCloneOrder ? this.orderFormGroup.valid : this.orderFormGroup.dirty);
        }
    };
    /**
     * prevent +, -, e entering in shipping cost
     */
    OrderEditComponent.prototype.keyEventShippingCost = function (event) {
        if (event.keyCode === 43 || event.keyCode === 45 || event.keyCode === 101) {
            event.preventDefault();
        }
    };
    OrderEditComponent.prototype.validateMoneyOrderAmount = function () {
        this.orderFormGroup.controls['moneyOrderAmount'].setValidators([Validators.required, Utils.moneyOrderAmountValidation]);
        this.orderFormGroup.controls['moneyOrderAmount'].updateValueAndValidity();
        var paymentSelector = +this.orderFormGroup.controls['moneyOrderAmount'].value;
        if (paymentSelector >= 0 && this.orderFormGroup.controls['moneyOrderAmount'].value) {
            var balanceOrderTotal = this.totalOrderCost - paymentSelector;
            if (balanceOrderTotal === 0) {
                this.validateEnteredAmount = true;
            }
            else {
                this.validateEnteredAmount = false;
            }
        }
        else {
            this.validateEnteredAmount = true;
        }
    };
    OrderEditComponent.prototype.enableAmount = function (event) {
        this.orderFormGroup.controls['enableStatus'].setValue(!this.orderFormGroup.controls['enableStatus'].value);
        if (this.orderFormGroup.controls['enableStatus'].value) {
            this.orderFormGroup.controls['moneyOrderAmount'].enable();
        }
        else {
            this.orderFormGroup.controls['moneyOrderAmount'].disable();
            this.validateEnteredAmount = true;
        }
        this.orderFormGroup.controls['moneyOrderAmount'].setValue('');
    };
    // *************************************** ECheck Payment****************************/
    /**
     * Get ECheck payment
     */
    OrderEditComponent.prototype.getSavedEchecks = function () {
        var _this = this;
        if (this.memberInfo.memberId) {
            this._echeckService.getSavedEchecks(this.memberInfo.memberId, this.selectedIsoCountryCode, this.eCheckTokenRes)
                .subscribe(function (response) {
                if (response && response.length > 0) {
                    _this.paymentComponentSettings.savedEChecks = response;
                    if (_this.echeckRequest && _this.echeckRequest.reusable) {
                        var selectedCard = _this.paymentComponentSettings.savedEChecks.find(function (x) { return x.id === _this.echeckRequest.id; });
                        if (selectedCard) {
                            var indexPostion = _this.paymentComponentSettings.savedEChecks
                                .findIndex(function (x) { return x.id === _this.echeckRequest.id; });
                            _this.paymentComponentSettings.savedEChecks.splice(indexPostion, 1);
                            _this.paymentComponentSettings.savedEChecks.unshift(selectedCard);
                            _this.orderFormGroup.controls['paymentInstrumentId'].setValue(_this.echeckRequest.id);
                        }
                        else {
                            var index = _this.paymentComponentSettings.savedEChecks.length - 1;
                            _this.orderFormGroup.controls['paymentInstrumentId']
                                .setValue(_this.paymentComponentSettings.savedEChecks[index].id);
                            // this.orderFormGroup.controls['paymentInstrumentId']
                            //     .setValue(this.paymentComponentSettings.savedEChecks[0].id);
                        }
                        // this.selectECheck();
                    }
                }
                else {
                    _this.paymentComponentSettings.savedEChecks = [];
                    _this.savedEChecks = '';
                }
                _this.savedEChecks = JSON.stringify(_this.paymentComponentSettings.savedEChecks);
            });
        }
    };
    /**
     * on change of payment method
     */
    OrderEditComponent.prototype.onPaymentMethodChnage = function () {
        var _this = this;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        //this.selectedpayvisionCardInfo = null;
        this.echeckRequest = null;
        var options = [this.paymentTypeEnum.Money_order, this.paymentTypeEnum.Wire_Transfer, this.paymentTypeEnum.Bank_Transfer,
            this.paymentTypeEnum.Cash_On_Delivery, this.paymentTypeEnum.Cash, this.paymentTypeEnum.BanContact_MisterCash_and_Maestro,
            this.paymentTypeEnum.MisterCash_and_Maestro, this.paymentTypeEnum.Pay_By_Link, this.paymentTypeEnum.Orange_Money];
        this.orderFormGroup.controls['moneyOrderAmount'].setValue('');
        if (options.some(function (x) { return x == (+_this.orderFormGroup.controls['paymentSelector'].value); })) {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([]);
            this.orderFormGroup.controls['enableStatus'].setValue(false);
            this.orderFormGroup.controls['moneyOrderAmount'].disable();
        }
        else {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['moneyOrderAmount'].setValidators([]);
        }
        this.setPayByLinkEmail();
        this.selectedpayvisionCardInfo.paymentMethod = this.getPaymentMethodById(+this.orderFormGroup.controls['paymentSelector'].value);
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
    };
    OrderEditComponent.prototype.setPayByLinkEmail = function () {
        if ((+this.orderFormGroup.controls['paymentSelector'].value) === this.paymentTypeEnum.Pay_By_Link) {
            var email = this.paymentComponentSettings && this.paymentComponentSettings.memberEmail ? this.paymentComponentSettings.memberEmail : this.address && this.address.email ? this.address.email : null;
            if (email != null) {
                this.emailForm.controls['payByLinkEmail'].setValue(email);
            }
            else {
                this.emailForm.controls['payByLinkEmail'].setValue('');
            }
            this.emailForm.controls['payByLinkEmail'].updateValueAndValidity();
            if (this.emailForm.controls['payByLinkEmail'].value !== '') {
                this.isPayByLinkValid = true;
            }
            else {
                this.isPayByLinkValid = false;
            }
        }
        else {
            this.isPayByLinkValid = true;
        }
    };
    /**
     * on change of Echeck
     */
    OrderEditComponent.prototype.selectECheck = function (echeckDetails, isNewEcheck) {
        this.isPaymentChanged = true;
        if (isNewEcheck) {
            this.buildEcheckForm();
            this.echeckSubmitted = false;
            this.eCheckPaymentPopup.open();
            this.addNeweCheck = true;
        }
        else {
            this.selectedECheckInfo = echeckDetails;
            this.billingAddressInfo = echeckDetails.billingAddress;
            this.addNeweCheck = false;
            this.eCheckTokenRes = '';
            this.echeckRequest = {
                portalCsp: true,
                id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
                portalType: EcheckPortalTypes.CustomerCare,
                accountNumber: this.selectedECheckInfo.accountNumber,
                routingNumber: this.selectedECheckInfo.routingNumber,
                bankName: this.selectedECheckInfo.bankName,
                accountType: this.selectedECheckInfo.accountType,
                nameOnBankAccount: this.selectedECheckInfo.nameOnBankAccount,
                reusable: this.selectedECheckInfo.reusable,
                defaultECheck: this.selectedECheckInfo.defaultECheck,
                customerId: this.memberInfo.memberId,
                billingAddress: this.getBillingAddressForECheck(),
                billingAddressId: null,
                billingAddressRequired: true,
                customMessage: '',
                storeId: this.storeInfo.id,
                email: this.selectedECheckInfo.email,
                phone: this.selectedECheckInfo.phone
            };
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    };
    /**
     * when Echeck form is closed
     */
    OrderEditComponent.prototype.onECheckFormClose = function () {
        this.eCheckPaymentPopup.close();
        this.addNeweCheck = false;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedEcheckDdl && this.savedEcheckDdl.nativeElement) {
            this.savedEcheckDdl.nativeElement.focus();
        }
    };
    /**
     * buildEcheckForm
     */
    OrderEditComponent.prototype.buildEcheckForm = function () {
        var phone = '';
        var email = '';
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            }
            else {
                phone = this.memberInfo.phone;
            }
        }
        this.echeckForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            accountType: ['', [Validators.required]],
            nameOnBankAccount: ['', [Validators.required, CustomValidators.requiredNotEmpty, Utils.alphaNumericCharacterValidation, Validators.maxLength(25)]],
            bankName: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            reuse: [false],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]]
        });
    };
    OrderEditComponent.prototype.validateNewECheck = function () {
        this.echeckSubmitted = true;
        if (this.echeckForm.valid) {
            var echeckFormValue_1 = this._commonService.trimObjectValues(this.echeckForm.value);
            if (echeckFormValue_1.phone) {
                var phoneCode = PhoneCodesConstants.phoneCodes.find(function (x) { return echeckFormValue_1.phone.toUpperCase().indexOf(x.name) > -1; });
                if (phoneCode) {
                    echeckFormValue_1.phone = echeckFormValue_1.phone;
                }
                else {
                    if (this.phoneNumberFormat) {
                        echeckFormValue_1.phone = this._maskPipe.transform(echeckFormValue_1.phone, this.phoneNumberFormat);
                    }
                    else {
                        echeckFormValue_1.phone = echeckFormValue_1.phone;
                    }
                }
            }
            var validateECheckReq = {
                accountNumber: echeckFormValue_1.accountNumber,
                accountType: echeckFormValue_1.accountType,
                bankName: echeckFormValue_1.bankName,
                routingNumber: echeckFormValue_1.routerNumber,
                addressOne: this.billingAddressInfo.addressLine1,
                addressTwo: this.billingAddressInfo.addressLine2,
                city: this.billingAddressInfo.city,
                country: this.paymentComponentSettings.isoTwoletterCountryCode,
                state: this.billingAddressInfo.stateCode,
                zip: this.billingAddressInfo.postalCode,
                email: echeckFormValue_1.email,
                phone: echeckFormValue_1.phone,
                paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.eCheck
            };
            this.validateECheck(validateECheckReq);
        }
    };
    /**
     * @description
     * @date 2019-01-22
     * @param {ValidateEcheckRequest} validateECheckReq
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.validateECheck = function (validateECheckReq) {
        var _this = this;
        this.eCheckValidationMessages = [];
        this._echeckService.validateEcheck(validateECheckReq)
            .subscribe(function (response) {
            if (response && response.success) {
                _this.savePersonalEcheck(validateECheckReq);
            }
            else if (response && !response.success && response.validations.length > 0) {
                _this.eCheckValidationMessages = response.validations.map(function (validation) { return validation.message; });
            }
            else {
                _this.eCheckValidationMessages.push('Echeck validation failed.');
            }
        }, function (error) {
            _this.eCheckValidationMessages.push('Echeck validation failed.');
        });
    };
    /**
     * save personal echecks
     */
    OrderEditComponent.prototype.savePersonalEcheck = function (eCheckInfo) {
        var _this = this;
        this.echeckRequest = {
            portalCsp: true,
            id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
            portalType: EcheckPortalTypes.CustomerCare,
            accountNumber: eCheckInfo.accountNumber,
            routingNumber: eCheckInfo.routingNumber,
            bankName: eCheckInfo.bankName,
            accountType: eCheckInfo.accountType,
            nameOnBankAccount: this.addNeweCheck ? eCheckInfo.name : this.selectedECheckInfo.nameOnBankAccount,
            reusable: this.addNeweCheck ? this.echeckForm.value.reuse : this.selectedECheckInfo.reusable,
            defaultECheck: this.addNeweCheck ? false : this.selectedECheckInfo.defaultECheck,
            customerId: this.memberInfo.memberId,
            billingAddress: this.getBillingAddressForECheck(),
            billingAddressId: null,
            billingAddressRequired: true,
            customMessage: '',
            storeId: this.storeInfo.id,
            email: eCheckInfo.email,
            phone: eCheckInfo.phone
        };
        this._echeckService.savePersonalCheck(this.memberInfo.memberId, this.echeckRequest)
            .subscribe(function (response) {
            if (response) {
                _this.eCheckTokenRes = response;
                _this.echeckSubmitted = false;
                if (_this.addNeweCheck) {
                    _this.eCheckPaymentPopup.close();
                    var savedEChecks = JSON.parse(_this.savedEChecks);
                    _this.paymentComponentSettings.savedEChecks = savedEChecks;
                    // this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                    // if (!this.echeckRequest.reusable) {
                    //     this.paymentComponentSettings.savedEChecks.push(this.echeckRequest);
                    //     this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.echeckRequest.id);
                    // } else {
                    //     this.getSavedEchecks();
                    // }
                    if (_this.echeckRequest && _this.echeckRequest.reusable) {
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue(_this.echeckRequest.id);
                        _this.getSavedEchecks();
                    }
                    else {
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue(_this.echeckRequest.id);
                    }
                }
                if (_this.paymentFormBtn && _this.paymentFormBtn.nativeElement) {
                    _this.paymentFormBtn.nativeElement.focus();
                }
            }
            else {
                _this.eCheckValidationMessages.push('Echeck validation failed.');
            }
        }, function (error) {
            _this.eCheckValidationMessages.push('Echeck validation failed.');
        });
    };
    /**
     * map billing address for e-Check
     */
    /**
     * map billing address for e-Check
     */
    OrderEditComponent.prototype.getBillingAddressForECheck = function () {
        var stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        var billingAddress = {
            id: null,
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2 || '',
            addressLine3: this.billingAddressInfo.addressLine3 || '',
            addressLine4: this.billingAddressInfo.addressLine4 || '',
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            countryId: this.billingAddressInfo.countryId,
            city: this.billingAddressInfo.city,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            country: this.billingAddressInfo.countryCode,
            countryCode: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            firstName: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            phone: ''
        };
        return billingAddress;
    };
    /**
     * get billing Address Id
     */
    OrderEditComponent.prototype.getBillingAddressId = function () {
        var billingAddressId = 0;
        if (this.orderFormGroup.value.billingAddressId) {
            billingAddressId = this.orderFormGroup.value.billingAddressId;
        }
        else if (this.orderFormGroup.controls['billingAddressSelector'].value === this.selectEnum.thirdOption.toString()) {
            var shippingAddressId = 0;
            if (this.orderFormGroup.value.shippingAddressId) {
                shippingAddressId = this.orderFormGroup.value.shippingAddressId;
            }
            else if (this.verifiedShippingAddressId) {
                shippingAddressId = this.verifiedShippingAddressId;
            }
            billingAddressId = shippingAddressId;
        }
        else if (this.verifiedBillingAddressId) {
            billingAddressId = this.verifiedBillingAddressId;
        }
        return billingAddressId;
    };
    /**
     * @description add mask while chnaging phone number
     *
     * @memberof EcheckComponent
     */
    OrderEditComponent.prototype.onChangeEcheckPhone = function ($event) {
        var value = this.echeckForm.controls['phone'].value;
        var updatedValue = value;
        var alphaNumericValue = value.replace(/[^a-z0-9]/gi, '');
        if (value.match(/[a-zA-Z]/)) {
            if (alphaNumericValue.substr(0, 3).match(/[a-zA-Z]/)) {
                updatedValue = value.replace(/[^a-z0-9]/gi, '');
            }
            else if (alphaNumericValue.substr(3, 3).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) AAAAAAA');
            }
            else if (alphaNumericValue.substr(6, 4).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) 000-AAAA');
            }
        }
        else {
            if (alphaNumericValue.length !== 3) {
                if (this.phoneNumberFormat) {
                    updatedValue = this._maskPipe.transform(value, this.phoneNumberFormat);
                }
                else {
                    updatedValue = value;
                }
            }
        }
        this.echeckForm.controls['phone'].setValue(updatedValue);
    };
    /**
     * map Echeck Info for payment
     */
    OrderEditComponent.prototype.getEcheckInfo = function () {
        var eCheckInfo = {
            bankName: this.echeckRequest.bankName,
            accountNumber: this.echeckRequest.accountNumber,
            routingNumber: this.echeckRequest.routingNumber,
            accountType: this.echeckRequest.accountType,
            mecTransactionID: '',
            nameOnBankAccount: this.echeckRequest.nameOnBankAccount,
            customMessage: '',
            reusable: this.echeckRequest.reusable,
            eCheckID: this.eCheckTokenRes ? parseInt(atob(this.eCheckTokenRes), 10) : this.echeckRequest ? this.echeckRequest.id : 0,
            email: this.echeckRequest.email,
            phone: this.echeckRequest.phone
        };
        return eCheckInfo;
    };
    OrderEditComponent.prototype.onWorldpayXMLFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this._cacheService.remove('UpdateOrderInfo');
        this.showWorldpayXml = false;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showWorldPayXMLPopup.close();
    };
    OrderEditComponent.prototype.onAdyenPaymentFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showAdyenPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showAdyenPaymentPopup.close();
    };
    OrderEditComponent.prototype.onNIFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNIPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this._cacheService.remove('UpdateOrderInfo');
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNIPopup.close();
    };
    OrderEditComponent.prototype.onNexioFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.isNexioPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this._cacheService.remove('UpdateOrderInfo');
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNexioPayment.close();
    };
    /**
 * get restricted products
 */
    OrderEditComponent.prototype.getRestrictedProducts = function (productModels) {
        var _this = this;
        this.isRestrictedProduct = true;
        this.getShippingRestrictionError();
        this.restrictedProducts = [];
        productModels.forEach(function (product) {
            var itemNumber = product.itemNumber.substring(product.itemNumber.indexOf('#') + 1);
            var item = _this.products.find(function (x) { return x.itemNumber === itemNumber; });
            item ? _this.restrictedProducts.push(item.name + ' - #' + itemNumber) : '';
        });
        this.showRestrictedProducts.open();
    };
    /**
     * generates and return Order Message based of changes made to Order.
     */
    OrderEditComponent.prototype.getOrderLogMessage = function () {
        var _this = this;
        var orderLog = '';
        var intialProductIds = this.orderInformation.orderLineItems.map(function (item) { return item.productId; });
        this.products.forEach(function (product) {
            var initialProduct = _this.orderInformation.orderLineItems.find(function (item) { return item.productId === product.id; });
            if (initialProduct) {
                intialProductIds.splice(intialProductIds.indexOf(initialProduct.productId), 1);
                if (initialProduct.quantity != +product.quantity) {
                    orderLog += 'The quantity of Item #' + product.itemNumber + ' - ' + product.name + ' changed from ' + initialProduct.quantity + ' to ' + product.quantity + '. ';
                }
            }
            else {
                orderLog += 'Item #' + product.itemNumber + ' - ' + product.name + ' added and quantity is ' + product.quantity + '. ';
            }
        });
        intialProductIds.forEach(function (id) {
            var initialProduct = _this.orderInformation.orderLineItems.find(function (item) { return item.productId === id; });
            orderLog += 'Item #' + initialProduct.itemNumber + ' - ' + initialProduct.productName + ' removed. ';
        });
        var newShipMethod = this.shippingMethods.find(function (item) { return item.shippingMethodId === +_this.orderFormGroup.value.shipMethodId; });
        if (this.orderInformation.orderShippings[0].deliveryPreferenceId
            !== this.orderFormGroup.value.deliveryPreference) {
            var initialPreference = Object.keys(DeliveryPreference)
                .find(function (k) { return DeliveryPreference[k] === _this.orderInformation.orderShippings[0].deliveryPreferenceId; });
            var newPreference = Object.keys(DeliveryPreference).find(function (k) { return DeliveryPreference[k]
                === _this.orderFormGroup.value.deliveryPreference; });
            orderLog += 'Delivery preference changed from ' + initialPreference + ' to ' + newPreference + '.';
            if (+this.orderFormGroup.value.shipMethodId !== this.orderInformation.orderShippings[0].shipMethodId) {
                if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) {
                    orderLog += 'Shipping Method is ' + newShipMethod.shippingMethodDisplayName + '. ';
                }
                else {
                    orderLog += 'Pick Up location is ' + newShipMethod.pickUpLocation.name + '. ';
                }
            }
        }
        else {
            if (+this.orderFormGroup.value.shipMethodId !== this.orderInformation.orderShippings[0].shipMethodId) {
                if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) {
                    orderLog += 'Shipping Method changed to ' + newShipMethod.shippingMethodDisplayName + '. ';
                }
                else {
                    orderLog += 'Pick Up location changed to ' + newShipMethod.pickUpLocation.name + '. ';
                }
            }
        }
        if (this.orderFormGroup && this.orderFormGroup.controls['shippingCostPercentage']
            && this.orderFormGroup.controls['shippingCostPercentage'].value > 0) {
            var discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value;
            orderLog += 'Shipping Cost was discounted by ' + (discountPercentage + '%') + '. ';
        }
        else if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY
            && this.orginalShippingCost !== (this.shippingCost + this.originalShippingTax)) {
            var costDifference = this.shippingCost - this.orginalShippingCost;
            orderLog += costDifference > 0 ? 'Shipping Cost was increased by ' + this._currencyPipe.
                transform(costDifference, this.storeInfo, true) +
                '.' : 'Shipping Cost was discounted by ' + this._currencyPipe.
                transform(-costDifference, this.storeInfo, true) + '.';
        }
        var paymentInfo = this.getOrderPaymentInfo();
        if (this.orderInformation.orderPayments.length > 0 && this.orderInformation.orderPayments[0].paymentMode
            && paymentInfo[0].creditCardModel.paymentMethodType !== this.orderInformation.orderPayments[0].paymentMode) {
            orderLog += 'Order payment method changed from ' + this.orderInformation.orderPayments[0].paymentMode
                + ' to ' + paymentInfo[0].creditCardModel.paymentMethodType + '. ';
            if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Credit_Card) {
                orderLog += 'Payment done through card number ending with' + paymentInfo[0].creditCardModel.maskedCreditCardNumber + '. ';
            }
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Money_order
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            var moneyOrderAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += ' Money Order funds ' + moneyOrderAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Orange_Money
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            var orangeMoneyAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += 'Orange Money funds ' + orangeMoneyAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Wire_Transfer
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            var moneyOrderAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += ' Wire Transfer funds ' + moneyOrderAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Bank_Transfer
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            var bankTransferAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += ' Bank Transfer funds ' + bankTransferAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Cash_On_Delivery
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            var CashOnDeliveryAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += ' Cash On Delivery Amount ' + CashOnDeliveryAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        //orderLog += "Order updated by " + this.userInfo.firstName + ' ' + (this.userInfo.middleName ? (this.userInfo.middleName + ' ') : '') + (this.userInfo.lastName ? this.userInfo.lastName : '') + ". ";
        return orderLog;
    };
    /**
    * create order log request parameter
    */
    OrderEditComponent.prototype.createOrderLog = function (response, isNewOrder, shippingInfo) {
        var _this = this;
        var orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': isNewOrder ? response.id : this.orderInformation.id,
            'webOrderId': isNewOrder ? response.webOrderId : this.orderInformation.webOrderId,
            'message': isNewOrder ? (shippingInfo ? shippingInfo : 'Order Placed by the agent') : response,
            'source': Constants.CUSTOMER_SERIVCE
        };
        if (orderLogRequest && orderLogRequest.message) {
            this._orderservice.createOrderLog(orderLogRequest)
                .subscribe(function (response) {
            }, function (error) {
                _this._commonService.createNotification('', 'Failed to Create order log', 'error');
            });
        }
    };
    /**
     * @description sip to different address click
     * @date 2018-11-16
     * @memberof OrderPromotionComponent
     */
    OrderEditComponent.prototype.shipToDifferentAddress = function () {
        this.showSavedAddress = true;
        this.isNewCard = false;
    };
    /**
     * @description this method will show new address form
     * @date 2018-11-16
     * @memberof OrderPromotionComponent
     */
    OrderEditComponent.prototype.addNewAddress = function () {
        if (this.shippingAddressInfoConfig && (!this.shippingAddressInfoConfig.pudoLocationsEnabled && this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayDropAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewDropshipPersonAddress();
        }
        this.address = null;
        this.showSavedAddress = false;
        this.isNewCard = true;
        this.clearPudoLocationSearchData();
    };
    OrderEditComponent.prototype.clearPudoLocationSearchData = function () {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = true;
        this.buildPudoLocationSearchForm();
    };
    /**
 * map the billing address fields
 */
    OrderEditComponent.prototype.mapBillingAddress = function () {
        var _this = this;
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY && (this.shippingAddressInfo && this.shippingAddressInfo.countryId) || (this.memberInfo && this.memberInfo.address)) {
            var address = (this.memberInfo && this.memberInfo.address) || this.shippingAddressInfo;
            this.paymentComponentSettings.billingAddress = address;
            var country = void 0;
            if (this.shippingAddressInfo && (this.shippingAddressInfo.stateCode === PaymentConstants.PuertoRico
                || this.shippingAddressInfo.stateCode === PaymentConstants.VirginIslands
                || this.shippingAddressInfo.stateCode === PaymentConstants.MarshallIslands)) {
                if (this.shippingAddressInfo.stateCode === PaymentConstants.MarshallIslands) {
                    country = this.countries.filter(function (x) { return x.isocodeThree.toLowerCase()
                        === _this.shippingAddressInfo.stateCode.toLowerCase(); })[0];
                }
                else {
                    country = this.countries.filter(function (x) { return x.isocodeTwo.toLowerCase()
                        === _this.shippingAddressInfo.stateCode.toLowerCase(); })[0];
                }
            }
            else {
                if (this.shippingAddressInfo && this.shippingAddressInfo.countryId) {
                    country = this.countries.filter(function (x) { return x.countryId === _this.shippingAddressInfo.countryId; })[0];
                }
            }
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            if (this.shippingAddressInfo && this.shippingAddressInfo.postalCode) {
                this.paymentComponentSettings.billingAddress.zipCode = this.shippingAddressInfo.postalCode;
            }
        }
        else {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            var country = this.countries.filter(function (x) { return x.countryId === _this.memberInfo.address.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
    };
    /**
     * verifyOrderRules
     * @returns boolean
     */
    OrderEditComponent.prototype.verifyOrderRules = function (isBackOrderDate) {
        var valid;
        valid = { thresholdCrossed: false, monthlyCCValid: false, memberCCOverride: false };
        var monthlyCCValid = false;
        var thresholdCrossed = false;
        var totalPoints = this.calculateTotalPoints();
        var subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
        if (this.selectedpayvisionCardInfo && (this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Bank_Transfer ||
            this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Money_order ||
            this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Orange_Money ||
            this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Wire_Transfer ||
            this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Cash_On_Delivery)
            && this.orderInformation && !(this.orderStatusId.Failed == this.orderInformation.orderStatusId)
            && this.paymentStatusEnum.PEND == this.orderInformation.orderPayments[0].paymentStatusId) {
            this.isMoneyOrderAmountUpdate = true;
        }
        // changes for order min/max for taxInclusive stores PS2022-1077
        if (this.storeInfo && this.storeInfo.taxInclusive) {
            subTotal = this.itemTotal;
        }
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints >= this.orderRules.minValue && totalPoints <= this.orderRules.maxValue)) {
            thresholdCrossed = false;
        }
        else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
            if (this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                thresholdCrossed = this.validateSubTotalBasedOnType(this.products, subTotal);
            }
            else if (subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue) {
                thresholdCrossed = false;
            }
            else {
                thresholdCrossed = true;
                if (subTotal <= this.orderRules.minValue && (this.orderInformation.overrideMinimumLimit === true || this.isOrderStatusUpdateEnableStatus || this.isMoneyOrderAmountUpdate)) {
                    thresholdCrossed = false;
                }
            }
        }
        else {
            thresholdCrossed = true;
        }
        if (this.memberInfo && this.memberOrderCCInfo) {
            var maxValue = void 0;
            if (this.appConfig && !this.appConfig.displayPurchaseLimitationMessage && (this.orderRules &&
                this.orderRules.valueType === ValueType.PRICE && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                maxValue = this.orderRules.maxCCValue > this.memberOrderCCInfo.maxCCValue
                    ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            }
            else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && this.orderRules.monthlyValueType === ValueType.CC) {
                maxValue = this.orderRules.maxCCValue >= this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            }
            else {
                maxValue = this.orderRules.maxValue > this.memberOrderCCInfo.maxValue
                    ? this.orderRules.maxValue : this.memberOrderCCInfo.maxValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxValue;
            }
            if ((totalPoints + this.memberOrderCCInfo.actualCCValue) > maxValue) {
                monthlyCCValid = true;
                thresholdCrossed = false;
            }
            // Monthly CC override for member
            if (this.orderRules && this.memberOrderCCInfo && this.memberCCOverride
                && this.memberCCOverride.overrideFlag) {
                var currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
                var endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                    .format(DateConstants.DateFormat);
                if (!isBackOrderDate) {
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    }
                    else if ((this.orderRules && this.orderRules.maxCCValue < this.memberCCOverride.cVLimit)
                        && ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        monthlyCCValid = false;
                    }
                }
                else {
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    }
                }
            }
        }
        if (!totalPoints) {
            monthlyCCValid = false;
            thresholdCrossed = false;
        }
        valid.thresholdCrossed = thresholdCrossed;
        valid.monthlyCCValid = monthlyCCValid;
        // for order rule value type: BOTH
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            var totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            var details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC);
            valid.cartLimitExceed = details.cartLimitExceed;
            valid.cartLimitNotReach = details.cartLimitNotReach;
            valid.monthlyCCValid = details.monthlyCCValid;
            valid.monthlyCCValue = details.monthlyCCValue;
            valid.thresholdCrossed = details.thresholdCrossed;
        }
        return valid;
    };
    /**
        * calculateSubtotalWithWholesalePrice()
        * @param shoppingCart
        */
    OrderEditComponent.prototype.calculateSubtotalWithWholesalePrice = function (orderSubTotal) {
        var _this = this;
        var subTotal = orderSubTotal;
        if (this.products && this.products.length &&
            this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
            && this.appConfig.displayPurchaseLimitationMessage
            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
            subTotal = 0;
            this.products.forEach(function (item) {
                subTotal += ((_this.countryTaxInclusive ? item.wholesalePrice : item.baseWholesalePrice) * item.quantity);
            });
            // Should not apply wholesale price when user exceeds limit,
            // Wholesale price calculation applicable for minimum limit restriction
            if (orderSubTotal > this.orderRules.maxValue) {
                subTotal = orderSubTotal;
            }
        }
        return subTotal;
    };
    /**
     * Get total points
     */
    OrderEditComponent.prototype.calculateTotalPoints = function () {
        var _totalCV = 0;
        for (var i = 0; i < this.products.length; i++) {
            if (!this.products[i].literature) {
                _totalCV += this.products[i].commissionableVolume * this.products[i].quantity;
            }
        }
        return _totalCV;
    };
    /**
     * Get Total added Products Cost.
     */
    OrderEditComponent.prototype.calculateItemsSubTotal = function (store) {
        var itemsSubTotal = 0;
        for (var i = 0; i < this.products.length; i++) {
            if (this.products[i].applicablePrice) {
                itemsSubTotal += Number(this.products[i].applicablePrice.
                    // tslint:disable-next-line:no-bitwise
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * this.products[i].quantity;
            }
        }
        if (store) {
            // tslint:disable-next-line:no-bitwise
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return itemsSubTotal;
    };
    /**
   * @description get Order Min Max Business Rules
   * @memberof OrderPromotionComponent
   */
    OrderEditComponent.prototype.getOrderRules = function () {
        var _this = this;
        var userInfo = this.memberInfo;
        var orderRulesRequest = {
            countryCode: this.selectedIsoCountryCode,
            memberTitleId: this.orderInformation && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : MemberLevel.RETAIL,
            orderType: this.orderInformation && this.orderInformation.memberLevelId !== MemberLevel.RETAIL ? MemberOrderType.Personal
                : MemberOrderType.Retail
        };
        this._orderService.getOrderBusinessRules(orderRulesRequest)
            .subscribe(function (response) {
            if (response) {
                _this.orderRules = response;
            }
        }, function (error) {
        });
        if (userInfo && userInfo.memberId && (this.memberInfo.memberTypeId === MemberTypeEnum.FPC
            || this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
            this.getMemberOrderRules(userInfo, false);
            this.getMemberCCOverrides(userInfo.memberId);
        }
    };
    /**
       * @description savePayment methos
       * @memberof OrderPromotionComponent
       */
    OrderEditComponent.prototype.savePaymentMethodClicked = function (savePaymentMethod) {
        this.isPaymentChanged = true;
        this.savePaymentMethod = !savePaymentMethod;
    };
    /**
       *
       * @param items
       */
    OrderEditComponent.prototype.getItemVolumeSum = function (items) {
        if (this.appConfig.roundoffTaxAmount) {
            return Math.round(items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; }));
        }
        else {
            return items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; });
        }
    };
    OrderEditComponent.prototype.trackByItem = function (index) {
        return index;
    };
    OrderEditComponent.prototype.moveToItemLevelSearchBlock = function (event) {
        if (this.itemLevelSearchInput && this.itemLevelSearchInput.nativeElement) {
            this.itemLevelSearchInput.nativeElement.focus();
        }
    };
    OrderEditComponent.prototype.validateSubTotalBasedOnType = function (products, subTotal) {
        var isThresholdCrossed = true;
        var itemSubTotal = subTotal;
        var orderMinValue = this.orderRules.minValue;
        var orderMaxValue = this.orderRules.maxValue;
        if (this.isLiteratureValidation(products)) {
            orderMinValue = this.orderRules.literatureMinValue;
            orderMaxValue = this.orderRules.literatureMaxValue;
        }
        if (itemSubTotal >= orderMinValue && itemSubTotal <= orderMaxValue) {
            isThresholdCrossed = false;
        }
        if (itemSubTotal <= orderMinValue) {
            this.orderInformation.overrideMinimumLimit === true || this.isOrderStatusUpdateEnableStatus || this.isMoneyOrderAmountUpdate ? isThresholdCrossed = false : isThresholdCrossed = true;
        }
        return isThresholdCrossed;
    };
    OrderEditComponent.prototype.isLiteratureValidation = function (products) {
        var literatureItems = products && products.filter(function (item) { return item.literature; });
        var isLiterature = literatureItems && literatureItems.length && products && products.length
            && products.length === literatureItems.length;
        return isLiterature;
    };
    /**
    * @description This method used to get cart items by member
    * getCartItemsByMemberAndCartTypeId()
    * @returns void
    */
    OrderEditComponent.prototype.getCartItemsByMemberAndCartTypeId = function (isSaveBagClicked) {
        var _this = this;
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId, CartTypes.OrderCart, this.storeInfo)
            .subscribe(function (cartInfo) {
            if (cartInfo && cartInfo.sessionGuid) {
                _this.memberCart = cartInfo;
                if (!_this.isOrderSessionInfo && cartInfo.items && cartInfo.items.length && !isSaveBagClicked) {
                    var productIds = cartInfo.items.map(function (x) { return x.productId; });
                    _this.getProductsByIds(productIds);
                }
            }
            else {
                _this.memberCart = null;
            }
            if (isSaveBagClicked) {
                _this.saveBag(true);
            }
        }, function (error) {
            new Error(error);
        });
    };
    /**
   * Save and update bag items
   * @returns void
   */
    OrderEditComponent.prototype.saveBag = function (isFallBack) {
        var _this = this;
        var items = this.getOrderLineItems(this.countryTaxInclusive);
        if (items && items.length) {
            if (this.memberCart && this.memberCart.sessionGuid) {
                this.prepareCartUpdateRequest();
                this._customerService.updateCart(this.memberCart, CartTypes.OrderCart, this.storeInfo.id, this.memberInfo.memberId, 1).subscribe(function (response) {
                    if (response) {
                        _this.createSuccessNotification(response);
                        _this._cacheService.set(CacheKey.CARTUPDATED, 'true');
                    }
                });
            }
            else {
                if (!isFallBack) {
                    this.getCartItemsByMemberAndCartTypeId(true);
                }
                else {
                    var cart = this.prepareCartCreateRequest();
                    this._customerService.saveCart(cart, CartTypes.OrderCart, this.storeInfo.id, this.memberInfo.memberId, 1).subscribe(function (response) {
                        if (response) {
                            _this.createSuccessNotification(response);
                            _this._cacheService.set(CacheKey.CARTUPDATED, 'true');
                        }
                    });
                }
            }
            this.getShoppingCartCount(this.storeInfo);
        }
    };
    /**
      * prepare update request
      * prepareCartUpdateRequest()
      * @returns void
      */
    OrderEditComponent.prototype.prepareCartUpdateRequest = function () {
        var _this = this;
        var items = this.getOrderLineItems(this.countryTaxInclusive);
        items.forEach(function (item) {
            var product = _this.memberCart.items.find(function (itm) { return itm.productId === item.productId; });
            if (product) {
                _this.memberCart.items.forEach(function (cart) {
                    if (cart.productId === product.productId) {
                        cart.quantity = _this.shoppingBagClicked ? item.quantity : cart.quantity + Number(item.quantity);
                    }
                });
            }
            else {
                var productItem = {
                    productId: item.productId,
                    quantity: item.quantity
                };
                _this.memberCart.items.push(productItem);
            }
        });
        if (this.shoppingBagClicked) {
            this.memberCart.items = this.memberCart.items.filter(function (item) {
                return items.map(function (product) { return product.productId; }).indexOf(item.productId) > -1;
            });
        }
    };
    /**
      * prepare create request
      * prepareCartCreateRequest()
      * @returns void
      */
    OrderEditComponent.prototype.prepareCartCreateRequest = function () {
        var items = this.getOrderLineItems(this.countryTaxInclusive);
        var memberCart = { items: [] };
        items.forEach(function (item) {
            var productItem = {
                productId: item.productId,
                quantity: item.quantity
            };
            memberCart.items.push(productItem);
        });
        return memberCart;
    };
    // get existing shopping cart item count
    OrderEditComponent.prototype.getShoppingCartCount = function (storeInfo) {
        var _this = this;
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId, CartTypes.OrderCart, storeInfo)
            .subscribe(function (cartInfo) {
            _this.existingItemCount = 0;
            if (cartInfo && cartInfo.sessionGuid) {
                _this.memberCartInfo = cartInfo;
                _this.existingItemCount = 0;
                var cartItems = cartInfo.items;
                for (var index = 0; cartItems.length > 0 && cartItems.length > index; index++) {
                    _this.existingItemCount += cartItems[index].quantity;
                }
                _this.shoppingCartCount = _this.existingItemCount;
            }
            else {
                _this.existingItemCount = 0;
            }
        }, function (error) {
            new Error(error);
        });
    };
    /**
    * show success notification after updating cart items
    * createSuccessNotification()
    * @returns void
    */
    OrderEditComponent.prototype.createSuccessNotification = function (response) {
        this.memberCart = response;
        var notification = this._translatePipe.get('order.Member cart items updated successfully')['value'];
        this._commonService.createNotification('', notification, 'success');
    };
    /**
       * @description get member cart items list
       * @memberof OrderPromotionComponent
       */
    OrderEditComponent.prototype.getMemberCartItems = function () {
        if (this.orderFormGroup && this.orderFormGroup.value.orderType === this.orderType.REGULAR
            && this.shoppingBagClicked && this.memberTypeId && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId();
        }
        else {
            this.memberCart = null;
        }
    };
    /**
   * @description
   * @private
   * @memberof OrderPromotionComponent
   */
    OrderEditComponent.prototype.loadMemberShoppingCart = function (storeInfo) {
        // get Member cart items when shopping bag clicked
        if (this.orderFormGroup.value.orderType === this.orderType.REGULAR && !this.memberCartSessionGuid
            && this.shoppingBagClicked && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId();
        }
        else if (!this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.memberCart = null;
        }
        else {
            this.memberCart = null;
        }
    };
    /**
      * removing not available cart items based on logged in user
      * @param  {Cart} orderCart
      * @param  {CartItem[]} unAvailableCartItems
      */
    OrderEditComponent.prototype.deleteCart = function (sessionGuid) {
        if (sessionGuid) {
            this.shoppingCartCount = 0;
            this.itemCount = 0;
            this._customerService.removeCartItem(sessionGuid, this.storeInfo.id).subscribe(function (response) {
            });
        }
    };
    OrderEditComponent.prototype.gotoCheckout = function () {
        if (this.shoppingCartCount) {
            if (!this.memberCart) {
                if (this.memberCartInfo.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCartInfo,
                        shoppingBagClicked: true
                    });
                }
            }
            else {
                if (this.memberCart.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCart,
                        shoppingBagClicked: true
                    });
                }
            }
        }
    };
    OrderEditComponent.prototype.calculateNetUnitPrice = function (product) {
        var netUnitPrice = product.computedTaxInclusivePrice / (1 + (product.taxRate / 100));
        return Math.round((netUnitPrice + Number.EPSILON) * 100) / 100;
    };
    /**
    * @description this method will calculate shipping cost that has to be used for calculating order summary
    * @memberof OrderPromotionComponent
    */
    OrderEditComponent.prototype.getShippingCostForOrderSummary = function () {
        var shippingCost = +this.getOrderShippingCost() || 0;
        if (this.orderFormGroup.value.isShippingDiscountApplied) {
            if ((this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()
                && this.shippingCost > 0)
                || (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                    && this.orderFormGroup.controls['shippingCostPercentage'].value > 0)) {
                shippingCost = (this.memberInfo && this.memberInfo.vatRegistered || this.orderInformation.orderShippings[0] && this.orderInformation.orderShippings[0].shippingWaived ||
                    (this.appConfig.enableVatItemizationForNonVat && this.orderInformation.memberTypeId === this.memberTypeEnums.DISTRIBUTOR) ||
                    (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice)) ? (this.shippingCost || 0) : (this.shippingCost || 0) + (this.shippingTax || 0);
            }
            else if ((this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()
                && this.shippingCost === 0)
                || (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                    && this.orderFormGroup.controls['shippingCostPercentage'].value === 100)) {
                shippingCost = 0;
            }
        }
        this.itemShippingCost = shippingCost;
        return shippingCost;
    };
    /**
    * @description this method will calculate tax exclusive shipping cost
    * @memberof OrderPromotionComponent
    */
    OrderEditComponent.prototype.getTaxExclusiveShippingCost = function () {
        var shippingCost = this.shippingCost || 0;
        if (this.orderFormGroup.value.isShippingDiscountApplied) {
            if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                && this.orderFormGroup.controls['shippingCostPercentage'].value === 100) {
                shippingCost = 0;
            }
        }
        return shippingCost;
    };
    /**
    * @description this method will calculate total shipping cost that includes taxes
    * @memberof OrderPromotionComponent
    */
    OrderEditComponent.prototype.getOrderShippingCost = function () {
        if (this.appConfig) {
            if (this.memberInfo && ((this.appConfig.enableVatItemizationForNonVat &&
                this.memberInfo.memberTypeId === MemberTypeId.DISTRIBUTOR) ||
                this.memberInfo.vatRegistered || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice)) &&
                !this.appConfig.calculateShippingWithTax) {
                return this.shippingCost;
            }
            else if (this.appConfig.calculateShippingWithTax && !(this.memberInfo.vatRegistered)) {
                return this.shippingCost + this.shippingTax;
            }
            else {
                return this.shippingCost;
            }
        }
    };
    OrderEditComponent.prototype.getBankDetails = function () {
        var bankDetails = this._translateService.get(PaymentConstants.BankTransfer)['value'];
        if (bankDetails != PaymentConstants.BankTransfer) {
            for (var key in bankDetails) {
                if (key.indexOf(PaymentConstants.BankDetails) > -1) {
                    this.bankDetailsList.push(bankDetails[key]);
                }
            }
        }
    };
    /**
    *
    * @param items
    */
    OrderEditComponent.prototype.getItemTotalSum = function (item) {
        return this.calculateSubTotal(this.storeInfo, this.countryTaxInclusive, item, this.memberInfo, true);
    };
    /**
      * Get Total CartItems Cost.
    */
    OrderEditComponent.prototype.calculateSubTotal = function (store, taxInclusiveShippingCountry, item, userInfo, taxCalculated) {
        var subTotal = 0;
        if (item) {
            var isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            var isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            if (userInfo && store.taxInclusive && isEnableVATCalculation) {
                subTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(item, store, taxInclusiveShippingCountry, userInfo, taxCalculated);
            }
            else {
                subTotal += this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry, isCalculateTaxExclusivePrice);
            }
        }
        if (store) {
            // tslint:disable-next-line:no-bitwise
            subTotal = Number(subTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return subTotal;
    };
    /**
     * calculate subtotal for vat and not vat registered user
     * calculateSubtotalForVatAndNonVatRegisteredUser()
     */
    OrderEditComponent.prototype.calculateSubtotalForVatAndNonVatRegisteredUser = function (item, store, taxInclusiveShippingCountry, userInfo, taxCalculated) {
        if (!item.literature && (taxCalculated || !userInfo.vatRegistered)) {
            if (userInfo.transactionalOptin &&
                userInfo.transactionalWholesaleQualified
                && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                    || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                        && this._commonService.isWHLSAL00enabledForAsstSupervisor(store.homeIsocodeThree)))) {
                var total = Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'computedTaxInclusivePrice']);
                return (Math.round((total + Number.EPSILON) * 100) / 100) * item.quantity;
            }
            else {
                return Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'applicablePrice'].
                    // tslint:disable-next-line:no-bitwise
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
            }
        }
        else if (taxCalculated && (userInfo.vatRegistered)) {
            return Number(item.catalogPrice.
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
        else {
            return this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry);
        }
    };
    /**
    * calculate subtotal
    * calculateItemSubtotal()
    */
    OrderEditComponent.prototype.calculateItemSubtotal = function (item, store, taxInclusiveShippingCountry, isCalcTaxExclusivePrice) {
        return Number(item[(taxInclusiveShippingCountry === false || isCalcTaxExclusivePrice) ? 'catalogPrice' : 'applicablePrice'].
            // tslint:disable-next-line:no-bitwise
            toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
    };
    OrderEditComponent.prototype.buildAchForm = function () {
        var phone = '';
        var email = '';
        var checkNumber = "";
        var phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, phoneNumberFormat);
            }
            else {
                phone = this.memberInfo.phone;
            }
        }
        this.paymentAchForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            //  accountType: ['', [Validators.required]],
            dlNumber: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            dlState: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            secType: ['', [Validators.required, CustomValidator.checkIfAccountSelected()],
            ],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]],
            checkNumber: [checkNumber, [Validators.required, CustomValidators.requiredNotEmpty]],
            reuse: [false],
            billingAddressId: [''],
        });
    };
    /**
     * on change of Ach
     */
    // selectAch(achDetails: PersonalAch, isNewAch: boolean) {
    //     if (isNewAch) {
    //         this.buildAchForm();
    //         this.echeckSubmitted = false;
    //         this.eCheckValidationMessages = [];
    //         this.achPaymentPopup.open();
    //        this.addNewAch = true;
    //     } else {
    //         this.selectedAchInfo = achDetails;
    //         this.billingAddressInfo = achDetails.billingAddress;
    //         this.addNewAch = false;
    //         if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
    //             this.paymentFormBtn.nativeElement.focus();
    //         }
    //     }
    //  }
    /**
    * Get ACH payment
    */
    // getSavedAchs(): void {
    //     const memberId = this.getUserMemberId();
    //     if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
    //         this._achService.getSavedAchs(memberId, this.selectedIsoCountryCode, PaymentMethodTypeConstants.Ach, this.achToken)
    //             .subscribe((response: PersonalAch[]) => {
    //                 if (response && response.length) {
    //                     this.paymentComponentSettings.savedAchs = response;
    //                     this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedAchs[0].id);
    //                     if (this.achRequest && this.achRequest.reusable) {
    //                         const selectedCard = this.paymentComponentSettings.savedAchs.find(x => x.id === this.achRequest.id);
    //                         if (selectedCard) {
    //                             const indexPostion = this.paymentComponentSettings.savedAchs
    //                                 .findIndex(x => x.id === this.achRequest.id);
    //                             this.paymentComponentSettings.savedAchs.splice(indexPostion, 1);
    //                             this.paymentComponentSettings.savedAchs.unshift(selectedCard);
    //                             this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedAchs[0].id);
    //                         } else {
    //                             const index = this.paymentComponentSettings.savedAchs.length - 1;
    //                             this.orderFormGroup.controls['paymentInstrumentId']
    //                                 .setValue(this.paymentComponentSettings.savedAchs[index].id);
    //                         }
    //                         const index = this.paymentComponentSettings.savedAchs.length - 1;
    //                          this.selectAch(this.paymentComponentSettings.savedAchs[index],false);
    //                     } else {
    //                         const index = this.paymentComponentSettings.savedAchs.length - 1;
    //                         this.selectAch(this.paymentComponentSettings.savedAchs[index],false);
    //                     }
    //                     this.savedAch = JSON.stringify(this.paymentComponentSettings.savedAchs);
    //                 }
    //             });
    //     }
    // }
    // getUserMemberId() {
    //     let memberId = null;
    //     if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
    //       memberId = this.accountMemberInfo.memberId;
    //     } else
    //         memberId = 0
    //     return memberId;
    //   }
    /**
   * @description submit ach payment information
   * @memberof ACHComponent
   */
    //   submitAchPaymentInformation(achPaymentInfo) {
    //      if(achPaymentInfo){
    //         this.achPaymentInfo = achPaymentInfo;
    //         this.achToken=this.achPaymentInfo.personalCheckId;
    //         this.getSavedAchs();
    //         this.achPaymentPopup.close();
    //    }
    // }
    // onPaymentAchFormClose() {
    //     this.achPaymentPopup.close();
    // }
    /**
    * map Ach Info for payment
    */
    //     getAchInfo() {
    //         this.achPaymentInfo=this.achPaymentInfo?this.achPaymentInfo:this.selectedAchInfo;
    //         if(this.achPaymentInfo){
    //           const paymentAchInfo = {
    //               bankName: this.achPaymentInfo.bankName,
    //               accountNumber: this.achPaymentInfo.accountNumber,
    //               routingNumber: this.achPaymentInfo.routingNumber,
    //               accountType: this.achPaymentInfo.accountType,
    //               mecTransactionID: '',
    //               nameOnBankAccount: this.achPaymentInfo.nameOnBankAccount,
    //               customMessage: '',
    //               reusable: this.achPaymentInfo.reusable,
    //               eCheckID:  this.achPaymentInfo.id,
    //               email: this.achPaymentInfo.email,
    //               phone: this.achPaymentInfo.phone,
    //               secType:this.achPaymentInfo.secType,
    //               dlState:this.achPaymentInfo.dlState,
    //               dlNumber:this.achPaymentInfo.dlNumber,
    //               checkNumber:this.achPaymentInfo.checkNumber,
    //           };
    //           return paymentAchInfo;
    //       }
    //   }
    /**
   * @description To get the list of bank details from payment service based on country
   * @date 2021-01-07
   * @param {*} countryCode
   * @memberof OrderEditComponent
   */
    OrderEditComponent.prototype.getBankDetailsByCountry = function (countryCode, paymentMethod) {
        var _this = this;
        this._achService.getBankDetailsByCountry(countryCode, paymentMethod).subscribe(function (response) {
            if (response && response.length > 0) {
                if (paymentMethod && PaymentMethodTypes.Wire_Transfer.toLowerCase() === paymentMethod.toLowerCase()) {
                    _this.bankDetailsCountryList = response.filter(function (bankDetail) { return bankDetail.paymentMode.toLowerCase() == PaymentMethodTypes.Wire_Transfer.toLowerCase(); });
                }
                else {
                    _this.bankDetailsCountryList = response;
                }
            }
            else {
                _this.bankDetailsCountryList = [];
            }
        });
    };
    OrderEditComponent.prototype.checkLoadedProducts = function (productsIds, response) {
        if (response && response.length) {
            var responseProductIds_1 = [];
            responseProductIds_1 = response.map(function (product) { return product.id; });
            if (this.isEditOrder) {
                this.prepareProductModel(productsIds, response);
            }
            else {
                var resultIds = productsIds.filter(function (item) { return responseProductIds_1.indexOf(item) === -1; });
                this.prepareProductModel(resultIds);
                this.loadproducts(response);
            }
        }
        else {
            this.prepareProductModel(productsIds);
        }
        this.getDepositFeeProduct(productsIds);
    };
    OrderEditComponent.prototype.prepareProductModel = function (idList, response) {
        var _this = this;
        if (idList && idList.length > 0) {
            var bwpEnableProduct_1;
            var products_1 = [];
            idList.forEach(function (id) {
                var lineItem = _this.orderInformation.orderLineItems.find(function (item) { return item.productId === id; });
                var productResponse = response && response.find(function (product) { return product.id === id; });
                bwpEnableProduct_1 = productResponse && productResponse.productMetaData.find(function (product) { return product.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && product.metaKeyWords === '1'; });
                var product = {
                    itemNumber: lineItem.itemNumber,
                    name: lineItem.productName,
                    id: lineItem.productId,
                    retailPrice: lineItem.unitRetailPrice,
                    baseRetailPrice: lineItem.unitRetailPrice,
                    applicablePrice: lineItem.unitPaidPrice,
                    catalogPrice: lineItem.unitPaidPrice,
                    computedTaxInclusivePrice: lineItem.unitPaidPrice,
                    baseWholesalePrice: lineItem.unitWholeSalePrice,
                    wholesalePrice: lineItem.unitWholeSalePrice,
                    unitBaseWholeSalePrice: lineItem.baseWholesalePrice,
                    taxRate: lineItem.taxRate,
                    discountPercentage: lineItem.discountPercentage,
                    literature: lineItem.literature,
                    importedMeasurementUnit: lineItem.importedMeasurementUnit,
                    revisionNumber: lineItem.revisionNumber,
                    commissionableVolume: lineItem.unitQualificationValue,
                    downloadableProduct: lineItem.downloadActivated,
                    shipping: {
                        height: lineItem.height,
                        weight: lineItem.weight,
                        length: lineItem.length,
                        width: lineItem.width,
                        shippingRequired: lineItem.shippable,
                        shippableFulfillment: lineItem.shippableFulfillment
                    },
                    stockAvailable: productResponse ? productResponse.stockAvailable : null,
                    manageStock: productResponse ? productResponse.manageStock : null,
                    stockQuantity: productResponse ? productResponse.stockQuantity : null,
                    bwpEnableProduct: bwpEnableProduct_1,
                    productMetaData: [{
                            metaTitle: ProductMetatDataValue.DISTRIBUTORELIGIBLE,
                            metaKeyWords: lineItem.fboEligible ? lineItem.fboEligible : false
                        },
                        {
                            metaTitle: ProductMetatDataValue.DEPOSIT_FEE_ENABLED,
                            metaKeyWords: productResponse && productResponse.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; }) ? true : false
                        },
                        {
                            metaTitle: ProductMetatDataValue.DEPOSIT_FEE_PRODUCT,
                            metaKeyWords: productResponse.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1'; }) ? true : false
                        }],
                    priceTierName: _this.orderInformation.priceTierName,
                    imageModelList: response && response.length ? _this.prepareProductImageModel(lineItem.productId, response) : [],
                    comboBOMEnabledProduct: productResponse.display ? (productResponse.display.comboBOMEnabled ? true : false) : false
                };
                products_1.push(product);
            });
            this.loadproducts(products_1, true);
        }
    };
    OrderEditComponent.prototype.prepareProductImageModel = function (productId, response) {
        var productDetails = response.find(function (product) { return product.id === productId; });
        if (productDetails && productDetails.imageModelList && productDetails.imageModelList.length) {
            return productDetails.imageModelList;
        }
        else {
            return [];
        }
    };
    /**
     * @description Method to search address based on name
     * @date 2021-04-21
     * @memberof OrderEditComponent
     */
    OrderEditComponent.prototype.searchShippingAddress = function (event) {
        this.addressSearchResult = this._commonService.searchShippingAddress(event, this.memberAddressDetails);
    };
    /**
    * To Get Promotions based on store
    */
    OrderEditComponent.prototype.getStorePromotions = function (memberTypeID) {
        var _this = this;
        if (this.storeInfo && this.storeInfo.languages && this.orderInformation) {
            var result = void 0;
            var cultureName_1 = this.orderInformation.languageCulture;
            if (cultureName_1) {
                this.storeLanguageCultureId = this.storeInfo.languages.find(function (languageCulture) { return languageCulture.cultureName.toLowerCase() == cultureName_1.toLowerCase(); }).cultureId;
            }
        }
        this.promotionModels = [];
        var promotionrequest = {
            memberType: memberTypeID,
            orderType: PromotionOrderType.SHOP,
            memberLevel: this.memberInfo.memberTitleId,
            isTaxInclusive: this.countryTaxInclusive,
            languageSetting: this.storeLanguageCultureId ? this.storeLanguageCultureId : null
        };
        this._commonService.getPromotionEngineConfigurations(this.storeId, promotionrequest).subscribe(function (response) {
            if (response && response.promotionModelList && response.promotionModelList.length > 0) {
                _this.promotionModels = response.promotionModelList;
            }
            else {
                _this.promotionModels = [];
            }
        }, function (error) {
            _this.promotionModels = [];
        });
    };
    OrderEditComponent.prototype.getStoreMetaData = function (storeId) {
        var _this = this;
        this._commonService.getStoreMetaData(storeId)
            .subscribe(function (storeMetaData) {
            _this.storeMetadata = storeMetaData;
            if (_this.storeInfo && _this.storeMetadata && _this.storeMetadata.length > 0) {
                var hasOrderUpdatePermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.ORDER_STATUS_UPDATE + "]"), AccessLevel.Store, _this.storeInfo ? _this.storeInfo.id : null);
                _this.hasServiceOrderUpdatePermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + _this.ServiceOrderPermissions[1] + "]"), AccessLevel.Customer_Service);
                var hasServiceOrderUpdatePermissions = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.REPLACEMENT_ORDER_STATUS_UPDATE + "]"), AccessLevel.Customer_Service);
                var orderStatusUpdateAttribute = _this.storeMetadata.find(function (x) { return (x.attribute &&
                    (x.attribute.toLowerCase() === (StoreMetaDataConstants.ENABLE_ORDER_STATUS_UPDATE.toLowerCase() || StoreMetaDataConstants.ENABLE_SERVICE_ORDER.toLowerCase()))); });
                var storeOrderUpdateFeatureEnabled = orderStatusUpdateAttribute && orderStatusUpdateAttribute.metaDataValue && orderStatusUpdateAttribute.metaDataValue === 'true' ? true : false;
                _this.hasManageOrderUpdatePermission = (hasOrderUpdatePermission || hasServiceOrderUpdatePermissions) && storeOrderUpdateFeatureEnabled;
                var isPickupOrder = _this.orderInformation.orderShippings[0].deliveryPreferenceId === ShippingType.PICKUP ? true : false;
                _this.isOrderStatusUpdateEnableStatus = (_this.hasManageOrderUpdatePermission || (_this.hasServiceOrderUpdatePermission && isPickupOrder)) && _this.orderInformation && _this.isEditOrder && (_this.orderStatusId.Processing == _this.orderInformation.orderStatusId || _this.orderStatusId.Shipped == _this.orderInformation.orderStatusId || _this.orderStatusId.Ready_For_Pickup == _this.orderInformation.orderStatusId) && _this.orderInformation.orderPayments.length > 0 && _this.paymentStatusEnum.PEND !== _this.orderInformation.orderPayments[0].paymentStatusId ? true : false;
                if (_this.isOrderStatusUpdateEnableStatus) {
                    _this.orderFormGroup.controls['shippedOrderStatus'].setValidators(Validators.required);
                }
            }
        });
    };
    OrderEditComponent.prototype.mapShippingAddress = function () {
        if (this.shippingAddressInfo) {
            this.paymentComponentSettings.shippingAddressDetail = this.shippingAddressInfo;
        }
    };
    OrderEditComponent.prototype.getDepositFeeProduct = function (productsIds) {
        var _this = this;
        var depositFeeProducts = null;
        var purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, this.memberInfo.wholeSaleQualified, this.appConfig.fpc5PercentEnabled, false, this.memberInfo.memberTitleId);
        var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        this._customerService.getRelatedProductList(this.storeId, productsIds, 2, this.memberInfo.memberTitleId, this.countryCode, purchaseFlowType, this.storeInfo.taxInclusive, wholesaleQualified, optin)
            .subscribe(function (response) {
            if (response && response.length) {
                depositFeeProducts = response;
                depositFeeProducts.forEach(function (product) {
                    productsIds.forEach(function (productId) {
                        var depsoitFeeProductDetail = depositFeeProducts.find(function (x) { return x.associateProductId == productId; });
                        if (depsoitFeeProductDetail && product.id == depsoitFeeProductDetail.id) {
                            var productAssociation = _this.productAssociationInfo.find(function (x) { return x.productId === productId && x.depositFeeProductId === product.id; });
                            if (!productAssociation) {
                                _this.productAssociationInfo.push({
                                    productId: productId,
                                    depositFeeProductId: product.id
                                });
                            }
                        }
                    });
                });
            }
        });
    };
    OrderEditComponent.prototype.buildPudoLocationSearchForm = function (zipCode, city, addressLine1, country, externalId) {
        this.pudoLocationSearchForm = this._formbuilder.group({
            zipCode: [zipCode, [Validators.required, this.getZipCodePatterns()]],
            externalId: [externalId],
            city: [city, [Validators.required]],
            country: [country],
            addressLine1: [addressLine1]
        });
        var countryCode = this.selectedIsoCountryCode || '';
        this.pudoLocationSearchForm.patchValue({
            country: countryCode.toUpperCase()
        });
    };
    OrderEditComponent.prototype.getZipCodePatterns = function () {
        var _this = this;
        this._commonService.getZipCodePatterns().subscribe(function (response) {
            var zipCodePatterns = response;
            var pattern = zipCodePatterns.filter(function (x) { return x.isoCodeThree
                === _this.selectedIsoCountryCode; });
            _this.zipPattern = pattern ? pattern.zipPattern : null;
        });
        return Validators.pattern(new RegExp(this.zipPattern));
    };
    OrderEditComponent.prototype.getPudoDropShipPersonAddress = function (collectionPoint) {
        var address = collectionPoint;
        var dropShipAddress;
        if (collectionPoint) {
            dropShipAddress = {
                addressLine1: address.street ? collectionPoint.street : this.pudoShippingAddressInfo.addressLine1,
                addressLine2: address.address2,
                addressLine3: address.address3,
                city: address.city,
                state: collectionPoint.state,
                stateCode: this.pudoShippingAddressInfo.stateCode || null,
                countryCode: this.selectedIsoCountryCode,
                country: collectionPoint.country || this.selectedIsoCountryCode,
                postalCode: this.pudoShippingAddressInfo.postalCode || null,
                zipCode: address.zipCode,
                countryId: this.pudoShippingAddressInfo.countryId,
                stateId: this.pudoShippingAddressInfo.stateId,
                externalId: address.externalId,
                name: address.name ? this.storeInfo.warehouseAddress.name : null
            };
            this.pudoAddress = dropShipAddress;
            this.messageService.setPudoPersonAddress(true);
            this.dropShipAddress = dropShipAddress;
            return this.dropShipAddress;
        }
        else if (this.dropLoactionSelected) {
            return this.dropShipAddress;
        }
        else if (this.orderSession && this.orderSession.pudoaddress) {
            return this.orderSession.pudoaddress;
        }
        else {
            return;
        }
    };
    OrderEditComponent.prototype.addNewDropshipPersonAddress = function () {
        var _this = this;
        this.pudoShippingAddressInfo = null;
        this.showDropShipPersonAddressForm = true;
        setTimeout(function () {
            _this.displayDropAddress = true;
        }, 100);
    };
    OrderEditComponent.prototype.savePudoShippingAddress = function (address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        }
        else if (this.pudoAddress && this.pudoAddress.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.pudoShippingAddressInfo = address;
        this.pudoAddress = address;
        this.pudoAddressSubmitted = true;
    };
    OrderEditComponent.prototype.getAddressIsValid = function (isValid) {
        //  this.formPickupPersonAddressValid = isValid;
        //this.pudoLocationsNotFound = false;
    };
    OrderEditComponent.prototype.pudoAddressInputChange = function (address) {
        if (this.formPickupPersonAddressValid) {
            this.pudoAddress = address;
            this.pudoCollectionPoints = null;
            this.hidePudoPickupLocationsButton = true;
            this.pudoLocationsNotFound = false;
            if (this.pudoAddress) {
                this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1, this.pudoAddress.externalId);
            }
        }
    };
    OrderEditComponent.prototype.clearPudoLocationSearchForm = function () {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = false;
        this.buildPudoLocationSearchForm();
    };
    OrderEditComponent.prototype.getPudoLocations = function () {
        var _this = this;
        var pudoLocationRequest = this.preparePudoLocationRequest();
        if (pudoLocationRequest) {
            this.pudoLocationsNotFound = false;
            this.pudoCollectionPoints = null;
            this.selectedPudoCollectionPoint = null;
            this.loadingPudoPickupLocations = true;
            this._orderService.getPudoLocations(pudoLocationRequest).subscribe(function (res) {
                _this.loadingPudoPickupLocations = false;
                if (res && res.collectionPoints && res.collectionPoints.length) {
                    _this.pudoLocationsNotFound = false;
                    res.collectionPoints.sort(function (x, y) { return x.distance - y.distance; });
                    _this.pudoCollectionPoints = res.collectionPoints;
                    _this.calculateOrderTax();
                    _this.prepareBusinessHours();
                    if (_this.pudoLocationSearchForm && _this.pudoLocationSearchForm.value && _this.pudoLocationSearchForm.value.externalId) {
                        _this.selectedPudoCollectionPoint = _this.pudoCollectionPoints.find(function (x) { return x.externalId == _this.pudoLocationSearchForm.value.externalId; });
                        _this.selectPudoCollectionPoint(_this.selectedPudoCollectionPoint);
                    }
                }
                else {
                    _this.pudoLocationsNotFound = true;
                }
            }, function (error) {
                _this.loadingPudoPickupLocations = false;
                _this.pudoLocationsNotFound = true;
            });
        }
    };
    OrderEditComponent.prototype.preparePudoLocationRequest = function () {
        var _this = this;
        if (!this.countries) {
            this.countries = this._cacheService.get(CacheKey.COUNTRIES);
        }
        var request = null;
        if (this.pudoLocationSearchForm) {
            var pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
            if (this.pudoAddress) {
                this.pudoAddress.zip = this.pudoAddress.zip ? this.pudoAddress.zip : this.pudoAddress.postalCode;
            }
            if (pudoLocationSearchFormData && pudoLocationSearchFormData.zipCode ? true : this.pudoAddress && this.pudoAddress.zip) {
                if (!pudoLocationSearchFormData.zipCode) {
                    this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
                }
                pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
                if (this.countries && pudoLocationSearchFormData.zipCode) {
                    var country = this.countries.find(function (x) { return x.isocodeThree.toUpperCase() === _this.storeInfo.homeIsocodeThree.toUpperCase(); });
                    request = {
                        countryIsoCode: pudoLocationSearchFormData.country || '',
                        postalCode: pudoLocationSearchFormData.zipCode || '',
                        storeID: this.storeInfo && this.storeInfo.id || null,
                        city: pudoLocationSearchFormData.city || '.',
                        streetAddress: pudoLocationSearchFormData.addressLine1 || '',
                        languageCode: "en",
                    };
                }
            }
        }
        else {
            if (this.pudoShippingAddressInfo) {
                request = {
                    countryIsoCode: this.pudoShippingAddressInfo.countryCode || '',
                    postalCode: this.pudoShippingAddressInfo.postalCode || '',
                    storeID: this.orderInformation && this.orderInformation.storeId || null,
                    city: this.pudoShippingAddressInfo.city || '.',
                    streetAddress: this.pudoShippingAddressInfo.addressLine1 || '',
                    languageCode: "en",
                };
            }
            this.buildPudoLocationSearchForm();
        }
        return request;
    };
    OrderEditComponent.prototype.prepareBusinessHours = function () {
        if (this.pudoCollectionPoints && this.pudoCollectionPoints.length) {
            this.pudoCollectionPoints.forEach(function (collectionPoint) {
                if (collectionPoint && collectionPoint.openingHours) {
                    var businessHours_1 = [];
                    collectionPoint.openingHours.forEach(function (opening) {
                        if (opening && opening.hours) {
                            var hours_1 = [];
                            opening.hours.forEach(function (hour) {
                                hours_1.push({ start: hour.opens, end: hour.closes });
                            });
                            var businessHour = {
                                available: true,
                                day: opening.dayText,
                                hours: hours_1
                            };
                            businessHours_1.push(businessHour);
                        }
                    });
                    collectionPoint.businessHours = businessHours_1;
                }
            });
        }
    };
    OrderEditComponent.prototype.loadPUDOLocations = function () {
        if (!this.skipAddressVerification) {
            this.messageService.setSubmitPudoPickupPersonAddress(true);
        }
        else {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                this.messageService.setSubmitPudoDropShipPersonAddress(true);
            }
            this.getPudoLocations();
        }
    };
    OrderEditComponent.prototype.getPudoLocationMap = function (geoPoint) {
        if (geoPoint && geoPoint.latitude && geoPoint.longitude) {
            if (environment.restrictGoogleMapNavigation) {
                return ApiUrlConstants.googleMapsUrl + geoPoint.latitude +
                    ',' + geoPoint.longitude;
            }
            else {
                return null;
            }
        }
        return null;
    };
    OrderEditComponent.prototype.selectPudoCollectionPoint = function (collectionPoint) {
        this.dropShipAddress = null;
        this.selectedPudoCollectionPoint = collectionPoint;
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.getPudoDropShipPersonAddress(collectionPoint);
            this.dropLoactionSelected = true;
            this.getShipMethods();
        }
        this.dropLoactionSelected = false;
        this.calculateOrderTax();
    };
    OrderEditComponent.prototype.getPudoDropAddress = function (address, shippingMethod) {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled &&
            this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            var pudoCollectionPoint = this.selectedPudoCollectionPoint ? this.selectedPudoCollectionPoint : this.dropShipAddress ? this.dropShipAddress : address;
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoAddress.stateCode);
            var pudoDropShipAddress = {
                addressLine1: this.selectedPudoCollectionPoint ? (pudoCollectionPoint.street + ' ' + pudoCollectionPoint.houseNumber) :
                    pudoCollectionPoint.addressLine1 ? pudoCollectionPoint.addressLine1 : address.addressLine1,
                addressLine2: this.selectedPudoCollectionPoint ? pudoCollectionPoint.address2 : pudoCollectionPoint.addressLine2,
                addressLine3: this.selectedPudoCollectionPoint ? pudoCollectionPoint.address3 : pudoCollectionPoint.addressLine3,
                addressLine4: null,
                city: pudoCollectionPoint.city || address.city,
                state: pudoCollectionPoint.state || address.state,
                stateCode: address.stateCode || pudoCollectionPoint.stateCode,
                countryCode: address.countryCode,
                country: countryObj.name,
                county: null,
                zip: pudoCollectionPoint.zipCode || address.zipCode,
                company: null,
                firstName: address.firstName,
                lastName: address.lastName,
                phoneNumer: address.phoneNumber,
                email: address.email,
                name: pudoCollectionPoint.name || address.name,
                instruction: '',
                optionName: DelivaryOptionType.Dropship,
                pickUpCenterId: shippingMethod && shippingMethod.pickUpLocation &&
                    shippingMethod.pickUpLocation.pickUpCenterId ? shippingMethod.pickUpLocation.pickUpCenterId : null,
                latitude: this.selectedPudoCollectionPoint ? pudoCollectionPoint.geoPoint.latitude + '' : '',
                longitude: this.selectedPudoCollectionPoint ? pudoCollectionPoint.geoPoint.longitude + '' : '',
                countryId: countryObj.countryId,
                stateId: stateObj.id,
                businessInformation: [],
                residential: false,
                validAddress: false,
                addressType: AddressType.PUDO,
                postalCode: pudoCollectionPoint.postalCode || address.postalCode,
                pudoNetwork: pudoCollectionPoint.network,
                pudoExternalId: pudoCollectionPoint.externalId,
                pudoIdentifier: pudoCollectionPoint.identifier
            };
            return pudoDropShipAddress;
        }
    };
    OrderEditComponent.prototype.getMembergovernmentIdentificationsInfo = function (memberId) {
        var _this = this;
        if (memberId) {
            this._customerService.getMembergovernment_identifications(memberId).subscribe(function (response) {
                if (response) {
                    _this.memberInfo.memberGovernmentIdentifications = response.memberGovernmentIdentificationModel;
                    _this.memberInfo.vatDetailModel = response.vatDetailModel;
                }
                if (_this.selectedIsoCountryCode) {
                    var countryObj = _this.countries.filter(function (x) { return x.isocodeThree === _this.selectedIsoCountryCode; })[0];
                    _this.memberInfo.vatRegistered = _this._commonService.getVatDetail(countryObj, _this.memberInfo);
                }
            });
        }
    };
    OrderEditComponent.prototype.buildPayByLinkForm = function () {
        this.emailForm = this._formbuilder.group({
            payByLinkEmail: ['', [Validators.required]]
        });
    };
    OrderEditComponent.prototype.emailCheck = function () {
        if (this.emailForm.controls['payByLinkEmail'].value !== '' && this.emailForm.controls['payByLinkEmail'].valid) {
            this.isPayByLinkValid = true;
        }
        else {
            this.isPayByLinkValid = false;
        }
    };
    OrderEditComponent.prototype.getDropShipPudoShippingMethods = function (shippingOptions, shippingMethods, mappingRequired) {
        var _this = this;
        if (mappingRequired === void 0) { mappingRequired = true; }
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist)) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                }
            }
            else {
                shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
            }
            shippingOptions.shippingTypeId = ShippingType.DELIVERY;
            this._orderService.getShipmentService(shippingOptions).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    // Testing Purpose .
                    //response.shippingMethods[0].pudoEnabled = true;
                    _this.dropshipPudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                    if (mappingRequired) {
                        if (_this.dropshipPudoShippingMethod) {
                            _this.dropshipPudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                    }
                }
            }, function (error) {
            });
        }
    };
    return OrderEditComponent;
}());
export { OrderEditComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/orders/order-edit.component.ts.pre-build-optimizer.js